"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RMF API Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FleetsApiFactory = exports.FleetsApiFp = exports.FleetsApiAxiosParamCreator = exports.DoorsApi = exports.DoorsApiFactory = exports.DoorsApiFp = exports.DoorsApiAxiosParamCreator = exports.DispensersApi = exports.DispensersApiFactory = exports.DispensersApiFp = exports.DispensersApiAxiosParamCreator = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.BuildingApi = exports.BuildingApiFactory = exports.BuildingApiFp = exports.BuildingApiAxiosParamCreator = exports.BeaconsApi = exports.BeaconsApiFactory = exports.BeaconsApiFp = exports.BeaconsApiAxiosParamCreator = exports.AlertsApi = exports.AlertsApiFactory = exports.AlertsApiFp = exports.AlertsApiAxiosParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = exports.UndoPhaseSkipRequestTypeEnum = exports.Tier = exports.TaskRewindRequestTypeEnum = exports.TaskResumeRequestTypeEnum = exports.TaskPhaseSkipRequestTypeEnum = exports.TaskKillRequestTypeEnum = exports.TaskInterruptionRequestTypeEnum = exports.TaskDispatchResponseItem1SuccessEnum = exports.TaskDispatchResponseItemSuccessEnum = exports.TaskDispatchResponseSuccessEnum = exports.TaskDiscoveryRequestTypeEnum = exports.TaskDiscoveryTypeEnum = exports.Status2 = exports.Status1 = exports.Status = exports.RobotTaskResponseSuccessEnum = exports.DispatchTaskRequestTypeEnum = exports.CancelTaskRequestTypeEnum = exports.ActivityDiscoveryRequestTypeEnum = void 0;
exports.TasksApi = exports.TasksApiFactory = exports.TasksApiFp = exports.TasksApiAxiosParamCreator = exports.SchedulerApi = exports.SchedulerApiFactory = exports.SchedulerApiFp = exports.SchedulerApiAxiosParamCreator = exports.NotificationApi = exports.NotificationApiFactory = exports.NotificationApiFp = exports.NotificationApiAxiosParamCreator = exports.LiftsApi = exports.LiftsApiFactory = exports.LiftsApiFp = exports.LiftsApiAxiosParamCreator = exports.IngestorsApi = exports.IngestorsApiFactory = exports.IngestorsApiFp = exports.IngestorsApiAxiosParamCreator = exports.FleetsApi = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.ActivityDiscoveryRequestTypeEnum = {
    ActivitiyDiscoveryRequest: 'activitiy_discovery_request',
};
exports.CancelTaskRequestTypeEnum = {
    CancelTaskRequest: 'cancel_task_request',
};
exports.DispatchTaskRequestTypeEnum = {
    DispatchTaskRequest: 'dispatch_task_request',
};
exports.RobotTaskResponseSuccessEnum = {
    False: false,
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.Status = {
    Uninitialized: 'uninitialized',
    Blocked: 'blocked',
    Error: 'error',
    Failed: 'failed',
    Queued: 'queued',
    Standby: 'standby',
    Underway: 'underway',
    Delayed: 'delayed',
    Skipped: 'skipped',
    Canceled: 'canceled',
    Killed: 'killed',
    Completed: 'completed',
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.Status1 = {
    Queued: 'queued',
    Selected: 'selected',
    Dispatched: 'dispatched',
    FailedToAssign: 'failed_to_assign',
    CanceledInFlight: 'canceled_in_flight',
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.Status2 = {
    Uninitialized: 'uninitialized',
    Offline: 'offline',
    Shutdown: 'shutdown',
    Idle: 'idle',
    Charging: 'charging',
    Working: 'working',
    Error: 'error',
};
exports.TaskDiscoveryTypeEnum = {
    TaskDiscoveryUpdate: 'task_discovery_update',
};
exports.TaskDiscoveryRequestTypeEnum = {
    TaskDiscoveryRequest: 'task_discovery_request',
};
exports.TaskDispatchResponseSuccessEnum = {
    False: false,
};
exports.TaskDispatchResponseItemSuccessEnum = {
    True: true,
};
exports.TaskDispatchResponseItem1SuccessEnum = {
    False: false,
};
exports.TaskInterruptionRequestTypeEnum = {
    InterruptTaskRequest: 'interrupt_task_request',
};
exports.TaskKillRequestTypeEnum = {
    KillTaskRequest: 'kill_task_request',
};
exports.TaskPhaseSkipRequestTypeEnum = {
    SkipPhaseRequest: 'skip_phase_request',
};
exports.TaskResumeRequestTypeEnum = {
    ResumeTaskRequest: 'resume_task_request',
};
exports.TaskRewindRequestTypeEnum = {
    RewindTaskRequest: 'rewind_task_request',
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.Tier = {
    Uninitialized: 'uninitialized',
    Info: 'info',
    Warning: 'warning',
    Error: 'error',
};
exports.UndoPhaseSkipRequestTypeEnum = {
    UndoPhaseSkipRequest: 'undo_phase_skip_request',
};
/**
 * AdminApi - axios parameter creator
 * @export
 */
var AdminApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Add a permission to a role
         * @summary Add Role Permission
         * @param {string} role
         * @param {Permission} permission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRolePermissionAdminRolesRolePermissionsPost: function (role, permission, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'role' is not null or undefined
                    (0, common_1.assertParamExists)('addRolePermissionAdminRolesRolePermissionsPost', 'role', role);
                    // verify required parameter 'permission' is not null or undefined
                    (0, common_1.assertParamExists)('addRolePermissionAdminRolesRolePermissionsPost', 'permission', permission);
                    localVarPath = "/admin/roles/{role}/permissions".replace("{" + 'role' + "}", encodeURIComponent(String(role)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(permission, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Add role to a user
         * @summary Add User Role
         * @param {string} username
         * @param {PostRoles} postRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserRoleAdminUsersUsernameRolesPost: function (username, postRoles, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'username' is not null or undefined
                    (0, common_1.assertParamExists)('addUserRoleAdminUsersUsernameRolesPost', 'username', username);
                    // verify required parameter 'postRoles' is not null or undefined
                    (0, common_1.assertParamExists)('addUserRoleAdminUsersUsernameRolesPost', 'postRoles', postRoles);
                    localVarPath = "/admin/users/{username}/roles".replace("{" + 'username' + "}", encodeURIComponent(String(username)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postRoles, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create a new role
         * @summary Create Role
         * @param {PostRoles} postRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoleAdminRolesPost: function (postRoles, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'postRoles' is not null or undefined
                    (0, common_1.assertParamExists)('createRoleAdminRolesPost', 'postRoles', postRoles);
                    localVarPath = "/admin/roles";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postRoles, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create a user
         * @summary Create User
         * @param {PostUsers} postUsers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAdminUsersPost: function (postUsers, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'postUsers' is not null or undefined
                    (0, common_1.assertParamExists)('createUserAdminUsersPost', 'postUsers', postUsers);
                    localVarPath = "/admin/users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postUsers, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete a role
         * @summary Delete Role
         * @param {string} role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoleAdminRolesRoleDelete: function (role, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'role' is not null or undefined
                    (0, common_1.assertParamExists)('deleteRoleAdminRolesRoleDelete', 'role', role);
                    localVarPath = "/admin/roles/{role}".replace("{" + 'role' + "}", encodeURIComponent(String(role)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete a user  This only performs a soft delete, while the user is deleted from the app database, it still exists in the idp so they can still log in, the user will then be re-created with the default permissions.
         * @summary Delete User
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAdminUsersUsernameDelete: function (username, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'username' is not null or undefined
                    (0, common_1.assertParamExists)('deleteUserAdminUsersUsernameDelete', 'username', username);
                    localVarPath = "/admin/users/{username}".replace("{" + 'username' + "}", encodeURIComponent(String(username)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Remove role from a user
         * @summary Delete User Role
         * @param {string} username
         * @param {string} role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserRoleAdminUsersUsernameRolesRoleDelete: function (username, role, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'username' is not null or undefined
                    (0, common_1.assertParamExists)('deleteUserRoleAdminUsersUsernameRolesRoleDelete', 'username', username);
                    // verify required parameter 'role' is not null or undefined
                    (0, common_1.assertParamExists)('deleteUserRoleAdminUsersUsernameRolesRoleDelete', 'role', role);
                    localVarPath = "/admin/users/{username}/roles/{role}"
                        .replace("{" + 'username' + "}", encodeURIComponent(String(username)))
                        .replace("{" + 'role' + "}", encodeURIComponent(String(role)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all permissions of a role
         * @summary Get Role Permissions
         * @param {string} role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolePermissionsAdminRolesRolePermissionsGet: function (role, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'role' is not null or undefined
                    (0, common_1.assertParamExists)('getRolePermissionsAdminRolesRolePermissionsGet', 'role', role);
                    localVarPath = "/admin/roles/{role}/permissions".replace("{" + 'role' + "}", encodeURIComponent(String(role)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all roles
         * @summary Get Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesAdminRolesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/roles";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get a user
         * @summary Get User
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAdminUsersUsernameGet: function (username, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'username' is not null or undefined
                    (0, common_1.assertParamExists)('getUserAdminUsersUsernameGet', 'username', username);
                    localVarPath = "/admin/users/{username}".replace("{" + 'username' + "}", encodeURIComponent(String(username)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Search users
         * @summary Get Users
         * @param {string} [username] filters username that starts with the value
         * @param {boolean} [isAdmin]
         * @param {number} [limit] defaults to 100
         * @param {number} [offset] defaults to 0
         * @param {string} [orderBy] common separated list of fields to order by, prefix with \&#39;-\&#39; to sort descendingly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersAdminUsersGet: function (username, isAdmin, limit, offset, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (username !== undefined) {
                        localVarQueryParameter['username'] = username;
                    }
                    if (isAdmin !== undefined) {
                        localVarQueryParameter['is_admin'] = isAdmin;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['order_by'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Make or remove admin privilege from a user
         * @summary Make Admin
         * @param {string} username
         * @param {PostMakeAdmin} postMakeAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeAdminAdminUsersUsernameMakeAdminPost: function (username, postMakeAdmin, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'username' is not null or undefined
                    (0, common_1.assertParamExists)('makeAdminAdminUsersUsernameMakeAdminPost', 'username', username);
                    // verify required parameter 'postMakeAdmin' is not null or undefined
                    (0, common_1.assertParamExists)('makeAdminAdminUsersUsernameMakeAdminPost', 'postMakeAdmin', postMakeAdmin);
                    localVarPath = "/admin/users/{username}/make_admin".replace("{" + 'username' + "}", encodeURIComponent(String(username)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postMakeAdmin, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete a permission from a role
         * @summary Remove Role Permission
         * @param {string} role
         * @param {Permission} permission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRolePermissionAdminRolesRolePermissionsRemovePost: function (role, permission, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'role' is not null or undefined
                    (0, common_1.assertParamExists)('removeRolePermissionAdminRolesRolePermissionsRemovePost', 'role', role);
                    // verify required parameter 'permission' is not null or undefined
                    (0, common_1.assertParamExists)('removeRolePermissionAdminRolesRolePermissionsRemovePost', 'permission', permission);
                    localVarPath = "/admin/roles/{role}/permissions/remove".replace("{" + 'role' + "}", encodeURIComponent(String(role)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(permission, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Set the roles of a user
         * @summary Set User Roles
         * @param {string} username
         * @param {Array<PostRoles>} postRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserRolesAdminUsersUsernameRolesPut: function (username, postRoles, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'username' is not null or undefined
                    (0, common_1.assertParamExists)('setUserRolesAdminUsersUsernameRolesPut', 'username', username);
                    // verify required parameter 'postRoles' is not null or undefined
                    (0, common_1.assertParamExists)('setUserRolesAdminUsersUsernameRolesPut', 'postRoles', postRoles);
                    localVarPath = "/admin/users/{username}/roles".replace("{" + 'username' + "}", encodeURIComponent(String(username)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postRoles, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AdminApiAxiosParamCreator = AdminApiAxiosParamCreator;
/**
 * AdminApi - functional programming interface
 * @export
 */
var AdminApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AdminApiAxiosParamCreator)(configuration);
    return {
        /**
         * Add a permission to a role
         * @summary Add Role Permission
         * @param {string} role
         * @param {Permission} permission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRolePermissionAdminRolesRolePermissionsPost: function (role, permission, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addRolePermissionAdminRolesRolePermissionsPost(role, permission, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Add role to a user
         * @summary Add User Role
         * @param {string} username
         * @param {PostRoles} postRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserRoleAdminUsersUsernameRolesPost: function (username, postRoles, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addUserRoleAdminUsersUsernameRolesPost(username, postRoles, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a new role
         * @summary Create Role
         * @param {PostRoles} postRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoleAdminRolesPost: function (postRoles, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRoleAdminRolesPost(postRoles, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a user
         * @summary Create User
         * @param {PostUsers} postUsers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAdminUsersPost: function (postUsers, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createUserAdminUsersPost(postUsers, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a role
         * @summary Delete Role
         * @param {string} role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoleAdminRolesRoleDelete: function (role, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRoleAdminRolesRoleDelete(role, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a user  This only performs a soft delete, while the user is deleted from the app database, it still exists in the idp so they can still log in, the user will then be re-created with the default permissions.
         * @summary Delete User
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAdminUsersUsernameDelete: function (username, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteUserAdminUsersUsernameDelete(username, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Remove role from a user
         * @summary Delete User Role
         * @param {string} username
         * @param {string} role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserRoleAdminUsersUsernameRolesRoleDelete: function (username, role, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteUserRoleAdminUsersUsernameRolesRoleDelete(username, role, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all permissions of a role
         * @summary Get Role Permissions
         * @param {string} role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolePermissionsAdminRolesRolePermissionsGet: function (role, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRolePermissionsAdminRolesRolePermissionsGet(role, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all roles
         * @summary Get Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesAdminRolesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRolesAdminRolesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a user
         * @summary Get User
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAdminUsersUsernameGet: function (username, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUserAdminUsersUsernameGet(username, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Search users
         * @summary Get Users
         * @param {string} [username] filters username that starts with the value
         * @param {boolean} [isAdmin]
         * @param {number} [limit] defaults to 100
         * @param {number} [offset] defaults to 0
         * @param {string} [orderBy] common separated list of fields to order by, prefix with \&#39;-\&#39; to sort descendingly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersAdminUsersGet: function (username, isAdmin, limit, offset, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUsersAdminUsersGet(username, isAdmin, limit, offset, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Make or remove admin privilege from a user
         * @summary Make Admin
         * @param {string} username
         * @param {PostMakeAdmin} postMakeAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeAdminAdminUsersUsernameMakeAdminPost: function (username, postMakeAdmin, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.makeAdminAdminUsersUsernameMakeAdminPost(username, postMakeAdmin, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a permission from a role
         * @summary Remove Role Permission
         * @param {string} role
         * @param {Permission} permission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRolePermissionAdminRolesRolePermissionsRemovePost: function (role, permission, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeRolePermissionAdminRolesRolePermissionsRemovePost(role, permission, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Set the roles of a user
         * @summary Set User Roles
         * @param {string} username
         * @param {Array<PostRoles>} postRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserRolesAdminUsersUsernameRolesPut: function (username, postRoles, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setUserRolesAdminUsersUsernameRolesPut(username, postRoles, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AdminApiFp = AdminApiFp;
/**
 * AdminApi - factory interface
 * @export
 */
var AdminApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AdminApiFp)(configuration);
    return {
        /**
         * Add a permission to a role
         * @summary Add Role Permission
         * @param {string} role
         * @param {Permission} permission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRolePermissionAdminRolesRolePermissionsPost: function (role, permission, options) {
            return localVarFp
                .addRolePermissionAdminRolesRolePermissionsPost(role, permission, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add role to a user
         * @summary Add User Role
         * @param {string} username
         * @param {PostRoles} postRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserRoleAdminUsersUsernameRolesPost: function (username, postRoles, options) {
            return localVarFp
                .addUserRoleAdminUsersUsernameRolesPost(username, postRoles, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a new role
         * @summary Create Role
         * @param {PostRoles} postRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoleAdminRolesPost: function (postRoles, options) {
            return localVarFp
                .createRoleAdminRolesPost(postRoles, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a user
         * @summary Create User
         * @param {PostUsers} postUsers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAdminUsersPost: function (postUsers, options) {
            return localVarFp
                .createUserAdminUsersPost(postUsers, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a role
         * @summary Delete Role
         * @param {string} role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoleAdminRolesRoleDelete: function (role, options) {
            return localVarFp
                .deleteRoleAdminRolesRoleDelete(role, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a user  This only performs a soft delete, while the user is deleted from the app database, it still exists in the idp so they can still log in, the user will then be re-created with the default permissions.
         * @summary Delete User
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAdminUsersUsernameDelete: function (username, options) {
            return localVarFp
                .deleteUserAdminUsersUsernameDelete(username, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Remove role from a user
         * @summary Delete User Role
         * @param {string} username
         * @param {string} role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserRoleAdminUsersUsernameRolesRoleDelete: function (username, role, options) {
            return localVarFp
                .deleteUserRoleAdminUsersUsernameRolesRoleDelete(username, role, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all permissions of a role
         * @summary Get Role Permissions
         * @param {string} role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolePermissionsAdminRolesRolePermissionsGet: function (role, options) {
            return localVarFp
                .getRolePermissionsAdminRolesRolePermissionsGet(role, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all roles
         * @summary Get Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesAdminRolesGet: function (options) {
            return localVarFp.getRolesAdminRolesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a user
         * @summary Get User
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAdminUsersUsernameGet: function (username, options) {
            return localVarFp
                .getUserAdminUsersUsernameGet(username, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Search users
         * @summary Get Users
         * @param {string} [username] filters username that starts with the value
         * @param {boolean} [isAdmin]
         * @param {number} [limit] defaults to 100
         * @param {number} [offset] defaults to 0
         * @param {string} [orderBy] common separated list of fields to order by, prefix with \&#39;-\&#39; to sort descendingly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersAdminUsersGet: function (username, isAdmin, limit, offset, orderBy, options) {
            return localVarFp
                .getUsersAdminUsersGet(username, isAdmin, limit, offset, orderBy, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Make or remove admin privilege from a user
         * @summary Make Admin
         * @param {string} username
         * @param {PostMakeAdmin} postMakeAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeAdminAdminUsersUsernameMakeAdminPost: function (username, postMakeAdmin, options) {
            return localVarFp
                .makeAdminAdminUsersUsernameMakeAdminPost(username, postMakeAdmin, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a permission from a role
         * @summary Remove Role Permission
         * @param {string} role
         * @param {Permission} permission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRolePermissionAdminRolesRolePermissionsRemovePost: function (role, permission, options) {
            return localVarFp
                .removeRolePermissionAdminRolesRolePermissionsRemovePost(role, permission, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Set the roles of a user
         * @summary Set User Roles
         * @param {string} username
         * @param {Array<PostRoles>} postRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserRolesAdminUsersUsernameRolesPut: function (username, postRoles, options) {
            return localVarFp
                .setUserRolesAdminUsersUsernameRolesPut(username, postRoles, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AdminApiFactory = AdminApiFactory;
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
var AdminApi = /** @class */ (function (_super) {
    __extends(AdminApi, _super);
    function AdminApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add a permission to a role
     * @summary Add Role Permission
     * @param {string} role
     * @param {Permission} permission
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.addRolePermissionAdminRolesRolePermissionsPost = function (role, permission, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .addRolePermissionAdminRolesRolePermissionsPost(role, permission, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add role to a user
     * @summary Add User Role
     * @param {string} username
     * @param {PostRoles} postRoles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.addUserRoleAdminUsersUsernameRolesPost = function (username, postRoles, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .addUserRoleAdminUsersUsernameRolesPost(username, postRoles, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a new role
     * @summary Create Role
     * @param {PostRoles} postRoles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createRoleAdminRolesPost = function (postRoles, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .createRoleAdminRolesPost(postRoles, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a user
     * @summary Create User
     * @param {PostUsers} postUsers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createUserAdminUsersPost = function (postUsers, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .createUserAdminUsersPost(postUsers, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a role
     * @summary Delete Role
     * @param {string} role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteRoleAdminRolesRoleDelete = function (role, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .deleteRoleAdminRolesRoleDelete(role, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a user  This only performs a soft delete, while the user is deleted from the app database, it still exists in the idp so they can still log in, the user will then be re-created with the default permissions.
     * @summary Delete User
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteUserAdminUsersUsernameDelete = function (username, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .deleteUserAdminUsersUsernameDelete(username, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Remove role from a user
     * @summary Delete User Role
     * @param {string} username
     * @param {string} role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteUserRoleAdminUsersUsernameRolesRoleDelete = function (username, role, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .deleteUserRoleAdminUsersUsernameRolesRoleDelete(username, role, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all permissions of a role
     * @summary Get Role Permissions
     * @param {string} role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getRolePermissionsAdminRolesRolePermissionsGet = function (role, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .getRolePermissionsAdminRolesRolePermissionsGet(role, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all roles
     * @summary Get Roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getRolesAdminRolesGet = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .getRolesAdminRolesGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a user
     * @summary Get User
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getUserAdminUsersUsernameGet = function (username, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .getUserAdminUsersUsernameGet(username, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Search users
     * @summary Get Users
     * @param {string} [username] filters username that starts with the value
     * @param {boolean} [isAdmin]
     * @param {number} [limit] defaults to 100
     * @param {number} [offset] defaults to 0
     * @param {string} [orderBy] common separated list of fields to order by, prefix with \&#39;-\&#39; to sort descendingly.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getUsersAdminUsersGet = function (username, isAdmin, limit, offset, orderBy, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .getUsersAdminUsersGet(username, isAdmin, limit, offset, orderBy, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Make or remove admin privilege from a user
     * @summary Make Admin
     * @param {string} username
     * @param {PostMakeAdmin} postMakeAdmin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.makeAdminAdminUsersUsernameMakeAdminPost = function (username, postMakeAdmin, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .makeAdminAdminUsersUsernameMakeAdminPost(username, postMakeAdmin, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a permission from a role
     * @summary Remove Role Permission
     * @param {string} role
     * @param {Permission} permission
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.removeRolePermissionAdminRolesRolePermissionsRemovePost = function (role, permission, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .removeRolePermissionAdminRolesRolePermissionsRemovePost(role, permission, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Set the roles of a user
     * @summary Set User Roles
     * @param {string} username
     * @param {Array<PostRoles>} postRoles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.setUserRolesAdminUsersUsernameRolesPut = function (username, postRoles, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .setUserRolesAdminUsersUsernameRolesPut(username, postRoles, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AdminApi;
}(base_1.BaseAPI));
exports.AdminApi = AdminApi;
/**
 * AlertsApi - axios parameter creator
 * @export
 */
var AlertsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Acknowledge Alert
         * @param {string} alertId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeAlertAlertsAlertIdPost: function (alertId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'alertId' is not null or undefined
                    (0, common_1.assertParamExists)('acknowledgeAlertAlertsAlertIdPost', 'alertId', alertId);
                    localVarPath = "/alerts/{alert_id}".replace("{" + 'alert_id' + "}", encodeURIComponent(String(alertId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Create Alert
         * @param {string} alertId
         * @param {string} category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlertAlertsPost: function (alertId, category, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'alertId' is not null or undefined
                    (0, common_1.assertParamExists)('createAlertAlertsPost', 'alertId', alertId);
                    // verify required parameter 'category' is not null or undefined
                    (0, common_1.assertParamExists)('createAlertAlertsPost', 'category', category);
                    localVarPath = "/alerts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (alertId !== undefined) {
                        localVarQueryParameter['alert_id'] = alertId;
                    }
                    if (category !== undefined) {
                        localVarQueryParameter['category'] = category;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Alert
         * @param {string} alertId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertAlertsAlertIdGet: function (alertId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'alertId' is not null or undefined
                    (0, common_1.assertParamExists)('getAlertAlertsAlertIdGet', 'alertId', alertId);
                    localVarPath = "/alerts/{alert_id}".replace("{" + 'alert_id' + "}", encodeURIComponent(String(alertId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertsAlertsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/alerts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AlertsApiAxiosParamCreator = AlertsApiAxiosParamCreator;
/**
 * AlertsApi - functional programming interface
 * @export
 */
var AlertsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AlertsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Acknowledge Alert
         * @param {string} alertId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeAlertAlertsAlertIdPost: function (alertId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.acknowledgeAlertAlertsAlertIdPost(alertId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Alert
         * @param {string} alertId
         * @param {string} category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlertAlertsPost: function (alertId, category, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAlertAlertsPost(alertId, category, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Alert
         * @param {string} alertId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertAlertsAlertIdGet: function (alertId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAlertAlertsAlertIdGet(alertId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertsAlertsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAlertsAlertsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AlertsApiFp = AlertsApiFp;
/**
 * AlertsApi - factory interface
 * @export
 */
var AlertsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AlertsApiFp)(configuration);
    return {
        /**
         *
         * @summary Acknowledge Alert
         * @param {string} alertId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeAlertAlertsAlertIdPost: function (alertId, options) {
            return localVarFp
                .acknowledgeAlertAlertsAlertIdPost(alertId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Alert
         * @param {string} alertId
         * @param {string} category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlertAlertsPost: function (alertId, category, options) {
            return localVarFp
                .createAlertAlertsPost(alertId, category, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Alert
         * @param {string} alertId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertAlertsAlertIdGet: function (alertId, options) {
            return localVarFp
                .getAlertAlertsAlertIdGet(alertId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertsAlertsGet: function (options) {
            return localVarFp.getAlertsAlertsGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AlertsApiFactory = AlertsApiFactory;
/**
 * AlertsApi - object-oriented interface
 * @export
 * @class AlertsApi
 * @extends {BaseAPI}
 */
var AlertsApi = /** @class */ (function (_super) {
    __extends(AlertsApi, _super);
    function AlertsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Acknowledge Alert
     * @param {string} alertId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    AlertsApi.prototype.acknowledgeAlertAlertsAlertIdPost = function (alertId, options) {
        var _this = this;
        return (0, exports.AlertsApiFp)(this.configuration)
            .acknowledgeAlertAlertsAlertIdPost(alertId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Alert
     * @param {string} alertId
     * @param {string} category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    AlertsApi.prototype.createAlertAlertsPost = function (alertId, category, options) {
        var _this = this;
        return (0, exports.AlertsApiFp)(this.configuration)
            .createAlertAlertsPost(alertId, category, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Alert
     * @param {string} alertId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    AlertsApi.prototype.getAlertAlertsAlertIdGet = function (alertId, options) {
        var _this = this;
        return (0, exports.AlertsApiFp)(this.configuration)
            .getAlertAlertsAlertIdGet(alertId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Alerts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    AlertsApi.prototype.getAlertsAlertsGet = function (options) {
        var _this = this;
        return (0, exports.AlertsApiFp)(this.configuration)
            .getAlertsAlertsGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AlertsApi;
}(base_1.BaseAPI));
exports.AlertsApi = AlertsApi;
/**
 * BeaconsApi - axios parameter creator
 * @export
 */
var BeaconsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get Beacon
         * @param {string} beaconId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeaconBeaconsBeaconIdGet: function (beaconId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'beaconId' is not null or undefined
                    (0, common_1.assertParamExists)('getBeaconBeaconsBeaconIdGet', 'beaconId', beaconId);
                    localVarPath = "/beacons/{beacon_id}".replace("{" + 'beacon_id' + "}", encodeURIComponent(String(beaconId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Beacons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeaconsBeaconsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/beacons";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Save Beacon State
         * @param {string} beaconId
         * @param {boolean} online
         * @param {string} category
         * @param {boolean} activated
         * @param {string} level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBeaconStateBeaconsPost: function (beaconId, online, category, activated, level, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'beaconId' is not null or undefined
                    (0, common_1.assertParamExists)('saveBeaconStateBeaconsPost', 'beaconId', beaconId);
                    // verify required parameter 'online' is not null or undefined
                    (0, common_1.assertParamExists)('saveBeaconStateBeaconsPost', 'online', online);
                    // verify required parameter 'category' is not null or undefined
                    (0, common_1.assertParamExists)('saveBeaconStateBeaconsPost', 'category', category);
                    // verify required parameter 'activated' is not null or undefined
                    (0, common_1.assertParamExists)('saveBeaconStateBeaconsPost', 'activated', activated);
                    // verify required parameter 'level' is not null or undefined
                    (0, common_1.assertParamExists)('saveBeaconStateBeaconsPost', 'level', level);
                    localVarPath = "/beacons";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (beaconId !== undefined) {
                        localVarQueryParameter['beacon_id'] = beaconId;
                    }
                    if (online !== undefined) {
                        localVarQueryParameter['online'] = online;
                    }
                    if (category !== undefined) {
                        localVarQueryParameter['category'] = category;
                    }
                    if (activated !== undefined) {
                        localVarQueryParameter['activated'] = activated;
                    }
                    if (level !== undefined) {
                        localVarQueryParameter['level'] = level;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.BeaconsApiAxiosParamCreator = BeaconsApiAxiosParamCreator;
/**
 * BeaconsApi - functional programming interface
 * @export
 */
var BeaconsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.BeaconsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get Beacon
         * @param {string} beaconId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeaconBeaconsBeaconIdGet: function (beaconId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBeaconBeaconsBeaconIdGet(beaconId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Beacons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeaconsBeaconsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBeaconsBeaconsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Save Beacon State
         * @param {string} beaconId
         * @param {boolean} online
         * @param {string} category
         * @param {boolean} activated
         * @param {string} level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBeaconStateBeaconsPost: function (beaconId, online, category, activated, level, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.saveBeaconStateBeaconsPost(beaconId, online, category, activated, level, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.BeaconsApiFp = BeaconsApiFp;
/**
 * BeaconsApi - factory interface
 * @export
 */
var BeaconsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.BeaconsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get Beacon
         * @param {string} beaconId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeaconBeaconsBeaconIdGet: function (beaconId, options) {
            return localVarFp
                .getBeaconBeaconsBeaconIdGet(beaconId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Beacons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeaconsBeaconsGet: function (options) {
            return localVarFp.getBeaconsBeaconsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Save Beacon State
         * @param {string} beaconId
         * @param {boolean} online
         * @param {string} category
         * @param {boolean} activated
         * @param {string} level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBeaconStateBeaconsPost: function (beaconId, online, category, activated, level, options) {
            return localVarFp
                .saveBeaconStateBeaconsPost(beaconId, online, category, activated, level, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BeaconsApiFactory = BeaconsApiFactory;
/**
 * BeaconsApi - object-oriented interface
 * @export
 * @class BeaconsApi
 * @extends {BaseAPI}
 */
var BeaconsApi = /** @class */ (function (_super) {
    __extends(BeaconsApi, _super);
    function BeaconsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get Beacon
     * @param {string} beaconId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeaconsApi
     */
    BeaconsApi.prototype.getBeaconBeaconsBeaconIdGet = function (beaconId, options) {
        var _this = this;
        return (0, exports.BeaconsApiFp)(this.configuration)
            .getBeaconBeaconsBeaconIdGet(beaconId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Beacons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeaconsApi
     */
    BeaconsApi.prototype.getBeaconsBeaconsGet = function (options) {
        var _this = this;
        return (0, exports.BeaconsApiFp)(this.configuration)
            .getBeaconsBeaconsGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Save Beacon State
     * @param {string} beaconId
     * @param {boolean} online
     * @param {string} category
     * @param {boolean} activated
     * @param {string} level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeaconsApi
     */
    BeaconsApi.prototype.saveBeaconStateBeaconsPost = function (beaconId, online, category, activated, level, options) {
        var _this = this;
        return (0, exports.BeaconsApiFp)(this.configuration)
            .saveBeaconStateBeaconsPost(beaconId, online, category, activated, level, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BeaconsApi;
}(base_1.BaseAPI));
exports.BeaconsApi = BeaconsApi;
/**
 * BuildingApi - axios parameter creator
 * @export
 */
var BuildingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Available in socket.io
         * @summary Get Building Map
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuildingMapBuildingMapGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/building_map";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.BuildingApiAxiosParamCreator = BuildingApiAxiosParamCreator;
/**
 * BuildingApi - functional programming interface
 * @export
 */
var BuildingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.BuildingApiAxiosParamCreator)(configuration);
    return {
        /**
         * Available in socket.io
         * @summary Get Building Map
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuildingMapBuildingMapGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBuildingMapBuildingMapGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.BuildingApiFp = BuildingApiFp;
/**
 * BuildingApi - factory interface
 * @export
 */
var BuildingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.BuildingApiFp)(configuration);
    return {
        /**
         * Available in socket.io
         * @summary Get Building Map
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuildingMapBuildingMapGet: function (options) {
            return localVarFp
                .getBuildingMapBuildingMapGet(options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BuildingApiFactory = BuildingApiFactory;
/**
 * BuildingApi - object-oriented interface
 * @export
 * @class BuildingApi
 * @extends {BaseAPI}
 */
var BuildingApi = /** @class */ (function (_super) {
    __extends(BuildingApi, _super);
    function BuildingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Available in socket.io
     * @summary Get Building Map
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildingApi
     */
    BuildingApi.prototype.getBuildingMapBuildingMapGet = function (options) {
        var _this = this;
        return (0, exports.BuildingApiFp)(this.configuration)
            .getBuildingMapBuildingMapGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BuildingApi;
}(base_1.BaseAPI));
exports.BuildingApi = BuildingApi;
/**
 * DefaultApi - axios parameter creator
 * @export
 */
var DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get the effective permissions of the current user
         * @summary Get Effective Permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectivePermissionsPermissionsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/permissions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get the current rmf time in unix milliseconds
         * @summary Get Time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTimeGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/time";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get the currently logged in user
         * @summary Get User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUserGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/user";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *  # NOTE: This endpoint is here for documentation purposes only, this is _not_ a REST endpoint.  ## About This exposes a minimal pubsub system built on top of socket.io. It works similar to a normal socket.io endpoint, except that are 2 special rooms which control subscriptions.  ## Rooms ### subscribe Clients must send a message to this room to start receiving messages on other rooms. The message must be of the form:  ``` {     \"room\": \"<room_name>\" } ```  ### unsubscribe Clients can send a message to this room to stop receiving messages on other rooms. The message must be of the form:  ``` {     \"room\": \"<room_name>\" } ```              ### /alerts   ``` {   \"title\": \"Alert\",   \"description\": \"General alert that can be triggered by events.\",   \"type\": \"object\",   \"properties\": {     \"id\": {       \"title\": \"Id\",       \"maxLength\": 255,       \"type\": \"string\"     },     \"original_id\": {       \"title\": \"Original Id\",       \"maxLength\": 255,       \"type\": \"string\"     },     \"category\": {       \"title\": \"Category\",       \"description\": \"Default: default<br/>Task: task<br/>Fleet: fleet<br/>Robot: robot<br/>Maintain: maintain\",       \"maxLength\": 8,       \"type\": \"string\"     },     \"message\": {       \"title\": \"Message\",       \"maxLength\": 500,       \"nullable\": true,       \"type\": \"string\"     },     \"unix_millis_created_time\": {       \"title\": \"Unix Millis Created Time\",       \"minimum\": -9223372036854775808,       \"maximum\": 9223372036854775807,       \"type\": \"integer\"     },     \"acknowledged_by\": {       \"title\": \"Acknowledged By\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"unix_millis_acknowledged_time\": {       \"title\": \"Unix Millis Acknowledged Time\",       \"minimum\": -9223372036854775808,       \"maximum\": 9223372036854775807,       \"nullable\": true,       \"type\": \"integer\"     }   },   \"required\": [     \"id\",     \"original_id\",     \"category\",     \"unix_millis_created_time\"   ],   \"additionalProperties\": false } ```   ### /beacons   ``` {   \"title\": \"BeaconState\",   \"type\": \"object\",   \"properties\": {     \"id\": {       \"title\": \"Id\",       \"maxLength\": 255,       \"type\": \"string\"     },     \"online\": {       \"title\": \"Online\",       \"type\": \"boolean\"     },     \"category\": {       \"title\": \"Category\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"activated\": {       \"title\": \"Activated\",       \"type\": \"boolean\"     },     \"level\": {       \"title\": \"Level\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     }   },   \"required\": [     \"id\",     \"online\",     \"activated\"   ],   \"additionalProperties\": false } ```   ### /building_map   ``` {   \"title\": \"BuildingMap\",   \"type\": \"object\",   \"properties\": {     \"name\": {       \"title\": \"Name\",       \"default\": \"\",       \"type\": \"string\"     },     \"levels\": {       \"title\": \"Levels\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Level\"       }     },     \"lifts\": {       \"title\": \"Lifts\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Lift\"       }     }   },   \"required\": [     \"name\",     \"levels\",     \"lifts\"   ],   \"definitions\": {     \"AffineImage\": {       \"title\": \"AffineImage\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"x_offset\": {           \"title\": \"X Offset\",           \"default\": 0,           \"type\": \"number\"         },         \"y_offset\": {           \"title\": \"Y Offset\",           \"default\": 0,           \"type\": \"number\"         },         \"yaw\": {           \"title\": \"Yaw\",           \"default\": 0,           \"type\": \"number\"         },         \"scale\": {           \"title\": \"Scale\",           \"default\": 0,           \"type\": \"number\"         },         \"encoding\": {           \"title\": \"Encoding\",           \"default\": \"\",           \"type\": \"string\"         },         \"data\": {           \"title\": \"Data\",           \"type\": \"string\"         }       },       \"required\": [         \"name\",         \"x_offset\",         \"y_offset\",         \"yaw\",         \"scale\",         \"encoding\",         \"data\"       ]     },     \"Place\": {       \"title\": \"Place\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"x\": {           \"title\": \"X\",           \"default\": 0,           \"type\": \"number\"         },         \"y\": {           \"title\": \"Y\",           \"default\": 0,           \"type\": \"number\"         },         \"yaw\": {           \"title\": \"Yaw\",           \"default\": 0,           \"type\": \"number\"         },         \"position_tolerance\": {           \"title\": \"Position Tolerance\",           \"default\": 0,           \"type\": \"number\"         },         \"yaw_tolerance\": {           \"title\": \"Yaw Tolerance\",           \"default\": 0,           \"type\": \"number\"         }       },       \"required\": [         \"name\",         \"x\",         \"y\",         \"yaw\",         \"position_tolerance\",         \"yaw_tolerance\"       ]     },     \"Door\": {       \"title\": \"Door\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"v1_x\": {           \"title\": \"V1 X\",           \"default\": 0,           \"type\": \"number\"         },         \"v1_y\": {           \"title\": \"V1 Y\",           \"default\": 0,           \"type\": \"number\"         },         \"v2_x\": {           \"title\": \"V2 X\",           \"default\": 0,           \"type\": \"number\"         },         \"v2_y\": {           \"title\": \"V2 Y\",           \"default\": 0,           \"type\": \"number\"         },         \"door_type\": {           \"title\": \"Door Type\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 255,           \"type\": \"integer\"         },         \"motion_range\": {           \"title\": \"Motion Range\",           \"default\": 0,           \"type\": \"number\"         },         \"motion_direction\": {           \"title\": \"Motion Direction\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         }       },       \"required\": [         \"name\",         \"v1_x\",         \"v1_y\",         \"v2_x\",         \"v2_y\",         \"door_type\",         \"motion_range\",         \"motion_direction\"       ]     },     \"Param\": {       \"title\": \"Param\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"type\": {           \"title\": \"Type\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         },         \"value_int\": {           \"title\": \"Value Int\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"value_float\": {           \"title\": \"Value Float\",           \"default\": 0,           \"type\": \"number\"         },         \"value_string\": {           \"title\": \"Value String\",           \"default\": \"\",           \"type\": \"string\"         },         \"value_bool\": {           \"title\": \"Value Bool\",           \"default\": false,           \"type\": \"boolean\"         }       },       \"required\": [         \"name\",         \"type\",         \"value_int\",         \"value_float\",         \"value_string\",         \"value_bool\"       ]     },     \"GraphNode\": {       \"title\": \"GraphNode\",       \"type\": \"object\",       \"properties\": {         \"x\": {           \"title\": \"X\",           \"default\": 0,           \"type\": \"number\"         },         \"y\": {           \"title\": \"Y\",           \"default\": 0,           \"type\": \"number\"         },         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"params\": {           \"title\": \"Params\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Param\"           }         }       },       \"required\": [         \"x\",         \"y\",         \"name\",         \"params\"       ]     },     \"GraphEdge\": {       \"title\": \"GraphEdge\",       \"type\": \"object\",       \"properties\": {         \"v1_idx\": {           \"title\": \"V1 Idx\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         },         \"v2_idx\": {           \"title\": \"V2 Idx\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         },         \"params\": {           \"title\": \"Params\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Param\"           }         },         \"edge_type\": {           \"title\": \"Edge Type\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 255,           \"type\": \"integer\"         }       },       \"required\": [         \"v1_idx\",         \"v2_idx\",         \"params\",         \"edge_type\"       ]     },     \"Graph\": {       \"title\": \"Graph\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"vertices\": {           \"title\": \"Vertices\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/GraphNode\"           }         },         \"edges\": {           \"title\": \"Edges\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/GraphEdge\"           }         },         \"params\": {           \"title\": \"Params\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Param\"           }         }       },       \"required\": [         \"name\",         \"vertices\",         \"edges\",         \"params\"       ]     },     \"Level\": {       \"title\": \"Level\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"elevation\": {           \"title\": \"Elevation\",           \"default\": 0,           \"type\": \"number\"         },         \"images\": {           \"title\": \"Images\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/AffineImage\"           }         },         \"places\": {           \"title\": \"Places\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Place\"           }         },         \"doors\": {           \"title\": \"Doors\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Door\"           }         },         \"nav_graphs\": {           \"title\": \"Nav Graphs\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Graph\"           }         },         \"wall_graph\": {           \"title\": \"Wall Graph\",           \"default\": {             \"name\": \"\",             \"vertices\": [],             \"edges\": [],             \"params\": []           },           \"allOf\": [             {               \"$ref\": \"#/definitions/Graph\"             }           ]         }       },       \"required\": [         \"name\",         \"elevation\",         \"images\",         \"places\",         \"doors\",         \"nav_graphs\",         \"wall_graph\"       ]     },     \"Lift\": {       \"title\": \"Lift\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"levels\": {           \"title\": \"Levels\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"doors\": {           \"title\": \"Doors\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Door\"           }         },         \"wall_graph\": {           \"title\": \"Wall Graph\",           \"default\": {             \"name\": \"\",             \"vertices\": [],             \"edges\": [],             \"params\": []           },           \"allOf\": [             {               \"$ref\": \"#/definitions/Graph\"             }           ]         },         \"ref_x\": {           \"title\": \"Ref X\",           \"default\": 0,           \"type\": \"number\"         },         \"ref_y\": {           \"title\": \"Ref Y\",           \"default\": 0,           \"type\": \"number\"         },         \"ref_yaw\": {           \"title\": \"Ref Yaw\",           \"default\": 0,           \"type\": \"number\"         },         \"width\": {           \"title\": \"Width\",           \"default\": 0,           \"type\": \"number\"         },         \"depth\": {           \"title\": \"Depth\",           \"default\": 0,           \"type\": \"number\"         }       },       \"required\": [         \"name\",         \"levels\",         \"doors\",         \"wall_graph\",         \"ref_x\",         \"ref_y\",         \"ref_yaw\",         \"width\",         \"depth\"       ]     }   } } ```   ### /doors/{door_name}/state   ``` {   \"title\": \"DoorState\",   \"type\": \"object\",   \"properties\": {     \"door_time\": {       \"title\": \"Door Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"door_name\": {       \"title\": \"Door Name\",       \"default\": \"\",       \"type\": \"string\"     },     \"current_mode\": {       \"title\": \"Current Mode\",       \"default\": {         \"value\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/DoorMode\"         }       ]     }   },   \"required\": [     \"door_time\",     \"door_name\",     \"current_mode\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     },     \"DoorMode\": {       \"title\": \"DoorMode\",       \"type\": \"object\",       \"properties\": {         \"value\": {           \"title\": \"Value\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"value\"       ]     }   } } ```   ### /doors/{door_name}/health   ``` {   \"title\": \"DoorHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /lifts/{lift_name}/state   ``` {   \"title\": \"LiftState\",   \"type\": \"object\",   \"properties\": {     \"lift_time\": {       \"title\": \"Lift Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"lift_name\": {       \"title\": \"Lift Name\",       \"default\": \"\",       \"type\": \"string\"     },     \"available_floors\": {       \"title\": \"Available Floors\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"type\": \"string\"       }     },     \"current_floor\": {       \"title\": \"Current Floor\",       \"default\": \"\",       \"type\": \"string\"     },     \"destination_floor\": {       \"title\": \"Destination Floor\",       \"default\": \"\",       \"type\": \"string\"     },     \"door_state\": {       \"title\": \"Door State\",       \"default\": 0,       \"minimum\": 0,       \"maximum\": 255,       \"type\": \"integer\"     },     \"motion_state\": {       \"title\": \"Motion State\",       \"default\": 0,       \"minimum\": 0,       \"maximum\": 255,       \"type\": \"integer\"     },     \"available_modes\": {       \"title\": \"Available Modes\",       \"type\": \"array\",       \"items\": {         \"type\": \"integer\"       }     },     \"current_mode\": {       \"title\": \"Current Mode\",       \"default\": 0,       \"minimum\": 0,       \"maximum\": 255,       \"type\": \"integer\"     },     \"session_id\": {       \"title\": \"Session Id\",       \"default\": \"\",       \"type\": \"string\"     }   },   \"required\": [     \"lift_time\",     \"lift_name\",     \"available_floors\",     \"current_floor\",     \"destination_floor\",     \"door_state\",     \"motion_state\",     \"available_modes\",     \"current_mode\",     \"session_id\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     }   } } ```   ### /lifts/{lift_name}/health   ``` {   \"title\": \"LiftHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /tasks/{task_id}/state   ``` {   \"title\": \"TaskState\",   \"type\": \"object\",   \"properties\": {     \"booking\": {       \"$ref\": \"#/definitions/Booking\"     },     \"category\": {       \"$ref\": \"#/definitions/Category\"     },     \"detail\": {       \"$ref\": \"#/definitions/Detail\"     },     \"unix_millis_start_time\": {       \"title\": \"Unix Millis Start Time\",       \"type\": \"integer\"     },     \"unix_millis_finish_time\": {       \"title\": \"Unix Millis Finish Time\",       \"type\": \"integer\"     },     \"original_estimate_millis\": {       \"$ref\": \"#/definitions/EstimateMillis\"     },     \"estimate_millis\": {       \"$ref\": \"#/definitions/EstimateMillis\"     },     \"assigned_to\": {       \"title\": \"Assigned To\",       \"description\": \"Which agent (robot) is the task assigned to\",       \"allOf\": [         {           \"$ref\": \"#/definitions/AssignedTo\"         }       ]     },     \"status\": {       \"$ref\": \"#/definitions/Status\"     },     \"dispatch\": {       \"$ref\": \"#/definitions/Dispatch\"     },     \"phases\": {       \"title\": \"Phases\",       \"description\": \"A dictionary of the states of the phases of the task. The keys (property names) are phase IDs, which are integers.\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/Phase\"       }     },     \"completed\": {       \"title\": \"Completed\",       \"description\": \"An array of the IDs of completed phases of this task\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Id\"       }     },     \"active\": {       \"title\": \"Active\",       \"description\": \"The ID of the active phase for this task\",       \"allOf\": [         {           \"$ref\": \"#/definitions/Id\"         }       ]     },     \"pending\": {       \"title\": \"Pending\",       \"description\": \"An array of the pending phases of this task\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Id\"       }     },     \"interruptions\": {       \"title\": \"Interruptions\",       \"description\": \"A dictionary of interruptions that have been applied to this task. The keys (property names) are the unique token of the interruption request.\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/Interruption\"       }     },     \"cancellation\": {       \"title\": \"Cancellation\",       \"description\": \"If the task was cancelled, this will describe information about the request.\",       \"allOf\": [         {           \"$ref\": \"#/definitions/Cancellation\"         }       ]     },     \"killed\": {       \"title\": \"Killed\",       \"description\": \"If the task was killed, this will describe information about the request.\",       \"allOf\": [         {           \"$ref\": \"#/definitions/Killed\"         }       ]     }   },   \"required\": [     \"booking\"   ],   \"definitions\": {     \"Booking\": {       \"title\": \"Booking\",       \"type\": \"object\",       \"properties\": {         \"id\": {           \"title\": \"Id\",           \"description\": \"The unique identifier for this task\",           \"type\": \"string\"         },         \"unix_millis_earliest_start_time\": {           \"title\": \"Unix Millis Earliest Start Time\",           \"type\": \"integer\"         },         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"type\": \"integer\"         },         \"priority\": {           \"title\": \"Priority\",           \"description\": \"Priority information about this task\",           \"anyOf\": [             {               \"type\": \"object\"             },             {               \"type\": \"string\"             }           ]         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Information about how and why this task was booked\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"requester\": {           \"title\": \"Requester\",           \"description\": \"(Optional) An identifier for the entity that requested this task\",           \"type\": \"string\"         }       },       \"required\": [         \"id\"       ]     },     \"Category\": {       \"title\": \"Category\",       \"description\": \"The category of this task or phase\",       \"type\": \"string\"     },     \"Detail\": {       \"title\": \"Detail\",       \"description\": \"Detailed information about a task, phase, or event\",       \"anyOf\": [         {           \"type\": \"object\"         },         {           \"type\": \"array\",           \"items\": {}         },         {           \"type\": \"string\"         }       ]     },     \"EstimateMillis\": {       \"title\": \"EstimateMillis\",       \"description\": \"An estimate, in milliseconds, of how long the subject will take to complete\",       \"minimum\": 0,       \"type\": \"integer\"     },     \"AssignedTo\": {       \"title\": \"AssignedTo\",       \"type\": \"object\",       \"properties\": {         \"group\": {           \"title\": \"Group\",           \"type\": \"string\"         },         \"name\": {           \"title\": \"Name\",           \"type\": \"string\"         }       },       \"required\": [         \"group\",         \"name\"       ]     },     \"Status\": {       \"title\": \"Status\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"blocked\",         \"error\",         \"failed\",         \"queued\",         \"standby\",         \"underway\",         \"delayed\",         \"skipped\",         \"canceled\",         \"killed\",         \"completed\"       ]     },     \"Status1\": {       \"title\": \"Status1\",       \"description\": \"An enumeration.\",       \"enum\": [         \"queued\",         \"selected\",         \"dispatched\",         \"failed_to_assign\",         \"canceled_in_flight\"       ]     },     \"Assignment\": {       \"title\": \"Assignment\",       \"type\": \"object\",       \"properties\": {         \"fleet_name\": {           \"title\": \"Fleet Name\",           \"type\": \"string\"         },         \"expected_robot_name\": {           \"title\": \"Expected Robot Name\",           \"type\": \"string\"         }       }     },     \"Error\": {       \"title\": \"Error\",       \"type\": \"object\",       \"properties\": {         \"code\": {           \"title\": \"Code\",           \"description\": \"A standard code for the kind of error that has occurred\",           \"minimum\": 0,           \"type\": \"integer\"         },         \"category\": {           \"title\": \"Category\",           \"description\": \"The category of the error\",           \"type\": \"string\"         },         \"detail\": {           \"title\": \"Detail\",           \"description\": \"Details about the error\",           \"type\": \"string\"         }       }     },     \"Dispatch\": {       \"title\": \"Dispatch\",       \"type\": \"object\",       \"properties\": {         \"status\": {           \"$ref\": \"#/definitions/Status1\"         },         \"assignment\": {           \"$ref\": \"#/definitions/Assignment\"         },         \"errors\": {           \"title\": \"Errors\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Error\"           }         }       },       \"required\": [         \"status\"       ]     },     \"Id\": {       \"title\": \"Id\",       \"minimum\": 0,       \"type\": \"integer\"     },     \"EventState\": {       \"title\": \"EventState\",       \"type\": \"object\",       \"properties\": {         \"id\": {           \"$ref\": \"#/definitions/Id\"         },         \"status\": {           \"$ref\": \"#/definitions/Status\"         },         \"name\": {           \"title\": \"Name\",           \"description\": \"The brief name of the event\",           \"type\": \"string\"         },         \"detail\": {           \"title\": \"Detail\",           \"description\": \"Detailed information about the event\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Detail\"             }           ]         },         \"deps\": {           \"title\": \"Deps\",           \"description\": \"This event may depend on other events. This array contains the IDs of those other event dependencies.\",           \"type\": \"array\",           \"items\": {             \"type\": \"integer\",             \"minimum\": 0           }         }       },       \"required\": [         \"id\"       ]     },     \"Undo\": {       \"title\": \"Undo\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the undo skip request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the undo skip request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"SkipPhaseRequest\": {       \"title\": \"SkipPhaseRequest\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the skip request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the purpose of the skip request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"undo\": {           \"title\": \"Undo\",           \"description\": \"Information about an undo skip request that applied to this request\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Undo\"             }           ]         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"Phase\": {       \"title\": \"Phase\",       \"type\": \"object\",       \"properties\": {         \"id\": {           \"$ref\": \"#/definitions/Id\"         },         \"category\": {           \"$ref\": \"#/definitions/Category\"         },         \"detail\": {           \"$ref\": \"#/definitions/Detail\"         },         \"unix_millis_start_time\": {           \"title\": \"Unix Millis Start Time\",           \"type\": \"integer\"         },         \"unix_millis_finish_time\": {           \"title\": \"Unix Millis Finish Time\",           \"type\": \"integer\"         },         \"original_estimate_millis\": {           \"$ref\": \"#/definitions/EstimateMillis\"         },         \"estimate_millis\": {           \"$ref\": \"#/definitions/EstimateMillis\"         },         \"final_event_id\": {           \"$ref\": \"#/definitions/Id\"         },         \"events\": {           \"title\": \"Events\",           \"description\": \"A dictionary of events for this phase. The keys (property names) are the event IDs, which are integers.\",           \"type\": \"object\",           \"additionalProperties\": {             \"$ref\": \"#/definitions/EventState\"           }         },         \"skip_requests\": {           \"title\": \"Skip Requests\",           \"description\": \"Information about any skip requests that have been received\",           \"type\": \"object\",           \"additionalProperties\": {             \"$ref\": \"#/definitions/SkipPhaseRequest\"           }         }       },       \"required\": [         \"id\"       ]     },     \"ResumedBy\": {       \"title\": \"ResumedBy\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the resume request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the resume request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"labels\"       ]     },     \"Interruption\": {       \"title\": \"Interruption\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the interruption request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the purpose of the interruption\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"resumed_by\": {           \"title\": \"Resumed By\",           \"description\": \"Information about the resume request that ended this interruption. This field will be missing if the interruption is still active.\",           \"allOf\": [             {               \"$ref\": \"#/definitions/ResumedBy\"             }           ]         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"Cancellation\": {       \"title\": \"Cancellation\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the cancellation request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the cancel request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"Killed\": {       \"title\": \"Killed\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the cancellation request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the kill request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     }   } } ```   ### /tasks/{task_id}/log   ``` {   \"title\": \"TaskEventLog\",   \"type\": \"object\",   \"properties\": {     \"task_id\": {       \"title\": \"Task Id\",       \"type\": \"string\"     },     \"log\": {       \"title\": \"Log\",       \"description\": \"Log entries related to the overall task\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/LogEntry\"       }     },     \"phases\": {       \"title\": \"Phases\",       \"description\": \"A dictionary whose keys (property names) are the indices of a phase\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/Phases\"       }     }   },   \"required\": [     \"task_id\"   ],   \"additionalProperties\": false,   \"definitions\": {     \"Tier\": {       \"title\": \"Tier\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"info\",         \"warning\",         \"error\"       ]     },     \"LogEntry\": {       \"title\": \"LogEntry\",       \"type\": \"object\",       \"properties\": {         \"seq\": {           \"title\": \"Seq\",           \"description\": \"Sequence number for this entry. Each entry has a unique sequence number which monotonically increase, until integer overflow causes a wrap around.\",           \"exclusiveMaximum\": 4294967296,           \"minimum\": 0,           \"type\": \"integer\"         },         \"tier\": {           \"description\": \"The importance level of the log entry\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Tier\"             }           ]         },         \"unix_millis_time\": {           \"title\": \"Unix Millis Time\",           \"type\": \"integer\"         },         \"text\": {           \"title\": \"Text\",           \"description\": \"The text of the log entry\",           \"type\": \"string\"         }       },       \"required\": [         \"seq\",         \"tier\",         \"unix_millis_time\",         \"text\"       ]     },     \"Phases\": {       \"title\": \"Phases\",       \"type\": \"object\",       \"properties\": {         \"log\": {           \"title\": \"Log\",           \"description\": \"Log entries related to the overall phase\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/LogEntry\"           }         },         \"events\": {           \"title\": \"Events\",           \"description\": \"A dictionary whose keys (property names) are the indices of an event in the phase\",           \"type\": \"object\",           \"additionalProperties\": {             \"type\": \"array\",             \"items\": {               \"$ref\": \"#/definitions/LogEntry\"             }           }         }       },       \"additionalProperties\": false     }   } } ```   ### /dispensers/{guid}/state   ``` {   \"title\": \"DispenserState\",   \"type\": \"object\",   \"properties\": {     \"time\": {       \"title\": \"Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"guid\": {       \"title\": \"Guid\",       \"default\": \"\",       \"type\": \"string\"     },     \"mode\": {       \"title\": \"Mode\",       \"default\": 0,       \"minimum\": -2147483648,       \"maximum\": 2147483647,       \"type\": \"integer\"     },     \"request_guid_queue\": {       \"title\": \"Request Guid Queue\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"type\": \"string\"       }     },     \"seconds_remaining\": {       \"title\": \"Seconds Remaining\",       \"default\": 0,       \"type\": \"number\"     }   },   \"required\": [     \"time\",     \"guid\",     \"mode\",     \"request_guid_queue\",     \"seconds_remaining\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     }   } } ```   ### /dispensers/{guid}/health   ``` {   \"title\": \"DispenserHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /ingestors/{guid}/state   ``` {   \"title\": \"IngestorState\",   \"type\": \"object\",   \"properties\": {     \"time\": {       \"title\": \"Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"guid\": {       \"title\": \"Guid\",       \"default\": \"\",       \"type\": \"string\"     },     \"mode\": {       \"title\": \"Mode\",       \"default\": 0,       \"minimum\": -2147483648,       \"maximum\": 2147483647,       \"type\": \"integer\"     },     \"request_guid_queue\": {       \"title\": \"Request Guid Queue\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"type\": \"string\"       }     },     \"seconds_remaining\": {       \"title\": \"Seconds Remaining\",       \"default\": 0,       \"type\": \"number\"     }   },   \"required\": [     \"time\",     \"guid\",     \"mode\",     \"request_guid_queue\",     \"seconds_remaining\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     }   } } ```   ### /ingestors/{guid}/health   ``` {   \"title\": \"IngestorHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /fleets/{name}/state   ``` {   \"title\": \"FleetState\",   \"type\": \"object\",   \"properties\": {     \"name\": {       \"title\": \"Name\",       \"type\": \"string\"     },     \"robots\": {       \"title\": \"Robots\",       \"description\": \"A dictionary of the states of the robots that belong to this fleet\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/RobotState\"       }     }   },   \"definitions\": {     \"Status2\": {       \"title\": \"Status2\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"offline\",         \"shutdown\",         \"idle\",         \"charging\",         \"working\",         \"error\"       ]     },     \"Location2D\": {       \"title\": \"Location2D\",       \"type\": \"object\",       \"properties\": {         \"map\": {           \"title\": \"Map\",           \"type\": \"string\"         },         \"x\": {           \"title\": \"X\",           \"type\": \"number\"         },         \"y\": {           \"title\": \"Y\",           \"type\": \"number\"         },         \"yaw\": {           \"title\": \"Yaw\",           \"type\": \"number\"         }       },       \"required\": [         \"map\",         \"x\",         \"y\",         \"yaw\"       ]     },     \"Issue\": {       \"title\": \"Issue\",       \"type\": \"object\",       \"properties\": {         \"category\": {           \"title\": \"Category\",           \"description\": \"Category of the robot\'s issue\",           \"type\": \"string\"         },         \"detail\": {           \"title\": \"Detail\",           \"description\": \"Detailed information about the issue\",           \"anyOf\": [             {               \"type\": \"object\"             },             {               \"type\": \"array\",               \"items\": {}             },             {               \"type\": \"string\"             }           ]         }       }     },     \"RobotState\": {       \"title\": \"RobotState\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"type\": \"string\"         },         \"status\": {           \"description\": \"A simple token representing the status of the robot\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Status2\"             }           ]         },         \"task_id\": {           \"title\": \"Task Id\",           \"description\": \"The ID of the task this robot is currently working on. Empty string if the robot is not working on a task.\",           \"type\": \"string\"         },         \"unix_millis_time\": {           \"title\": \"Unix Millis Time\",           \"type\": \"integer\"         },         \"location\": {           \"$ref\": \"#/definitions/Location2D\"         },         \"battery\": {           \"title\": \"Battery\",           \"description\": \"State of charge of the battery. Values range from 0.0 (depleted) to 1.0 (fully charged)\",           \"minimum\": 0.0,           \"maximum\": 1.0,           \"type\": \"number\"         },         \"issues\": {           \"title\": \"Issues\",           \"description\": \"A list of issues with the robot that operators need to address\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Issue\"           }         }       }     }   } } ```   ### /fleets/{name}/log   ``` {   \"title\": \"FleetState\",   \"type\": \"object\",   \"properties\": {     \"name\": {       \"title\": \"Name\",       \"type\": \"string\"     },     \"log\": {       \"title\": \"Log\",       \"description\": \"Log for the overall fleet\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/LogEntry\"       }     },     \"robots\": {       \"title\": \"Robots\",       \"description\": \"Dictionary of logs for the individual robots. The keys (property names) are the robot names.\",       \"type\": \"object\",       \"additionalProperties\": {         \"type\": \"array\",         \"items\": {           \"$ref\": \"#/definitions/LogEntry\"         }       }     }   },   \"definitions\": {     \"Tier\": {       \"title\": \"Tier\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"info\",         \"warning\",         \"error\"       ]     },     \"LogEntry\": {       \"title\": \"LogEntry\",       \"type\": \"object\",       \"properties\": {         \"seq\": {           \"title\": \"Seq\",           \"description\": \"Sequence number for this entry. Each entry has a unique sequence number which monotonically increase, until integer overflow causes a wrap around.\",           \"exclusiveMaximum\": 4294967296,           \"minimum\": 0,           \"type\": \"integer\"         },         \"tier\": {           \"description\": \"The importance level of the log entry\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Tier\"             }           ]         },         \"unix_millis_time\": {           \"title\": \"Unix Millis Time\",           \"type\": \"integer\"         },         \"text\": {           \"title\": \"Text\",           \"description\": \"The text of the log entry\",           \"type\": \"string\"         }       },       \"required\": [         \"seq\",         \"tier\",         \"unix_millis_time\",         \"text\"       ]     }   } } ```   ### /scheduler/robot_zone_info   ``` {   \"title\": \"CAGRobotInfo\",   \"type\": \"object\",   \"properties\": {     \"info\": {       \"title\": \"Info\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Fleet\"       }     }   },   \"required\": [     \"info\"   ],   \"definitions\": {     \"CleanAction\": {       \"title\": \"CleanAction\",       \"type\": \"object\",       \"properties\": {         \"clean_action\": {           \"title\": \"Clean Action\",           \"default\": \"\",           \"type\": \"string\"         },         \"duration\": {           \"title\": \"Duration\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 18446744073709551615,           \"type\": \"integer\"         }       },       \"required\": [         \"clean_action\",         \"duration\"       ]     },     \"Zone\": {       \"title\": \"Zone\",       \"type\": \"object\",       \"properties\": {         \"zone_name\": {           \"title\": \"Zone Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"clean_actions\": {           \"title\": \"Clean Actions\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/CleanAction\"           }         }       },       \"required\": [         \"zone_name\",         \"clean_actions\"       ]     },     \"Fleet\": {       \"title\": \"Fleet\",       \"type\": \"object\",       \"properties\": {         \"fleet_name\": {           \"title\": \"Fleet Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"ui_fleet_name\": {           \"title\": \"Ui Fleet Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"ui_robot_names\": {           \"title\": \"Ui Robot Names\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"robots\": {           \"title\": \"Robots\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"zones\": {           \"title\": \"Zones\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Zone\"           }         }       },       \"required\": [         \"fleet_name\",         \"ui_fleet_name\",         \"ui_robot_names\",         \"robots\",         \"zones\"       ]     }   } } ```
         * @summary Socket.io endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lambdaSocketIoGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/socket.io";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
var DefaultApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get the effective permissions of the current user
         * @summary Get Effective Permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectivePermissionsPermissionsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEffectivePermissionsPermissionsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get the current rmf time in unix milliseconds
         * @summary Get Time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTimeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTimeTimeGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get the currently logged in user
         * @summary Get User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUserGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUserUserGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *  # NOTE: This endpoint is here for documentation purposes only, this is _not_ a REST endpoint.  ## About This exposes a minimal pubsub system built on top of socket.io. It works similar to a normal socket.io endpoint, except that are 2 special rooms which control subscriptions.  ## Rooms ### subscribe Clients must send a message to this room to start receiving messages on other rooms. The message must be of the form:  ``` {     \"room\": \"<room_name>\" } ```  ### unsubscribe Clients can send a message to this room to stop receiving messages on other rooms. The message must be of the form:  ``` {     \"room\": \"<room_name>\" } ```              ### /alerts   ``` {   \"title\": \"Alert\",   \"description\": \"General alert that can be triggered by events.\",   \"type\": \"object\",   \"properties\": {     \"id\": {       \"title\": \"Id\",       \"maxLength\": 255,       \"type\": \"string\"     },     \"original_id\": {       \"title\": \"Original Id\",       \"maxLength\": 255,       \"type\": \"string\"     },     \"category\": {       \"title\": \"Category\",       \"description\": \"Default: default<br/>Task: task<br/>Fleet: fleet<br/>Robot: robot<br/>Maintain: maintain\",       \"maxLength\": 8,       \"type\": \"string\"     },     \"message\": {       \"title\": \"Message\",       \"maxLength\": 500,       \"nullable\": true,       \"type\": \"string\"     },     \"unix_millis_created_time\": {       \"title\": \"Unix Millis Created Time\",       \"minimum\": -9223372036854775808,       \"maximum\": 9223372036854775807,       \"type\": \"integer\"     },     \"acknowledged_by\": {       \"title\": \"Acknowledged By\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"unix_millis_acknowledged_time\": {       \"title\": \"Unix Millis Acknowledged Time\",       \"minimum\": -9223372036854775808,       \"maximum\": 9223372036854775807,       \"nullable\": true,       \"type\": \"integer\"     }   },   \"required\": [     \"id\",     \"original_id\",     \"category\",     \"unix_millis_created_time\"   ],   \"additionalProperties\": false } ```   ### /beacons   ``` {   \"title\": \"BeaconState\",   \"type\": \"object\",   \"properties\": {     \"id\": {       \"title\": \"Id\",       \"maxLength\": 255,       \"type\": \"string\"     },     \"online\": {       \"title\": \"Online\",       \"type\": \"boolean\"     },     \"category\": {       \"title\": \"Category\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"activated\": {       \"title\": \"Activated\",       \"type\": \"boolean\"     },     \"level\": {       \"title\": \"Level\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     }   },   \"required\": [     \"id\",     \"online\",     \"activated\"   ],   \"additionalProperties\": false } ```   ### /building_map   ``` {   \"title\": \"BuildingMap\",   \"type\": \"object\",   \"properties\": {     \"name\": {       \"title\": \"Name\",       \"default\": \"\",       \"type\": \"string\"     },     \"levels\": {       \"title\": \"Levels\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Level\"       }     },     \"lifts\": {       \"title\": \"Lifts\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Lift\"       }     }   },   \"required\": [     \"name\",     \"levels\",     \"lifts\"   ],   \"definitions\": {     \"AffineImage\": {       \"title\": \"AffineImage\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"x_offset\": {           \"title\": \"X Offset\",           \"default\": 0,           \"type\": \"number\"         },         \"y_offset\": {           \"title\": \"Y Offset\",           \"default\": 0,           \"type\": \"number\"         },         \"yaw\": {           \"title\": \"Yaw\",           \"default\": 0,           \"type\": \"number\"         },         \"scale\": {           \"title\": \"Scale\",           \"default\": 0,           \"type\": \"number\"         },         \"encoding\": {           \"title\": \"Encoding\",           \"default\": \"\",           \"type\": \"string\"         },         \"data\": {           \"title\": \"Data\",           \"type\": \"string\"         }       },       \"required\": [         \"name\",         \"x_offset\",         \"y_offset\",         \"yaw\",         \"scale\",         \"encoding\",         \"data\"       ]     },     \"Place\": {       \"title\": \"Place\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"x\": {           \"title\": \"X\",           \"default\": 0,           \"type\": \"number\"         },         \"y\": {           \"title\": \"Y\",           \"default\": 0,           \"type\": \"number\"         },         \"yaw\": {           \"title\": \"Yaw\",           \"default\": 0,           \"type\": \"number\"         },         \"position_tolerance\": {           \"title\": \"Position Tolerance\",           \"default\": 0,           \"type\": \"number\"         },         \"yaw_tolerance\": {           \"title\": \"Yaw Tolerance\",           \"default\": 0,           \"type\": \"number\"         }       },       \"required\": [         \"name\",         \"x\",         \"y\",         \"yaw\",         \"position_tolerance\",         \"yaw_tolerance\"       ]     },     \"Door\": {       \"title\": \"Door\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"v1_x\": {           \"title\": \"V1 X\",           \"default\": 0,           \"type\": \"number\"         },         \"v1_y\": {           \"title\": \"V1 Y\",           \"default\": 0,           \"type\": \"number\"         },         \"v2_x\": {           \"title\": \"V2 X\",           \"default\": 0,           \"type\": \"number\"         },         \"v2_y\": {           \"title\": \"V2 Y\",           \"default\": 0,           \"type\": \"number\"         },         \"door_type\": {           \"title\": \"Door Type\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 255,           \"type\": \"integer\"         },         \"motion_range\": {           \"title\": \"Motion Range\",           \"default\": 0,           \"type\": \"number\"         },         \"motion_direction\": {           \"title\": \"Motion Direction\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         }       },       \"required\": [         \"name\",         \"v1_x\",         \"v1_y\",         \"v2_x\",         \"v2_y\",         \"door_type\",         \"motion_range\",         \"motion_direction\"       ]     },     \"Param\": {       \"title\": \"Param\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"type\": {           \"title\": \"Type\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         },         \"value_int\": {           \"title\": \"Value Int\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"value_float\": {           \"title\": \"Value Float\",           \"default\": 0,           \"type\": \"number\"         },         \"value_string\": {           \"title\": \"Value String\",           \"default\": \"\",           \"type\": \"string\"         },         \"value_bool\": {           \"title\": \"Value Bool\",           \"default\": false,           \"type\": \"boolean\"         }       },       \"required\": [         \"name\",         \"type\",         \"value_int\",         \"value_float\",         \"value_string\",         \"value_bool\"       ]     },     \"GraphNode\": {       \"title\": \"GraphNode\",       \"type\": \"object\",       \"properties\": {         \"x\": {           \"title\": \"X\",           \"default\": 0,           \"type\": \"number\"         },         \"y\": {           \"title\": \"Y\",           \"default\": 0,           \"type\": \"number\"         },         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"params\": {           \"title\": \"Params\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Param\"           }         }       },       \"required\": [         \"x\",         \"y\",         \"name\",         \"params\"       ]     },     \"GraphEdge\": {       \"title\": \"GraphEdge\",       \"type\": \"object\",       \"properties\": {         \"v1_idx\": {           \"title\": \"V1 Idx\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         },         \"v2_idx\": {           \"title\": \"V2 Idx\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         },         \"params\": {           \"title\": \"Params\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Param\"           }         },         \"edge_type\": {           \"title\": \"Edge Type\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 255,           \"type\": \"integer\"         }       },       \"required\": [         \"v1_idx\",         \"v2_idx\",         \"params\",         \"edge_type\"       ]     },     \"Graph\": {       \"title\": \"Graph\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"vertices\": {           \"title\": \"Vertices\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/GraphNode\"           }         },         \"edges\": {           \"title\": \"Edges\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/GraphEdge\"           }         },         \"params\": {           \"title\": \"Params\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Param\"           }         }       },       \"required\": [         \"name\",         \"vertices\",         \"edges\",         \"params\"       ]     },     \"Level\": {       \"title\": \"Level\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"elevation\": {           \"title\": \"Elevation\",           \"default\": 0,           \"type\": \"number\"         },         \"images\": {           \"title\": \"Images\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/AffineImage\"           }         },         \"places\": {           \"title\": \"Places\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Place\"           }         },         \"doors\": {           \"title\": \"Doors\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Door\"           }         },         \"nav_graphs\": {           \"title\": \"Nav Graphs\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Graph\"           }         },         \"wall_graph\": {           \"title\": \"Wall Graph\",           \"default\": {             \"name\": \"\",             \"vertices\": [],             \"edges\": [],             \"params\": []           },           \"allOf\": [             {               \"$ref\": \"#/definitions/Graph\"             }           ]         }       },       \"required\": [         \"name\",         \"elevation\",         \"images\",         \"places\",         \"doors\",         \"nav_graphs\",         \"wall_graph\"       ]     },     \"Lift\": {       \"title\": \"Lift\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"levels\": {           \"title\": \"Levels\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"doors\": {           \"title\": \"Doors\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Door\"           }         },         \"wall_graph\": {           \"title\": \"Wall Graph\",           \"default\": {             \"name\": \"\",             \"vertices\": [],             \"edges\": [],             \"params\": []           },           \"allOf\": [             {               \"$ref\": \"#/definitions/Graph\"             }           ]         },         \"ref_x\": {           \"title\": \"Ref X\",           \"default\": 0,           \"type\": \"number\"         },         \"ref_y\": {           \"title\": \"Ref Y\",           \"default\": 0,           \"type\": \"number\"         },         \"ref_yaw\": {           \"title\": \"Ref Yaw\",           \"default\": 0,           \"type\": \"number\"         },         \"width\": {           \"title\": \"Width\",           \"default\": 0,           \"type\": \"number\"         },         \"depth\": {           \"title\": \"Depth\",           \"default\": 0,           \"type\": \"number\"         }       },       \"required\": [         \"name\",         \"levels\",         \"doors\",         \"wall_graph\",         \"ref_x\",         \"ref_y\",         \"ref_yaw\",         \"width\",         \"depth\"       ]     }   } } ```   ### /doors/{door_name}/state   ``` {   \"title\": \"DoorState\",   \"type\": \"object\",   \"properties\": {     \"door_time\": {       \"title\": \"Door Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"door_name\": {       \"title\": \"Door Name\",       \"default\": \"\",       \"type\": \"string\"     },     \"current_mode\": {       \"title\": \"Current Mode\",       \"default\": {         \"value\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/DoorMode\"         }       ]     }   },   \"required\": [     \"door_time\",     \"door_name\",     \"current_mode\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     },     \"DoorMode\": {       \"title\": \"DoorMode\",       \"type\": \"object\",       \"properties\": {         \"value\": {           \"title\": \"Value\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"value\"       ]     }   } } ```   ### /doors/{door_name}/health   ``` {   \"title\": \"DoorHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /lifts/{lift_name}/state   ``` {   \"title\": \"LiftState\",   \"type\": \"object\",   \"properties\": {     \"lift_time\": {       \"title\": \"Lift Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"lift_name\": {       \"title\": \"Lift Name\",       \"default\": \"\",       \"type\": \"string\"     },     \"available_floors\": {       \"title\": \"Available Floors\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"type\": \"string\"       }     },     \"current_floor\": {       \"title\": \"Current Floor\",       \"default\": \"\",       \"type\": \"string\"     },     \"destination_floor\": {       \"title\": \"Destination Floor\",       \"default\": \"\",       \"type\": \"string\"     },     \"door_state\": {       \"title\": \"Door State\",       \"default\": 0,       \"minimum\": 0,       \"maximum\": 255,       \"type\": \"integer\"     },     \"motion_state\": {       \"title\": \"Motion State\",       \"default\": 0,       \"minimum\": 0,       \"maximum\": 255,       \"type\": \"integer\"     },     \"available_modes\": {       \"title\": \"Available Modes\",       \"type\": \"array\",       \"items\": {         \"type\": \"integer\"       }     },     \"current_mode\": {       \"title\": \"Current Mode\",       \"default\": 0,       \"minimum\": 0,       \"maximum\": 255,       \"type\": \"integer\"     },     \"session_id\": {       \"title\": \"Session Id\",       \"default\": \"\",       \"type\": \"string\"     }   },   \"required\": [     \"lift_time\",     \"lift_name\",     \"available_floors\",     \"current_floor\",     \"destination_floor\",     \"door_state\",     \"motion_state\",     \"available_modes\",     \"current_mode\",     \"session_id\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     }   } } ```   ### /lifts/{lift_name}/health   ``` {   \"title\": \"LiftHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /tasks/{task_id}/state   ``` {   \"title\": \"TaskState\",   \"type\": \"object\",   \"properties\": {     \"booking\": {       \"$ref\": \"#/definitions/Booking\"     },     \"category\": {       \"$ref\": \"#/definitions/Category\"     },     \"detail\": {       \"$ref\": \"#/definitions/Detail\"     },     \"unix_millis_start_time\": {       \"title\": \"Unix Millis Start Time\",       \"type\": \"integer\"     },     \"unix_millis_finish_time\": {       \"title\": \"Unix Millis Finish Time\",       \"type\": \"integer\"     },     \"original_estimate_millis\": {       \"$ref\": \"#/definitions/EstimateMillis\"     },     \"estimate_millis\": {       \"$ref\": \"#/definitions/EstimateMillis\"     },     \"assigned_to\": {       \"title\": \"Assigned To\",       \"description\": \"Which agent (robot) is the task assigned to\",       \"allOf\": [         {           \"$ref\": \"#/definitions/AssignedTo\"         }       ]     },     \"status\": {       \"$ref\": \"#/definitions/Status\"     },     \"dispatch\": {       \"$ref\": \"#/definitions/Dispatch\"     },     \"phases\": {       \"title\": \"Phases\",       \"description\": \"A dictionary of the states of the phases of the task. The keys (property names) are phase IDs, which are integers.\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/Phase\"       }     },     \"completed\": {       \"title\": \"Completed\",       \"description\": \"An array of the IDs of completed phases of this task\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Id\"       }     },     \"active\": {       \"title\": \"Active\",       \"description\": \"The ID of the active phase for this task\",       \"allOf\": [         {           \"$ref\": \"#/definitions/Id\"         }       ]     },     \"pending\": {       \"title\": \"Pending\",       \"description\": \"An array of the pending phases of this task\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Id\"       }     },     \"interruptions\": {       \"title\": \"Interruptions\",       \"description\": \"A dictionary of interruptions that have been applied to this task. The keys (property names) are the unique token of the interruption request.\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/Interruption\"       }     },     \"cancellation\": {       \"title\": \"Cancellation\",       \"description\": \"If the task was cancelled, this will describe information about the request.\",       \"allOf\": [         {           \"$ref\": \"#/definitions/Cancellation\"         }       ]     },     \"killed\": {       \"title\": \"Killed\",       \"description\": \"If the task was killed, this will describe information about the request.\",       \"allOf\": [         {           \"$ref\": \"#/definitions/Killed\"         }       ]     }   },   \"required\": [     \"booking\"   ],   \"definitions\": {     \"Booking\": {       \"title\": \"Booking\",       \"type\": \"object\",       \"properties\": {         \"id\": {           \"title\": \"Id\",           \"description\": \"The unique identifier for this task\",           \"type\": \"string\"         },         \"unix_millis_earliest_start_time\": {           \"title\": \"Unix Millis Earliest Start Time\",           \"type\": \"integer\"         },         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"type\": \"integer\"         },         \"priority\": {           \"title\": \"Priority\",           \"description\": \"Priority information about this task\",           \"anyOf\": [             {               \"type\": \"object\"             },             {               \"type\": \"string\"             }           ]         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Information about how and why this task was booked\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"requester\": {           \"title\": \"Requester\",           \"description\": \"(Optional) An identifier for the entity that requested this task\",           \"type\": \"string\"         }       },       \"required\": [         \"id\"       ]     },     \"Category\": {       \"title\": \"Category\",       \"description\": \"The category of this task or phase\",       \"type\": \"string\"     },     \"Detail\": {       \"title\": \"Detail\",       \"description\": \"Detailed information about a task, phase, or event\",       \"anyOf\": [         {           \"type\": \"object\"         },         {           \"type\": \"array\",           \"items\": {}         },         {           \"type\": \"string\"         }       ]     },     \"EstimateMillis\": {       \"title\": \"EstimateMillis\",       \"description\": \"An estimate, in milliseconds, of how long the subject will take to complete\",       \"minimum\": 0,       \"type\": \"integer\"     },     \"AssignedTo\": {       \"title\": \"AssignedTo\",       \"type\": \"object\",       \"properties\": {         \"group\": {           \"title\": \"Group\",           \"type\": \"string\"         },         \"name\": {           \"title\": \"Name\",           \"type\": \"string\"         }       },       \"required\": [         \"group\",         \"name\"       ]     },     \"Status\": {       \"title\": \"Status\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"blocked\",         \"error\",         \"failed\",         \"queued\",         \"standby\",         \"underway\",         \"delayed\",         \"skipped\",         \"canceled\",         \"killed\",         \"completed\"       ]     },     \"Status1\": {       \"title\": \"Status1\",       \"description\": \"An enumeration.\",       \"enum\": [         \"queued\",         \"selected\",         \"dispatched\",         \"failed_to_assign\",         \"canceled_in_flight\"       ]     },     \"Assignment\": {       \"title\": \"Assignment\",       \"type\": \"object\",       \"properties\": {         \"fleet_name\": {           \"title\": \"Fleet Name\",           \"type\": \"string\"         },         \"expected_robot_name\": {           \"title\": \"Expected Robot Name\",           \"type\": \"string\"         }       }     },     \"Error\": {       \"title\": \"Error\",       \"type\": \"object\",       \"properties\": {         \"code\": {           \"title\": \"Code\",           \"description\": \"A standard code for the kind of error that has occurred\",           \"minimum\": 0,           \"type\": \"integer\"         },         \"category\": {           \"title\": \"Category\",           \"description\": \"The category of the error\",           \"type\": \"string\"         },         \"detail\": {           \"title\": \"Detail\",           \"description\": \"Details about the error\",           \"type\": \"string\"         }       }     },     \"Dispatch\": {       \"title\": \"Dispatch\",       \"type\": \"object\",       \"properties\": {         \"status\": {           \"$ref\": \"#/definitions/Status1\"         },         \"assignment\": {           \"$ref\": \"#/definitions/Assignment\"         },         \"errors\": {           \"title\": \"Errors\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Error\"           }         }       },       \"required\": [         \"status\"       ]     },     \"Id\": {       \"title\": \"Id\",       \"minimum\": 0,       \"type\": \"integer\"     },     \"EventState\": {       \"title\": \"EventState\",       \"type\": \"object\",       \"properties\": {         \"id\": {           \"$ref\": \"#/definitions/Id\"         },         \"status\": {           \"$ref\": \"#/definitions/Status\"         },         \"name\": {           \"title\": \"Name\",           \"description\": \"The brief name of the event\",           \"type\": \"string\"         },         \"detail\": {           \"title\": \"Detail\",           \"description\": \"Detailed information about the event\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Detail\"             }           ]         },         \"deps\": {           \"title\": \"Deps\",           \"description\": \"This event may depend on other events. This array contains the IDs of those other event dependencies.\",           \"type\": \"array\",           \"items\": {             \"type\": \"integer\",             \"minimum\": 0           }         }       },       \"required\": [         \"id\"       ]     },     \"Undo\": {       \"title\": \"Undo\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the undo skip request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the undo skip request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"SkipPhaseRequest\": {       \"title\": \"SkipPhaseRequest\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the skip request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the purpose of the skip request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"undo\": {           \"title\": \"Undo\",           \"description\": \"Information about an undo skip request that applied to this request\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Undo\"             }           ]         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"Phase\": {       \"title\": \"Phase\",       \"type\": \"object\",       \"properties\": {         \"id\": {           \"$ref\": \"#/definitions/Id\"         },         \"category\": {           \"$ref\": \"#/definitions/Category\"         },         \"detail\": {           \"$ref\": \"#/definitions/Detail\"         },         \"unix_millis_start_time\": {           \"title\": \"Unix Millis Start Time\",           \"type\": \"integer\"         },         \"unix_millis_finish_time\": {           \"title\": \"Unix Millis Finish Time\",           \"type\": \"integer\"         },         \"original_estimate_millis\": {           \"$ref\": \"#/definitions/EstimateMillis\"         },         \"estimate_millis\": {           \"$ref\": \"#/definitions/EstimateMillis\"         },         \"final_event_id\": {           \"$ref\": \"#/definitions/Id\"         },         \"events\": {           \"title\": \"Events\",           \"description\": \"A dictionary of events for this phase. The keys (property names) are the event IDs, which are integers.\",           \"type\": \"object\",           \"additionalProperties\": {             \"$ref\": \"#/definitions/EventState\"           }         },         \"skip_requests\": {           \"title\": \"Skip Requests\",           \"description\": \"Information about any skip requests that have been received\",           \"type\": \"object\",           \"additionalProperties\": {             \"$ref\": \"#/definitions/SkipPhaseRequest\"           }         }       },       \"required\": [         \"id\"       ]     },     \"ResumedBy\": {       \"title\": \"ResumedBy\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the resume request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the resume request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"labels\"       ]     },     \"Interruption\": {       \"title\": \"Interruption\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the interruption request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the purpose of the interruption\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"resumed_by\": {           \"title\": \"Resumed By\",           \"description\": \"Information about the resume request that ended this interruption. This field will be missing if the interruption is still active.\",           \"allOf\": [             {               \"$ref\": \"#/definitions/ResumedBy\"             }           ]         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"Cancellation\": {       \"title\": \"Cancellation\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the cancellation request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the cancel request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"Killed\": {       \"title\": \"Killed\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the cancellation request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the kill request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     }   } } ```   ### /tasks/{task_id}/log   ``` {   \"title\": \"TaskEventLog\",   \"type\": \"object\",   \"properties\": {     \"task_id\": {       \"title\": \"Task Id\",       \"type\": \"string\"     },     \"log\": {       \"title\": \"Log\",       \"description\": \"Log entries related to the overall task\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/LogEntry\"       }     },     \"phases\": {       \"title\": \"Phases\",       \"description\": \"A dictionary whose keys (property names) are the indices of a phase\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/Phases\"       }     }   },   \"required\": [     \"task_id\"   ],   \"additionalProperties\": false,   \"definitions\": {     \"Tier\": {       \"title\": \"Tier\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"info\",         \"warning\",         \"error\"       ]     },     \"LogEntry\": {       \"title\": \"LogEntry\",       \"type\": \"object\",       \"properties\": {         \"seq\": {           \"title\": \"Seq\",           \"description\": \"Sequence number for this entry. Each entry has a unique sequence number which monotonically increase, until integer overflow causes a wrap around.\",           \"exclusiveMaximum\": 4294967296,           \"minimum\": 0,           \"type\": \"integer\"         },         \"tier\": {           \"description\": \"The importance level of the log entry\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Tier\"             }           ]         },         \"unix_millis_time\": {           \"title\": \"Unix Millis Time\",           \"type\": \"integer\"         },         \"text\": {           \"title\": \"Text\",           \"description\": \"The text of the log entry\",           \"type\": \"string\"         }       },       \"required\": [         \"seq\",         \"tier\",         \"unix_millis_time\",         \"text\"       ]     },     \"Phases\": {       \"title\": \"Phases\",       \"type\": \"object\",       \"properties\": {         \"log\": {           \"title\": \"Log\",           \"description\": \"Log entries related to the overall phase\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/LogEntry\"           }         },         \"events\": {           \"title\": \"Events\",           \"description\": \"A dictionary whose keys (property names) are the indices of an event in the phase\",           \"type\": \"object\",           \"additionalProperties\": {             \"type\": \"array\",             \"items\": {               \"$ref\": \"#/definitions/LogEntry\"             }           }         }       },       \"additionalProperties\": false     }   } } ```   ### /dispensers/{guid}/state   ``` {   \"title\": \"DispenserState\",   \"type\": \"object\",   \"properties\": {     \"time\": {       \"title\": \"Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"guid\": {       \"title\": \"Guid\",       \"default\": \"\",       \"type\": \"string\"     },     \"mode\": {       \"title\": \"Mode\",       \"default\": 0,       \"minimum\": -2147483648,       \"maximum\": 2147483647,       \"type\": \"integer\"     },     \"request_guid_queue\": {       \"title\": \"Request Guid Queue\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"type\": \"string\"       }     },     \"seconds_remaining\": {       \"title\": \"Seconds Remaining\",       \"default\": 0,       \"type\": \"number\"     }   },   \"required\": [     \"time\",     \"guid\",     \"mode\",     \"request_guid_queue\",     \"seconds_remaining\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     }   } } ```   ### /dispensers/{guid}/health   ``` {   \"title\": \"DispenserHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /ingestors/{guid}/state   ``` {   \"title\": \"IngestorState\",   \"type\": \"object\",   \"properties\": {     \"time\": {       \"title\": \"Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"guid\": {       \"title\": \"Guid\",       \"default\": \"\",       \"type\": \"string\"     },     \"mode\": {       \"title\": \"Mode\",       \"default\": 0,       \"minimum\": -2147483648,       \"maximum\": 2147483647,       \"type\": \"integer\"     },     \"request_guid_queue\": {       \"title\": \"Request Guid Queue\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"type\": \"string\"       }     },     \"seconds_remaining\": {       \"title\": \"Seconds Remaining\",       \"default\": 0,       \"type\": \"number\"     }   },   \"required\": [     \"time\",     \"guid\",     \"mode\",     \"request_guid_queue\",     \"seconds_remaining\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     }   } } ```   ### /ingestors/{guid}/health   ``` {   \"title\": \"IngestorHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /fleets/{name}/state   ``` {   \"title\": \"FleetState\",   \"type\": \"object\",   \"properties\": {     \"name\": {       \"title\": \"Name\",       \"type\": \"string\"     },     \"robots\": {       \"title\": \"Robots\",       \"description\": \"A dictionary of the states of the robots that belong to this fleet\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/RobotState\"       }     }   },   \"definitions\": {     \"Status2\": {       \"title\": \"Status2\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"offline\",         \"shutdown\",         \"idle\",         \"charging\",         \"working\",         \"error\"       ]     },     \"Location2D\": {       \"title\": \"Location2D\",       \"type\": \"object\",       \"properties\": {         \"map\": {           \"title\": \"Map\",           \"type\": \"string\"         },         \"x\": {           \"title\": \"X\",           \"type\": \"number\"         },         \"y\": {           \"title\": \"Y\",           \"type\": \"number\"         },         \"yaw\": {           \"title\": \"Yaw\",           \"type\": \"number\"         }       },       \"required\": [         \"map\",         \"x\",         \"y\",         \"yaw\"       ]     },     \"Issue\": {       \"title\": \"Issue\",       \"type\": \"object\",       \"properties\": {         \"category\": {           \"title\": \"Category\",           \"description\": \"Category of the robot\'s issue\",           \"type\": \"string\"         },         \"detail\": {           \"title\": \"Detail\",           \"description\": \"Detailed information about the issue\",           \"anyOf\": [             {               \"type\": \"object\"             },             {               \"type\": \"array\",               \"items\": {}             },             {               \"type\": \"string\"             }           ]         }       }     },     \"RobotState\": {       \"title\": \"RobotState\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"type\": \"string\"         },         \"status\": {           \"description\": \"A simple token representing the status of the robot\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Status2\"             }           ]         },         \"task_id\": {           \"title\": \"Task Id\",           \"description\": \"The ID of the task this robot is currently working on. Empty string if the robot is not working on a task.\",           \"type\": \"string\"         },         \"unix_millis_time\": {           \"title\": \"Unix Millis Time\",           \"type\": \"integer\"         },         \"location\": {           \"$ref\": \"#/definitions/Location2D\"         },         \"battery\": {           \"title\": \"Battery\",           \"description\": \"State of charge of the battery. Values range from 0.0 (depleted) to 1.0 (fully charged)\",           \"minimum\": 0.0,           \"maximum\": 1.0,           \"type\": \"number\"         },         \"issues\": {           \"title\": \"Issues\",           \"description\": \"A list of issues with the robot that operators need to address\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Issue\"           }         }       }     }   } } ```   ### /fleets/{name}/log   ``` {   \"title\": \"FleetState\",   \"type\": \"object\",   \"properties\": {     \"name\": {       \"title\": \"Name\",       \"type\": \"string\"     },     \"log\": {       \"title\": \"Log\",       \"description\": \"Log for the overall fleet\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/LogEntry\"       }     },     \"robots\": {       \"title\": \"Robots\",       \"description\": \"Dictionary of logs for the individual robots. The keys (property names) are the robot names.\",       \"type\": \"object\",       \"additionalProperties\": {         \"type\": \"array\",         \"items\": {           \"$ref\": \"#/definitions/LogEntry\"         }       }     }   },   \"definitions\": {     \"Tier\": {       \"title\": \"Tier\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"info\",         \"warning\",         \"error\"       ]     },     \"LogEntry\": {       \"title\": \"LogEntry\",       \"type\": \"object\",       \"properties\": {         \"seq\": {           \"title\": \"Seq\",           \"description\": \"Sequence number for this entry. Each entry has a unique sequence number which monotonically increase, until integer overflow causes a wrap around.\",           \"exclusiveMaximum\": 4294967296,           \"minimum\": 0,           \"type\": \"integer\"         },         \"tier\": {           \"description\": \"The importance level of the log entry\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Tier\"             }           ]         },         \"unix_millis_time\": {           \"title\": \"Unix Millis Time\",           \"type\": \"integer\"         },         \"text\": {           \"title\": \"Text\",           \"description\": \"The text of the log entry\",           \"type\": \"string\"         }       },       \"required\": [         \"seq\",         \"tier\",         \"unix_millis_time\",         \"text\"       ]     }   } } ```   ### /scheduler/robot_zone_info   ``` {   \"title\": \"CAGRobotInfo\",   \"type\": \"object\",   \"properties\": {     \"info\": {       \"title\": \"Info\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Fleet\"       }     }   },   \"required\": [     \"info\"   ],   \"definitions\": {     \"CleanAction\": {       \"title\": \"CleanAction\",       \"type\": \"object\",       \"properties\": {         \"clean_action\": {           \"title\": \"Clean Action\",           \"default\": \"\",           \"type\": \"string\"         },         \"duration\": {           \"title\": \"Duration\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 18446744073709551615,           \"type\": \"integer\"         }       },       \"required\": [         \"clean_action\",         \"duration\"       ]     },     \"Zone\": {       \"title\": \"Zone\",       \"type\": \"object\",       \"properties\": {         \"zone_name\": {           \"title\": \"Zone Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"clean_actions\": {           \"title\": \"Clean Actions\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/CleanAction\"           }         }       },       \"required\": [         \"zone_name\",         \"clean_actions\"       ]     },     \"Fleet\": {       \"title\": \"Fleet\",       \"type\": \"object\",       \"properties\": {         \"fleet_name\": {           \"title\": \"Fleet Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"ui_fleet_name\": {           \"title\": \"Ui Fleet Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"ui_robot_names\": {           \"title\": \"Ui Robot Names\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"robots\": {           \"title\": \"Robots\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"zones\": {           \"title\": \"Zones\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Zone\"           }         }       },       \"required\": [         \"fleet_name\",         \"ui_fleet_name\",         \"ui_robot_names\",         \"robots\",         \"zones\"       ]     }   } } ```
         * @summary Socket.io endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lambdaSocketIoGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.lambdaSocketIoGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
var DefaultApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         * Get the effective permissions of the current user
         * @summary Get Effective Permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectivePermissionsPermissionsGet: function (options) {
            return localVarFp
                .getEffectivePermissionsPermissionsGet(options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the current rmf time in unix milliseconds
         * @summary Get Time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTimeGet: function (options) {
            return localVarFp.getTimeTimeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the currently logged in user
         * @summary Get User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUserGet: function (options) {
            return localVarFp.getUserUserGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *  # NOTE: This endpoint is here for documentation purposes only, this is _not_ a REST endpoint.  ## About This exposes a minimal pubsub system built on top of socket.io. It works similar to a normal socket.io endpoint, except that are 2 special rooms which control subscriptions.  ## Rooms ### subscribe Clients must send a message to this room to start receiving messages on other rooms. The message must be of the form:  ``` {     \"room\": \"<room_name>\" } ```  ### unsubscribe Clients can send a message to this room to stop receiving messages on other rooms. The message must be of the form:  ``` {     \"room\": \"<room_name>\" } ```              ### /alerts   ``` {   \"title\": \"Alert\",   \"description\": \"General alert that can be triggered by events.\",   \"type\": \"object\",   \"properties\": {     \"id\": {       \"title\": \"Id\",       \"maxLength\": 255,       \"type\": \"string\"     },     \"original_id\": {       \"title\": \"Original Id\",       \"maxLength\": 255,       \"type\": \"string\"     },     \"category\": {       \"title\": \"Category\",       \"description\": \"Default: default<br/>Task: task<br/>Fleet: fleet<br/>Robot: robot<br/>Maintain: maintain\",       \"maxLength\": 8,       \"type\": \"string\"     },     \"message\": {       \"title\": \"Message\",       \"maxLength\": 500,       \"nullable\": true,       \"type\": \"string\"     },     \"unix_millis_created_time\": {       \"title\": \"Unix Millis Created Time\",       \"minimum\": -9223372036854775808,       \"maximum\": 9223372036854775807,       \"type\": \"integer\"     },     \"acknowledged_by\": {       \"title\": \"Acknowledged By\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"unix_millis_acknowledged_time\": {       \"title\": \"Unix Millis Acknowledged Time\",       \"minimum\": -9223372036854775808,       \"maximum\": 9223372036854775807,       \"nullable\": true,       \"type\": \"integer\"     }   },   \"required\": [     \"id\",     \"original_id\",     \"category\",     \"unix_millis_created_time\"   ],   \"additionalProperties\": false } ```   ### /beacons   ``` {   \"title\": \"BeaconState\",   \"type\": \"object\",   \"properties\": {     \"id\": {       \"title\": \"Id\",       \"maxLength\": 255,       \"type\": \"string\"     },     \"online\": {       \"title\": \"Online\",       \"type\": \"boolean\"     },     \"category\": {       \"title\": \"Category\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"activated\": {       \"title\": \"Activated\",       \"type\": \"boolean\"     },     \"level\": {       \"title\": \"Level\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     }   },   \"required\": [     \"id\",     \"online\",     \"activated\"   ],   \"additionalProperties\": false } ```   ### /building_map   ``` {   \"title\": \"BuildingMap\",   \"type\": \"object\",   \"properties\": {     \"name\": {       \"title\": \"Name\",       \"default\": \"\",       \"type\": \"string\"     },     \"levels\": {       \"title\": \"Levels\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Level\"       }     },     \"lifts\": {       \"title\": \"Lifts\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Lift\"       }     }   },   \"required\": [     \"name\",     \"levels\",     \"lifts\"   ],   \"definitions\": {     \"AffineImage\": {       \"title\": \"AffineImage\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"x_offset\": {           \"title\": \"X Offset\",           \"default\": 0,           \"type\": \"number\"         },         \"y_offset\": {           \"title\": \"Y Offset\",           \"default\": 0,           \"type\": \"number\"         },         \"yaw\": {           \"title\": \"Yaw\",           \"default\": 0,           \"type\": \"number\"         },         \"scale\": {           \"title\": \"Scale\",           \"default\": 0,           \"type\": \"number\"         },         \"encoding\": {           \"title\": \"Encoding\",           \"default\": \"\",           \"type\": \"string\"         },         \"data\": {           \"title\": \"Data\",           \"type\": \"string\"         }       },       \"required\": [         \"name\",         \"x_offset\",         \"y_offset\",         \"yaw\",         \"scale\",         \"encoding\",         \"data\"       ]     },     \"Place\": {       \"title\": \"Place\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"x\": {           \"title\": \"X\",           \"default\": 0,           \"type\": \"number\"         },         \"y\": {           \"title\": \"Y\",           \"default\": 0,           \"type\": \"number\"         },         \"yaw\": {           \"title\": \"Yaw\",           \"default\": 0,           \"type\": \"number\"         },         \"position_tolerance\": {           \"title\": \"Position Tolerance\",           \"default\": 0,           \"type\": \"number\"         },         \"yaw_tolerance\": {           \"title\": \"Yaw Tolerance\",           \"default\": 0,           \"type\": \"number\"         }       },       \"required\": [         \"name\",         \"x\",         \"y\",         \"yaw\",         \"position_tolerance\",         \"yaw_tolerance\"       ]     },     \"Door\": {       \"title\": \"Door\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"v1_x\": {           \"title\": \"V1 X\",           \"default\": 0,           \"type\": \"number\"         },         \"v1_y\": {           \"title\": \"V1 Y\",           \"default\": 0,           \"type\": \"number\"         },         \"v2_x\": {           \"title\": \"V2 X\",           \"default\": 0,           \"type\": \"number\"         },         \"v2_y\": {           \"title\": \"V2 Y\",           \"default\": 0,           \"type\": \"number\"         },         \"door_type\": {           \"title\": \"Door Type\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 255,           \"type\": \"integer\"         },         \"motion_range\": {           \"title\": \"Motion Range\",           \"default\": 0,           \"type\": \"number\"         },         \"motion_direction\": {           \"title\": \"Motion Direction\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         }       },       \"required\": [         \"name\",         \"v1_x\",         \"v1_y\",         \"v2_x\",         \"v2_y\",         \"door_type\",         \"motion_range\",         \"motion_direction\"       ]     },     \"Param\": {       \"title\": \"Param\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"type\": {           \"title\": \"Type\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         },         \"value_int\": {           \"title\": \"Value Int\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"value_float\": {           \"title\": \"Value Float\",           \"default\": 0,           \"type\": \"number\"         },         \"value_string\": {           \"title\": \"Value String\",           \"default\": \"\",           \"type\": \"string\"         },         \"value_bool\": {           \"title\": \"Value Bool\",           \"default\": false,           \"type\": \"boolean\"         }       },       \"required\": [         \"name\",         \"type\",         \"value_int\",         \"value_float\",         \"value_string\",         \"value_bool\"       ]     },     \"GraphNode\": {       \"title\": \"GraphNode\",       \"type\": \"object\",       \"properties\": {         \"x\": {           \"title\": \"X\",           \"default\": 0,           \"type\": \"number\"         },         \"y\": {           \"title\": \"Y\",           \"default\": 0,           \"type\": \"number\"         },         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"params\": {           \"title\": \"Params\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Param\"           }         }       },       \"required\": [         \"x\",         \"y\",         \"name\",         \"params\"       ]     },     \"GraphEdge\": {       \"title\": \"GraphEdge\",       \"type\": \"object\",       \"properties\": {         \"v1_idx\": {           \"title\": \"V1 Idx\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         },         \"v2_idx\": {           \"title\": \"V2 Idx\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         },         \"params\": {           \"title\": \"Params\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Param\"           }         },         \"edge_type\": {           \"title\": \"Edge Type\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 255,           \"type\": \"integer\"         }       },       \"required\": [         \"v1_idx\",         \"v2_idx\",         \"params\",         \"edge_type\"       ]     },     \"Graph\": {       \"title\": \"Graph\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"vertices\": {           \"title\": \"Vertices\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/GraphNode\"           }         },         \"edges\": {           \"title\": \"Edges\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/GraphEdge\"           }         },         \"params\": {           \"title\": \"Params\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Param\"           }         }       },       \"required\": [         \"name\",         \"vertices\",         \"edges\",         \"params\"       ]     },     \"Level\": {       \"title\": \"Level\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"elevation\": {           \"title\": \"Elevation\",           \"default\": 0,           \"type\": \"number\"         },         \"images\": {           \"title\": \"Images\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/AffineImage\"           }         },         \"places\": {           \"title\": \"Places\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Place\"           }         },         \"doors\": {           \"title\": \"Doors\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Door\"           }         },         \"nav_graphs\": {           \"title\": \"Nav Graphs\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Graph\"           }         },         \"wall_graph\": {           \"title\": \"Wall Graph\",           \"default\": {             \"name\": \"\",             \"vertices\": [],             \"edges\": [],             \"params\": []           },           \"allOf\": [             {               \"$ref\": \"#/definitions/Graph\"             }           ]         }       },       \"required\": [         \"name\",         \"elevation\",         \"images\",         \"places\",         \"doors\",         \"nav_graphs\",         \"wall_graph\"       ]     },     \"Lift\": {       \"title\": \"Lift\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"levels\": {           \"title\": \"Levels\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"doors\": {           \"title\": \"Doors\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Door\"           }         },         \"wall_graph\": {           \"title\": \"Wall Graph\",           \"default\": {             \"name\": \"\",             \"vertices\": [],             \"edges\": [],             \"params\": []           },           \"allOf\": [             {               \"$ref\": \"#/definitions/Graph\"             }           ]         },         \"ref_x\": {           \"title\": \"Ref X\",           \"default\": 0,           \"type\": \"number\"         },         \"ref_y\": {           \"title\": \"Ref Y\",           \"default\": 0,           \"type\": \"number\"         },         \"ref_yaw\": {           \"title\": \"Ref Yaw\",           \"default\": 0,           \"type\": \"number\"         },         \"width\": {           \"title\": \"Width\",           \"default\": 0,           \"type\": \"number\"         },         \"depth\": {           \"title\": \"Depth\",           \"default\": 0,           \"type\": \"number\"         }       },       \"required\": [         \"name\",         \"levels\",         \"doors\",         \"wall_graph\",         \"ref_x\",         \"ref_y\",         \"ref_yaw\",         \"width\",         \"depth\"       ]     }   } } ```   ### /doors/{door_name}/state   ``` {   \"title\": \"DoorState\",   \"type\": \"object\",   \"properties\": {     \"door_time\": {       \"title\": \"Door Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"door_name\": {       \"title\": \"Door Name\",       \"default\": \"\",       \"type\": \"string\"     },     \"current_mode\": {       \"title\": \"Current Mode\",       \"default\": {         \"value\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/DoorMode\"         }       ]     }   },   \"required\": [     \"door_time\",     \"door_name\",     \"current_mode\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     },     \"DoorMode\": {       \"title\": \"DoorMode\",       \"type\": \"object\",       \"properties\": {         \"value\": {           \"title\": \"Value\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"value\"       ]     }   } } ```   ### /doors/{door_name}/health   ``` {   \"title\": \"DoorHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /lifts/{lift_name}/state   ``` {   \"title\": \"LiftState\",   \"type\": \"object\",   \"properties\": {     \"lift_time\": {       \"title\": \"Lift Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"lift_name\": {       \"title\": \"Lift Name\",       \"default\": \"\",       \"type\": \"string\"     },     \"available_floors\": {       \"title\": \"Available Floors\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"type\": \"string\"       }     },     \"current_floor\": {       \"title\": \"Current Floor\",       \"default\": \"\",       \"type\": \"string\"     },     \"destination_floor\": {       \"title\": \"Destination Floor\",       \"default\": \"\",       \"type\": \"string\"     },     \"door_state\": {       \"title\": \"Door State\",       \"default\": 0,       \"minimum\": 0,       \"maximum\": 255,       \"type\": \"integer\"     },     \"motion_state\": {       \"title\": \"Motion State\",       \"default\": 0,       \"minimum\": 0,       \"maximum\": 255,       \"type\": \"integer\"     },     \"available_modes\": {       \"title\": \"Available Modes\",       \"type\": \"array\",       \"items\": {         \"type\": \"integer\"       }     },     \"current_mode\": {       \"title\": \"Current Mode\",       \"default\": 0,       \"minimum\": 0,       \"maximum\": 255,       \"type\": \"integer\"     },     \"session_id\": {       \"title\": \"Session Id\",       \"default\": \"\",       \"type\": \"string\"     }   },   \"required\": [     \"lift_time\",     \"lift_name\",     \"available_floors\",     \"current_floor\",     \"destination_floor\",     \"door_state\",     \"motion_state\",     \"available_modes\",     \"current_mode\",     \"session_id\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     }   } } ```   ### /lifts/{lift_name}/health   ``` {   \"title\": \"LiftHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /tasks/{task_id}/state   ``` {   \"title\": \"TaskState\",   \"type\": \"object\",   \"properties\": {     \"booking\": {       \"$ref\": \"#/definitions/Booking\"     },     \"category\": {       \"$ref\": \"#/definitions/Category\"     },     \"detail\": {       \"$ref\": \"#/definitions/Detail\"     },     \"unix_millis_start_time\": {       \"title\": \"Unix Millis Start Time\",       \"type\": \"integer\"     },     \"unix_millis_finish_time\": {       \"title\": \"Unix Millis Finish Time\",       \"type\": \"integer\"     },     \"original_estimate_millis\": {       \"$ref\": \"#/definitions/EstimateMillis\"     },     \"estimate_millis\": {       \"$ref\": \"#/definitions/EstimateMillis\"     },     \"assigned_to\": {       \"title\": \"Assigned To\",       \"description\": \"Which agent (robot) is the task assigned to\",       \"allOf\": [         {           \"$ref\": \"#/definitions/AssignedTo\"         }       ]     },     \"status\": {       \"$ref\": \"#/definitions/Status\"     },     \"dispatch\": {       \"$ref\": \"#/definitions/Dispatch\"     },     \"phases\": {       \"title\": \"Phases\",       \"description\": \"A dictionary of the states of the phases of the task. The keys (property names) are phase IDs, which are integers.\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/Phase\"       }     },     \"completed\": {       \"title\": \"Completed\",       \"description\": \"An array of the IDs of completed phases of this task\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Id\"       }     },     \"active\": {       \"title\": \"Active\",       \"description\": \"The ID of the active phase for this task\",       \"allOf\": [         {           \"$ref\": \"#/definitions/Id\"         }       ]     },     \"pending\": {       \"title\": \"Pending\",       \"description\": \"An array of the pending phases of this task\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Id\"       }     },     \"interruptions\": {       \"title\": \"Interruptions\",       \"description\": \"A dictionary of interruptions that have been applied to this task. The keys (property names) are the unique token of the interruption request.\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/Interruption\"       }     },     \"cancellation\": {       \"title\": \"Cancellation\",       \"description\": \"If the task was cancelled, this will describe information about the request.\",       \"allOf\": [         {           \"$ref\": \"#/definitions/Cancellation\"         }       ]     },     \"killed\": {       \"title\": \"Killed\",       \"description\": \"If the task was killed, this will describe information about the request.\",       \"allOf\": [         {           \"$ref\": \"#/definitions/Killed\"         }       ]     }   },   \"required\": [     \"booking\"   ],   \"definitions\": {     \"Booking\": {       \"title\": \"Booking\",       \"type\": \"object\",       \"properties\": {         \"id\": {           \"title\": \"Id\",           \"description\": \"The unique identifier for this task\",           \"type\": \"string\"         },         \"unix_millis_earliest_start_time\": {           \"title\": \"Unix Millis Earliest Start Time\",           \"type\": \"integer\"         },         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"type\": \"integer\"         },         \"priority\": {           \"title\": \"Priority\",           \"description\": \"Priority information about this task\",           \"anyOf\": [             {               \"type\": \"object\"             },             {               \"type\": \"string\"             }           ]         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Information about how and why this task was booked\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"requester\": {           \"title\": \"Requester\",           \"description\": \"(Optional) An identifier for the entity that requested this task\",           \"type\": \"string\"         }       },       \"required\": [         \"id\"       ]     },     \"Category\": {       \"title\": \"Category\",       \"description\": \"The category of this task or phase\",       \"type\": \"string\"     },     \"Detail\": {       \"title\": \"Detail\",       \"description\": \"Detailed information about a task, phase, or event\",       \"anyOf\": [         {           \"type\": \"object\"         },         {           \"type\": \"array\",           \"items\": {}         },         {           \"type\": \"string\"         }       ]     },     \"EstimateMillis\": {       \"title\": \"EstimateMillis\",       \"description\": \"An estimate, in milliseconds, of how long the subject will take to complete\",       \"minimum\": 0,       \"type\": \"integer\"     },     \"AssignedTo\": {       \"title\": \"AssignedTo\",       \"type\": \"object\",       \"properties\": {         \"group\": {           \"title\": \"Group\",           \"type\": \"string\"         },         \"name\": {           \"title\": \"Name\",           \"type\": \"string\"         }       },       \"required\": [         \"group\",         \"name\"       ]     },     \"Status\": {       \"title\": \"Status\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"blocked\",         \"error\",         \"failed\",         \"queued\",         \"standby\",         \"underway\",         \"delayed\",         \"skipped\",         \"canceled\",         \"killed\",         \"completed\"       ]     },     \"Status1\": {       \"title\": \"Status1\",       \"description\": \"An enumeration.\",       \"enum\": [         \"queued\",         \"selected\",         \"dispatched\",         \"failed_to_assign\",         \"canceled_in_flight\"       ]     },     \"Assignment\": {       \"title\": \"Assignment\",       \"type\": \"object\",       \"properties\": {         \"fleet_name\": {           \"title\": \"Fleet Name\",           \"type\": \"string\"         },         \"expected_robot_name\": {           \"title\": \"Expected Robot Name\",           \"type\": \"string\"         }       }     },     \"Error\": {       \"title\": \"Error\",       \"type\": \"object\",       \"properties\": {         \"code\": {           \"title\": \"Code\",           \"description\": \"A standard code for the kind of error that has occurred\",           \"minimum\": 0,           \"type\": \"integer\"         },         \"category\": {           \"title\": \"Category\",           \"description\": \"The category of the error\",           \"type\": \"string\"         },         \"detail\": {           \"title\": \"Detail\",           \"description\": \"Details about the error\",           \"type\": \"string\"         }       }     },     \"Dispatch\": {       \"title\": \"Dispatch\",       \"type\": \"object\",       \"properties\": {         \"status\": {           \"$ref\": \"#/definitions/Status1\"         },         \"assignment\": {           \"$ref\": \"#/definitions/Assignment\"         },         \"errors\": {           \"title\": \"Errors\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Error\"           }         }       },       \"required\": [         \"status\"       ]     },     \"Id\": {       \"title\": \"Id\",       \"minimum\": 0,       \"type\": \"integer\"     },     \"EventState\": {       \"title\": \"EventState\",       \"type\": \"object\",       \"properties\": {         \"id\": {           \"$ref\": \"#/definitions/Id\"         },         \"status\": {           \"$ref\": \"#/definitions/Status\"         },         \"name\": {           \"title\": \"Name\",           \"description\": \"The brief name of the event\",           \"type\": \"string\"         },         \"detail\": {           \"title\": \"Detail\",           \"description\": \"Detailed information about the event\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Detail\"             }           ]         },         \"deps\": {           \"title\": \"Deps\",           \"description\": \"This event may depend on other events. This array contains the IDs of those other event dependencies.\",           \"type\": \"array\",           \"items\": {             \"type\": \"integer\",             \"minimum\": 0           }         }       },       \"required\": [         \"id\"       ]     },     \"Undo\": {       \"title\": \"Undo\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the undo skip request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the undo skip request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"SkipPhaseRequest\": {       \"title\": \"SkipPhaseRequest\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the skip request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the purpose of the skip request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"undo\": {           \"title\": \"Undo\",           \"description\": \"Information about an undo skip request that applied to this request\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Undo\"             }           ]         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"Phase\": {       \"title\": \"Phase\",       \"type\": \"object\",       \"properties\": {         \"id\": {           \"$ref\": \"#/definitions/Id\"         },         \"category\": {           \"$ref\": \"#/definitions/Category\"         },         \"detail\": {           \"$ref\": \"#/definitions/Detail\"         },         \"unix_millis_start_time\": {           \"title\": \"Unix Millis Start Time\",           \"type\": \"integer\"         },         \"unix_millis_finish_time\": {           \"title\": \"Unix Millis Finish Time\",           \"type\": \"integer\"         },         \"original_estimate_millis\": {           \"$ref\": \"#/definitions/EstimateMillis\"         },         \"estimate_millis\": {           \"$ref\": \"#/definitions/EstimateMillis\"         },         \"final_event_id\": {           \"$ref\": \"#/definitions/Id\"         },         \"events\": {           \"title\": \"Events\",           \"description\": \"A dictionary of events for this phase. The keys (property names) are the event IDs, which are integers.\",           \"type\": \"object\",           \"additionalProperties\": {             \"$ref\": \"#/definitions/EventState\"           }         },         \"skip_requests\": {           \"title\": \"Skip Requests\",           \"description\": \"Information about any skip requests that have been received\",           \"type\": \"object\",           \"additionalProperties\": {             \"$ref\": \"#/definitions/SkipPhaseRequest\"           }         }       },       \"required\": [         \"id\"       ]     },     \"ResumedBy\": {       \"title\": \"ResumedBy\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the resume request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the resume request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"labels\"       ]     },     \"Interruption\": {       \"title\": \"Interruption\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the interruption request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the purpose of the interruption\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"resumed_by\": {           \"title\": \"Resumed By\",           \"description\": \"Information about the resume request that ended this interruption. This field will be missing if the interruption is still active.\",           \"allOf\": [             {               \"$ref\": \"#/definitions/ResumedBy\"             }           ]         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"Cancellation\": {       \"title\": \"Cancellation\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the cancellation request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the cancel request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"Killed\": {       \"title\": \"Killed\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the cancellation request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the kill request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     }   } } ```   ### /tasks/{task_id}/log   ``` {   \"title\": \"TaskEventLog\",   \"type\": \"object\",   \"properties\": {     \"task_id\": {       \"title\": \"Task Id\",       \"type\": \"string\"     },     \"log\": {       \"title\": \"Log\",       \"description\": \"Log entries related to the overall task\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/LogEntry\"       }     },     \"phases\": {       \"title\": \"Phases\",       \"description\": \"A dictionary whose keys (property names) are the indices of a phase\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/Phases\"       }     }   },   \"required\": [     \"task_id\"   ],   \"additionalProperties\": false,   \"definitions\": {     \"Tier\": {       \"title\": \"Tier\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"info\",         \"warning\",         \"error\"       ]     },     \"LogEntry\": {       \"title\": \"LogEntry\",       \"type\": \"object\",       \"properties\": {         \"seq\": {           \"title\": \"Seq\",           \"description\": \"Sequence number for this entry. Each entry has a unique sequence number which monotonically increase, until integer overflow causes a wrap around.\",           \"exclusiveMaximum\": 4294967296,           \"minimum\": 0,           \"type\": \"integer\"         },         \"tier\": {           \"description\": \"The importance level of the log entry\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Tier\"             }           ]         },         \"unix_millis_time\": {           \"title\": \"Unix Millis Time\",           \"type\": \"integer\"         },         \"text\": {           \"title\": \"Text\",           \"description\": \"The text of the log entry\",           \"type\": \"string\"         }       },       \"required\": [         \"seq\",         \"tier\",         \"unix_millis_time\",         \"text\"       ]     },     \"Phases\": {       \"title\": \"Phases\",       \"type\": \"object\",       \"properties\": {         \"log\": {           \"title\": \"Log\",           \"description\": \"Log entries related to the overall phase\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/LogEntry\"           }         },         \"events\": {           \"title\": \"Events\",           \"description\": \"A dictionary whose keys (property names) are the indices of an event in the phase\",           \"type\": \"object\",           \"additionalProperties\": {             \"type\": \"array\",             \"items\": {               \"$ref\": \"#/definitions/LogEntry\"             }           }         }       },       \"additionalProperties\": false     }   } } ```   ### /dispensers/{guid}/state   ``` {   \"title\": \"DispenserState\",   \"type\": \"object\",   \"properties\": {     \"time\": {       \"title\": \"Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"guid\": {       \"title\": \"Guid\",       \"default\": \"\",       \"type\": \"string\"     },     \"mode\": {       \"title\": \"Mode\",       \"default\": 0,       \"minimum\": -2147483648,       \"maximum\": 2147483647,       \"type\": \"integer\"     },     \"request_guid_queue\": {       \"title\": \"Request Guid Queue\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"type\": \"string\"       }     },     \"seconds_remaining\": {       \"title\": \"Seconds Remaining\",       \"default\": 0,       \"type\": \"number\"     }   },   \"required\": [     \"time\",     \"guid\",     \"mode\",     \"request_guid_queue\",     \"seconds_remaining\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     }   } } ```   ### /dispensers/{guid}/health   ``` {   \"title\": \"DispenserHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /ingestors/{guid}/state   ``` {   \"title\": \"IngestorState\",   \"type\": \"object\",   \"properties\": {     \"time\": {       \"title\": \"Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"guid\": {       \"title\": \"Guid\",       \"default\": \"\",       \"type\": \"string\"     },     \"mode\": {       \"title\": \"Mode\",       \"default\": 0,       \"minimum\": -2147483648,       \"maximum\": 2147483647,       \"type\": \"integer\"     },     \"request_guid_queue\": {       \"title\": \"Request Guid Queue\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"type\": \"string\"       }     },     \"seconds_remaining\": {       \"title\": \"Seconds Remaining\",       \"default\": 0,       \"type\": \"number\"     }   },   \"required\": [     \"time\",     \"guid\",     \"mode\",     \"request_guid_queue\",     \"seconds_remaining\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     }   } } ```   ### /ingestors/{guid}/health   ``` {   \"title\": \"IngestorHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /fleets/{name}/state   ``` {   \"title\": \"FleetState\",   \"type\": \"object\",   \"properties\": {     \"name\": {       \"title\": \"Name\",       \"type\": \"string\"     },     \"robots\": {       \"title\": \"Robots\",       \"description\": \"A dictionary of the states of the robots that belong to this fleet\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/RobotState\"       }     }   },   \"definitions\": {     \"Status2\": {       \"title\": \"Status2\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"offline\",         \"shutdown\",         \"idle\",         \"charging\",         \"working\",         \"error\"       ]     },     \"Location2D\": {       \"title\": \"Location2D\",       \"type\": \"object\",       \"properties\": {         \"map\": {           \"title\": \"Map\",           \"type\": \"string\"         },         \"x\": {           \"title\": \"X\",           \"type\": \"number\"         },         \"y\": {           \"title\": \"Y\",           \"type\": \"number\"         },         \"yaw\": {           \"title\": \"Yaw\",           \"type\": \"number\"         }       },       \"required\": [         \"map\",         \"x\",         \"y\",         \"yaw\"       ]     },     \"Issue\": {       \"title\": \"Issue\",       \"type\": \"object\",       \"properties\": {         \"category\": {           \"title\": \"Category\",           \"description\": \"Category of the robot\'s issue\",           \"type\": \"string\"         },         \"detail\": {           \"title\": \"Detail\",           \"description\": \"Detailed information about the issue\",           \"anyOf\": [             {               \"type\": \"object\"             },             {               \"type\": \"array\",               \"items\": {}             },             {               \"type\": \"string\"             }           ]         }       }     },     \"RobotState\": {       \"title\": \"RobotState\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"type\": \"string\"         },         \"status\": {           \"description\": \"A simple token representing the status of the robot\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Status2\"             }           ]         },         \"task_id\": {           \"title\": \"Task Id\",           \"description\": \"The ID of the task this robot is currently working on. Empty string if the robot is not working on a task.\",           \"type\": \"string\"         },         \"unix_millis_time\": {           \"title\": \"Unix Millis Time\",           \"type\": \"integer\"         },         \"location\": {           \"$ref\": \"#/definitions/Location2D\"         },         \"battery\": {           \"title\": \"Battery\",           \"description\": \"State of charge of the battery. Values range from 0.0 (depleted) to 1.0 (fully charged)\",           \"minimum\": 0.0,           \"maximum\": 1.0,           \"type\": \"number\"         },         \"issues\": {           \"title\": \"Issues\",           \"description\": \"A list of issues with the robot that operators need to address\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Issue\"           }         }       }     }   } } ```   ### /fleets/{name}/log   ``` {   \"title\": \"FleetState\",   \"type\": \"object\",   \"properties\": {     \"name\": {       \"title\": \"Name\",       \"type\": \"string\"     },     \"log\": {       \"title\": \"Log\",       \"description\": \"Log for the overall fleet\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/LogEntry\"       }     },     \"robots\": {       \"title\": \"Robots\",       \"description\": \"Dictionary of logs for the individual robots. The keys (property names) are the robot names.\",       \"type\": \"object\",       \"additionalProperties\": {         \"type\": \"array\",         \"items\": {           \"$ref\": \"#/definitions/LogEntry\"         }       }     }   },   \"definitions\": {     \"Tier\": {       \"title\": \"Tier\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"info\",         \"warning\",         \"error\"       ]     },     \"LogEntry\": {       \"title\": \"LogEntry\",       \"type\": \"object\",       \"properties\": {         \"seq\": {           \"title\": \"Seq\",           \"description\": \"Sequence number for this entry. Each entry has a unique sequence number which monotonically increase, until integer overflow causes a wrap around.\",           \"exclusiveMaximum\": 4294967296,           \"minimum\": 0,           \"type\": \"integer\"         },         \"tier\": {           \"description\": \"The importance level of the log entry\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Tier\"             }           ]         },         \"unix_millis_time\": {           \"title\": \"Unix Millis Time\",           \"type\": \"integer\"         },         \"text\": {           \"title\": \"Text\",           \"description\": \"The text of the log entry\",           \"type\": \"string\"         }       },       \"required\": [         \"seq\",         \"tier\",         \"unix_millis_time\",         \"text\"       ]     }   } } ```   ### /scheduler/robot_zone_info   ``` {   \"title\": \"CAGRobotInfo\",   \"type\": \"object\",   \"properties\": {     \"info\": {       \"title\": \"Info\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Fleet\"       }     }   },   \"required\": [     \"info\"   ],   \"definitions\": {     \"CleanAction\": {       \"title\": \"CleanAction\",       \"type\": \"object\",       \"properties\": {         \"clean_action\": {           \"title\": \"Clean Action\",           \"default\": \"\",           \"type\": \"string\"         },         \"duration\": {           \"title\": \"Duration\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 18446744073709551615,           \"type\": \"integer\"         }       },       \"required\": [         \"clean_action\",         \"duration\"       ]     },     \"Zone\": {       \"title\": \"Zone\",       \"type\": \"object\",       \"properties\": {         \"zone_name\": {           \"title\": \"Zone Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"clean_actions\": {           \"title\": \"Clean Actions\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/CleanAction\"           }         }       },       \"required\": [         \"zone_name\",         \"clean_actions\"       ]     },     \"Fleet\": {       \"title\": \"Fleet\",       \"type\": \"object\",       \"properties\": {         \"fleet_name\": {           \"title\": \"Fleet Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"ui_fleet_name\": {           \"title\": \"Ui Fleet Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"ui_robot_names\": {           \"title\": \"Ui Robot Names\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"robots\": {           \"title\": \"Robots\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"zones\": {           \"title\": \"Zones\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Zone\"           }         }       },       \"required\": [         \"fleet_name\",         \"ui_fleet_name\",         \"ui_robot_names\",         \"robots\",         \"zones\"       ]     }   } } ```
         * @summary Socket.io endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lambdaSocketIoGet: function (options) {
            return localVarFp.lambdaSocketIoGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get the effective permissions of the current user
     * @summary Get Effective Permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getEffectivePermissionsPermissionsGet = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration)
            .getEffectivePermissionsPermissionsGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the current rmf time in unix milliseconds
     * @summary Get Time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getTimeTimeGet = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration)
            .getTimeTimeGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the currently logged in user
     * @summary Get User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getUserUserGet = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration)
            .getUserUserGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *  # NOTE: This endpoint is here for documentation purposes only, this is _not_ a REST endpoint.  ## About This exposes a minimal pubsub system built on top of socket.io. It works similar to a normal socket.io endpoint, except that are 2 special rooms which control subscriptions.  ## Rooms ### subscribe Clients must send a message to this room to start receiving messages on other rooms. The message must be of the form:  ``` {     \"room\": \"<room_name>\" } ```  ### unsubscribe Clients can send a message to this room to stop receiving messages on other rooms. The message must be of the form:  ``` {     \"room\": \"<room_name>\" } ```              ### /alerts   ``` {   \"title\": \"Alert\",   \"description\": \"General alert that can be triggered by events.\",   \"type\": \"object\",   \"properties\": {     \"id\": {       \"title\": \"Id\",       \"maxLength\": 255,       \"type\": \"string\"     },     \"original_id\": {       \"title\": \"Original Id\",       \"maxLength\": 255,       \"type\": \"string\"     },     \"category\": {       \"title\": \"Category\",       \"description\": \"Default: default<br/>Task: task<br/>Fleet: fleet<br/>Robot: robot<br/>Maintain: maintain\",       \"maxLength\": 8,       \"type\": \"string\"     },     \"message\": {       \"title\": \"Message\",       \"maxLength\": 500,       \"nullable\": true,       \"type\": \"string\"     },     \"unix_millis_created_time\": {       \"title\": \"Unix Millis Created Time\",       \"minimum\": -9223372036854775808,       \"maximum\": 9223372036854775807,       \"type\": \"integer\"     },     \"acknowledged_by\": {       \"title\": \"Acknowledged By\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"unix_millis_acknowledged_time\": {       \"title\": \"Unix Millis Acknowledged Time\",       \"minimum\": -9223372036854775808,       \"maximum\": 9223372036854775807,       \"nullable\": true,       \"type\": \"integer\"     }   },   \"required\": [     \"id\",     \"original_id\",     \"category\",     \"unix_millis_created_time\"   ],   \"additionalProperties\": false } ```   ### /beacons   ``` {   \"title\": \"BeaconState\",   \"type\": \"object\",   \"properties\": {     \"id\": {       \"title\": \"Id\",       \"maxLength\": 255,       \"type\": \"string\"     },     \"online\": {       \"title\": \"Online\",       \"type\": \"boolean\"     },     \"category\": {       \"title\": \"Category\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"activated\": {       \"title\": \"Activated\",       \"type\": \"boolean\"     },     \"level\": {       \"title\": \"Level\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     }   },   \"required\": [     \"id\",     \"online\",     \"activated\"   ],   \"additionalProperties\": false } ```   ### /building_map   ``` {   \"title\": \"BuildingMap\",   \"type\": \"object\",   \"properties\": {     \"name\": {       \"title\": \"Name\",       \"default\": \"\",       \"type\": \"string\"     },     \"levels\": {       \"title\": \"Levels\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Level\"       }     },     \"lifts\": {       \"title\": \"Lifts\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Lift\"       }     }   },   \"required\": [     \"name\",     \"levels\",     \"lifts\"   ],   \"definitions\": {     \"AffineImage\": {       \"title\": \"AffineImage\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"x_offset\": {           \"title\": \"X Offset\",           \"default\": 0,           \"type\": \"number\"         },         \"y_offset\": {           \"title\": \"Y Offset\",           \"default\": 0,           \"type\": \"number\"         },         \"yaw\": {           \"title\": \"Yaw\",           \"default\": 0,           \"type\": \"number\"         },         \"scale\": {           \"title\": \"Scale\",           \"default\": 0,           \"type\": \"number\"         },         \"encoding\": {           \"title\": \"Encoding\",           \"default\": \"\",           \"type\": \"string\"         },         \"data\": {           \"title\": \"Data\",           \"type\": \"string\"         }       },       \"required\": [         \"name\",         \"x_offset\",         \"y_offset\",         \"yaw\",         \"scale\",         \"encoding\",         \"data\"       ]     },     \"Place\": {       \"title\": \"Place\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"x\": {           \"title\": \"X\",           \"default\": 0,           \"type\": \"number\"         },         \"y\": {           \"title\": \"Y\",           \"default\": 0,           \"type\": \"number\"         },         \"yaw\": {           \"title\": \"Yaw\",           \"default\": 0,           \"type\": \"number\"         },         \"position_tolerance\": {           \"title\": \"Position Tolerance\",           \"default\": 0,           \"type\": \"number\"         },         \"yaw_tolerance\": {           \"title\": \"Yaw Tolerance\",           \"default\": 0,           \"type\": \"number\"         }       },       \"required\": [         \"name\",         \"x\",         \"y\",         \"yaw\",         \"position_tolerance\",         \"yaw_tolerance\"       ]     },     \"Door\": {       \"title\": \"Door\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"v1_x\": {           \"title\": \"V1 X\",           \"default\": 0,           \"type\": \"number\"         },         \"v1_y\": {           \"title\": \"V1 Y\",           \"default\": 0,           \"type\": \"number\"         },         \"v2_x\": {           \"title\": \"V2 X\",           \"default\": 0,           \"type\": \"number\"         },         \"v2_y\": {           \"title\": \"V2 Y\",           \"default\": 0,           \"type\": \"number\"         },         \"door_type\": {           \"title\": \"Door Type\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 255,           \"type\": \"integer\"         },         \"motion_range\": {           \"title\": \"Motion Range\",           \"default\": 0,           \"type\": \"number\"         },         \"motion_direction\": {           \"title\": \"Motion Direction\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         }       },       \"required\": [         \"name\",         \"v1_x\",         \"v1_y\",         \"v2_x\",         \"v2_y\",         \"door_type\",         \"motion_range\",         \"motion_direction\"       ]     },     \"Param\": {       \"title\": \"Param\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"type\": {           \"title\": \"Type\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         },         \"value_int\": {           \"title\": \"Value Int\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"value_float\": {           \"title\": \"Value Float\",           \"default\": 0,           \"type\": \"number\"         },         \"value_string\": {           \"title\": \"Value String\",           \"default\": \"\",           \"type\": \"string\"         },         \"value_bool\": {           \"title\": \"Value Bool\",           \"default\": false,           \"type\": \"boolean\"         }       },       \"required\": [         \"name\",         \"type\",         \"value_int\",         \"value_float\",         \"value_string\",         \"value_bool\"       ]     },     \"GraphNode\": {       \"title\": \"GraphNode\",       \"type\": \"object\",       \"properties\": {         \"x\": {           \"title\": \"X\",           \"default\": 0,           \"type\": \"number\"         },         \"y\": {           \"title\": \"Y\",           \"default\": 0,           \"type\": \"number\"         },         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"params\": {           \"title\": \"Params\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Param\"           }         }       },       \"required\": [         \"x\",         \"y\",         \"name\",         \"params\"       ]     },     \"GraphEdge\": {       \"title\": \"GraphEdge\",       \"type\": \"object\",       \"properties\": {         \"v1_idx\": {           \"title\": \"V1 Idx\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         },         \"v2_idx\": {           \"title\": \"V2 Idx\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         },         \"params\": {           \"title\": \"Params\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Param\"           }         },         \"edge_type\": {           \"title\": \"Edge Type\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 255,           \"type\": \"integer\"         }       },       \"required\": [         \"v1_idx\",         \"v2_idx\",         \"params\",         \"edge_type\"       ]     },     \"Graph\": {       \"title\": \"Graph\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"vertices\": {           \"title\": \"Vertices\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/GraphNode\"           }         },         \"edges\": {           \"title\": \"Edges\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/GraphEdge\"           }         },         \"params\": {           \"title\": \"Params\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Param\"           }         }       },       \"required\": [         \"name\",         \"vertices\",         \"edges\",         \"params\"       ]     },     \"Level\": {       \"title\": \"Level\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"elevation\": {           \"title\": \"Elevation\",           \"default\": 0,           \"type\": \"number\"         },         \"images\": {           \"title\": \"Images\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/AffineImage\"           }         },         \"places\": {           \"title\": \"Places\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Place\"           }         },         \"doors\": {           \"title\": \"Doors\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Door\"           }         },         \"nav_graphs\": {           \"title\": \"Nav Graphs\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Graph\"           }         },         \"wall_graph\": {           \"title\": \"Wall Graph\",           \"default\": {             \"name\": \"\",             \"vertices\": [],             \"edges\": [],             \"params\": []           },           \"allOf\": [             {               \"$ref\": \"#/definitions/Graph\"             }           ]         }       },       \"required\": [         \"name\",         \"elevation\",         \"images\",         \"places\",         \"doors\",         \"nav_graphs\",         \"wall_graph\"       ]     },     \"Lift\": {       \"title\": \"Lift\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"levels\": {           \"title\": \"Levels\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"doors\": {           \"title\": \"Doors\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Door\"           }         },         \"wall_graph\": {           \"title\": \"Wall Graph\",           \"default\": {             \"name\": \"\",             \"vertices\": [],             \"edges\": [],             \"params\": []           },           \"allOf\": [             {               \"$ref\": \"#/definitions/Graph\"             }           ]         },         \"ref_x\": {           \"title\": \"Ref X\",           \"default\": 0,           \"type\": \"number\"         },         \"ref_y\": {           \"title\": \"Ref Y\",           \"default\": 0,           \"type\": \"number\"         },         \"ref_yaw\": {           \"title\": \"Ref Yaw\",           \"default\": 0,           \"type\": \"number\"         },         \"width\": {           \"title\": \"Width\",           \"default\": 0,           \"type\": \"number\"         },         \"depth\": {           \"title\": \"Depth\",           \"default\": 0,           \"type\": \"number\"         }       },       \"required\": [         \"name\",         \"levels\",         \"doors\",         \"wall_graph\",         \"ref_x\",         \"ref_y\",         \"ref_yaw\",         \"width\",         \"depth\"       ]     }   } } ```   ### /doors/{door_name}/state   ``` {   \"title\": \"DoorState\",   \"type\": \"object\",   \"properties\": {     \"door_time\": {       \"title\": \"Door Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"door_name\": {       \"title\": \"Door Name\",       \"default\": \"\",       \"type\": \"string\"     },     \"current_mode\": {       \"title\": \"Current Mode\",       \"default\": {         \"value\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/DoorMode\"         }       ]     }   },   \"required\": [     \"door_time\",     \"door_name\",     \"current_mode\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     },     \"DoorMode\": {       \"title\": \"DoorMode\",       \"type\": \"object\",       \"properties\": {         \"value\": {           \"title\": \"Value\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"value\"       ]     }   } } ```   ### /doors/{door_name}/health   ``` {   \"title\": \"DoorHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /lifts/{lift_name}/state   ``` {   \"title\": \"LiftState\",   \"type\": \"object\",   \"properties\": {     \"lift_time\": {       \"title\": \"Lift Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"lift_name\": {       \"title\": \"Lift Name\",       \"default\": \"\",       \"type\": \"string\"     },     \"available_floors\": {       \"title\": \"Available Floors\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"type\": \"string\"       }     },     \"current_floor\": {       \"title\": \"Current Floor\",       \"default\": \"\",       \"type\": \"string\"     },     \"destination_floor\": {       \"title\": \"Destination Floor\",       \"default\": \"\",       \"type\": \"string\"     },     \"door_state\": {       \"title\": \"Door State\",       \"default\": 0,       \"minimum\": 0,       \"maximum\": 255,       \"type\": \"integer\"     },     \"motion_state\": {       \"title\": \"Motion State\",       \"default\": 0,       \"minimum\": 0,       \"maximum\": 255,       \"type\": \"integer\"     },     \"available_modes\": {       \"title\": \"Available Modes\",       \"type\": \"array\",       \"items\": {         \"type\": \"integer\"       }     },     \"current_mode\": {       \"title\": \"Current Mode\",       \"default\": 0,       \"minimum\": 0,       \"maximum\": 255,       \"type\": \"integer\"     },     \"session_id\": {       \"title\": \"Session Id\",       \"default\": \"\",       \"type\": \"string\"     }   },   \"required\": [     \"lift_time\",     \"lift_name\",     \"available_floors\",     \"current_floor\",     \"destination_floor\",     \"door_state\",     \"motion_state\",     \"available_modes\",     \"current_mode\",     \"session_id\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     }   } } ```   ### /lifts/{lift_name}/health   ``` {   \"title\": \"LiftHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /tasks/{task_id}/state   ``` {   \"title\": \"TaskState\",   \"type\": \"object\",   \"properties\": {     \"booking\": {       \"$ref\": \"#/definitions/Booking\"     },     \"category\": {       \"$ref\": \"#/definitions/Category\"     },     \"detail\": {       \"$ref\": \"#/definitions/Detail\"     },     \"unix_millis_start_time\": {       \"title\": \"Unix Millis Start Time\",       \"type\": \"integer\"     },     \"unix_millis_finish_time\": {       \"title\": \"Unix Millis Finish Time\",       \"type\": \"integer\"     },     \"original_estimate_millis\": {       \"$ref\": \"#/definitions/EstimateMillis\"     },     \"estimate_millis\": {       \"$ref\": \"#/definitions/EstimateMillis\"     },     \"assigned_to\": {       \"title\": \"Assigned To\",       \"description\": \"Which agent (robot) is the task assigned to\",       \"allOf\": [         {           \"$ref\": \"#/definitions/AssignedTo\"         }       ]     },     \"status\": {       \"$ref\": \"#/definitions/Status\"     },     \"dispatch\": {       \"$ref\": \"#/definitions/Dispatch\"     },     \"phases\": {       \"title\": \"Phases\",       \"description\": \"A dictionary of the states of the phases of the task. The keys (property names) are phase IDs, which are integers.\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/Phase\"       }     },     \"completed\": {       \"title\": \"Completed\",       \"description\": \"An array of the IDs of completed phases of this task\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Id\"       }     },     \"active\": {       \"title\": \"Active\",       \"description\": \"The ID of the active phase for this task\",       \"allOf\": [         {           \"$ref\": \"#/definitions/Id\"         }       ]     },     \"pending\": {       \"title\": \"Pending\",       \"description\": \"An array of the pending phases of this task\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Id\"       }     },     \"interruptions\": {       \"title\": \"Interruptions\",       \"description\": \"A dictionary of interruptions that have been applied to this task. The keys (property names) are the unique token of the interruption request.\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/Interruption\"       }     },     \"cancellation\": {       \"title\": \"Cancellation\",       \"description\": \"If the task was cancelled, this will describe information about the request.\",       \"allOf\": [         {           \"$ref\": \"#/definitions/Cancellation\"         }       ]     },     \"killed\": {       \"title\": \"Killed\",       \"description\": \"If the task was killed, this will describe information about the request.\",       \"allOf\": [         {           \"$ref\": \"#/definitions/Killed\"         }       ]     }   },   \"required\": [     \"booking\"   ],   \"definitions\": {     \"Booking\": {       \"title\": \"Booking\",       \"type\": \"object\",       \"properties\": {         \"id\": {           \"title\": \"Id\",           \"description\": \"The unique identifier for this task\",           \"type\": \"string\"         },         \"unix_millis_earliest_start_time\": {           \"title\": \"Unix Millis Earliest Start Time\",           \"type\": \"integer\"         },         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"type\": \"integer\"         },         \"priority\": {           \"title\": \"Priority\",           \"description\": \"Priority information about this task\",           \"anyOf\": [             {               \"type\": \"object\"             },             {               \"type\": \"string\"             }           ]         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Information about how and why this task was booked\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"requester\": {           \"title\": \"Requester\",           \"description\": \"(Optional) An identifier for the entity that requested this task\",           \"type\": \"string\"         }       },       \"required\": [         \"id\"       ]     },     \"Category\": {       \"title\": \"Category\",       \"description\": \"The category of this task or phase\",       \"type\": \"string\"     },     \"Detail\": {       \"title\": \"Detail\",       \"description\": \"Detailed information about a task, phase, or event\",       \"anyOf\": [         {           \"type\": \"object\"         },         {           \"type\": \"array\",           \"items\": {}         },         {           \"type\": \"string\"         }       ]     },     \"EstimateMillis\": {       \"title\": \"EstimateMillis\",       \"description\": \"An estimate, in milliseconds, of how long the subject will take to complete\",       \"minimum\": 0,       \"type\": \"integer\"     },     \"AssignedTo\": {       \"title\": \"AssignedTo\",       \"type\": \"object\",       \"properties\": {         \"group\": {           \"title\": \"Group\",           \"type\": \"string\"         },         \"name\": {           \"title\": \"Name\",           \"type\": \"string\"         }       },       \"required\": [         \"group\",         \"name\"       ]     },     \"Status\": {       \"title\": \"Status\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"blocked\",         \"error\",         \"failed\",         \"queued\",         \"standby\",         \"underway\",         \"delayed\",         \"skipped\",         \"canceled\",         \"killed\",         \"completed\"       ]     },     \"Status1\": {       \"title\": \"Status1\",       \"description\": \"An enumeration.\",       \"enum\": [         \"queued\",         \"selected\",         \"dispatched\",         \"failed_to_assign\",         \"canceled_in_flight\"       ]     },     \"Assignment\": {       \"title\": \"Assignment\",       \"type\": \"object\",       \"properties\": {         \"fleet_name\": {           \"title\": \"Fleet Name\",           \"type\": \"string\"         },         \"expected_robot_name\": {           \"title\": \"Expected Robot Name\",           \"type\": \"string\"         }       }     },     \"Error\": {       \"title\": \"Error\",       \"type\": \"object\",       \"properties\": {         \"code\": {           \"title\": \"Code\",           \"description\": \"A standard code for the kind of error that has occurred\",           \"minimum\": 0,           \"type\": \"integer\"         },         \"category\": {           \"title\": \"Category\",           \"description\": \"The category of the error\",           \"type\": \"string\"         },         \"detail\": {           \"title\": \"Detail\",           \"description\": \"Details about the error\",           \"type\": \"string\"         }       }     },     \"Dispatch\": {       \"title\": \"Dispatch\",       \"type\": \"object\",       \"properties\": {         \"status\": {           \"$ref\": \"#/definitions/Status1\"         },         \"assignment\": {           \"$ref\": \"#/definitions/Assignment\"         },         \"errors\": {           \"title\": \"Errors\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Error\"           }         }       },       \"required\": [         \"status\"       ]     },     \"Id\": {       \"title\": \"Id\",       \"minimum\": 0,       \"type\": \"integer\"     },     \"EventState\": {       \"title\": \"EventState\",       \"type\": \"object\",       \"properties\": {         \"id\": {           \"$ref\": \"#/definitions/Id\"         },         \"status\": {           \"$ref\": \"#/definitions/Status\"         },         \"name\": {           \"title\": \"Name\",           \"description\": \"The brief name of the event\",           \"type\": \"string\"         },         \"detail\": {           \"title\": \"Detail\",           \"description\": \"Detailed information about the event\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Detail\"             }           ]         },         \"deps\": {           \"title\": \"Deps\",           \"description\": \"This event may depend on other events. This array contains the IDs of those other event dependencies.\",           \"type\": \"array\",           \"items\": {             \"type\": \"integer\",             \"minimum\": 0           }         }       },       \"required\": [         \"id\"       ]     },     \"Undo\": {       \"title\": \"Undo\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the undo skip request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the undo skip request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"SkipPhaseRequest\": {       \"title\": \"SkipPhaseRequest\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the skip request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the purpose of the skip request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"undo\": {           \"title\": \"Undo\",           \"description\": \"Information about an undo skip request that applied to this request\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Undo\"             }           ]         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"Phase\": {       \"title\": \"Phase\",       \"type\": \"object\",       \"properties\": {         \"id\": {           \"$ref\": \"#/definitions/Id\"         },         \"category\": {           \"$ref\": \"#/definitions/Category\"         },         \"detail\": {           \"$ref\": \"#/definitions/Detail\"         },         \"unix_millis_start_time\": {           \"title\": \"Unix Millis Start Time\",           \"type\": \"integer\"         },         \"unix_millis_finish_time\": {           \"title\": \"Unix Millis Finish Time\",           \"type\": \"integer\"         },         \"original_estimate_millis\": {           \"$ref\": \"#/definitions/EstimateMillis\"         },         \"estimate_millis\": {           \"$ref\": \"#/definitions/EstimateMillis\"         },         \"final_event_id\": {           \"$ref\": \"#/definitions/Id\"         },         \"events\": {           \"title\": \"Events\",           \"description\": \"A dictionary of events for this phase. The keys (property names) are the event IDs, which are integers.\",           \"type\": \"object\",           \"additionalProperties\": {             \"$ref\": \"#/definitions/EventState\"           }         },         \"skip_requests\": {           \"title\": \"Skip Requests\",           \"description\": \"Information about any skip requests that have been received\",           \"type\": \"object\",           \"additionalProperties\": {             \"$ref\": \"#/definitions/SkipPhaseRequest\"           }         }       },       \"required\": [         \"id\"       ]     },     \"ResumedBy\": {       \"title\": \"ResumedBy\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the resume request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the resume request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"labels\"       ]     },     \"Interruption\": {       \"title\": \"Interruption\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the interruption request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the purpose of the interruption\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"resumed_by\": {           \"title\": \"Resumed By\",           \"description\": \"Information about the resume request that ended this interruption. This field will be missing if the interruption is still active.\",           \"allOf\": [             {               \"$ref\": \"#/definitions/ResumedBy\"             }           ]         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"Cancellation\": {       \"title\": \"Cancellation\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the cancellation request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the cancel request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     },     \"Killed\": {       \"title\": \"Killed\",       \"type\": \"object\",       \"properties\": {         \"unix_millis_request_time\": {           \"title\": \"Unix Millis Request Time\",           \"description\": \"The time that the cancellation request arrived\",           \"type\": \"integer\"         },         \"labels\": {           \"title\": \"Labels\",           \"description\": \"Labels to describe the kill request\",           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         }       },       \"required\": [         \"unix_millis_request_time\",         \"labels\"       ]     }   } } ```   ### /tasks/{task_id}/log   ``` {   \"title\": \"TaskEventLog\",   \"type\": \"object\",   \"properties\": {     \"task_id\": {       \"title\": \"Task Id\",       \"type\": \"string\"     },     \"log\": {       \"title\": \"Log\",       \"description\": \"Log entries related to the overall task\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/LogEntry\"       }     },     \"phases\": {       \"title\": \"Phases\",       \"description\": \"A dictionary whose keys (property names) are the indices of a phase\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/Phases\"       }     }   },   \"required\": [     \"task_id\"   ],   \"additionalProperties\": false,   \"definitions\": {     \"Tier\": {       \"title\": \"Tier\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"info\",         \"warning\",         \"error\"       ]     },     \"LogEntry\": {       \"title\": \"LogEntry\",       \"type\": \"object\",       \"properties\": {         \"seq\": {           \"title\": \"Seq\",           \"description\": \"Sequence number for this entry. Each entry has a unique sequence number which monotonically increase, until integer overflow causes a wrap around.\",           \"exclusiveMaximum\": 4294967296,           \"minimum\": 0,           \"type\": \"integer\"         },         \"tier\": {           \"description\": \"The importance level of the log entry\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Tier\"             }           ]         },         \"unix_millis_time\": {           \"title\": \"Unix Millis Time\",           \"type\": \"integer\"         },         \"text\": {           \"title\": \"Text\",           \"description\": \"The text of the log entry\",           \"type\": \"string\"         }       },       \"required\": [         \"seq\",         \"tier\",         \"unix_millis_time\",         \"text\"       ]     },     \"Phases\": {       \"title\": \"Phases\",       \"type\": \"object\",       \"properties\": {         \"log\": {           \"title\": \"Log\",           \"description\": \"Log entries related to the overall phase\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/LogEntry\"           }         },         \"events\": {           \"title\": \"Events\",           \"description\": \"A dictionary whose keys (property names) are the indices of an event in the phase\",           \"type\": \"object\",           \"additionalProperties\": {             \"type\": \"array\",             \"items\": {               \"$ref\": \"#/definitions/LogEntry\"             }           }         }       },       \"additionalProperties\": false     }   } } ```   ### /dispensers/{guid}/state   ``` {   \"title\": \"DispenserState\",   \"type\": \"object\",   \"properties\": {     \"time\": {       \"title\": \"Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"guid\": {       \"title\": \"Guid\",       \"default\": \"\",       \"type\": \"string\"     },     \"mode\": {       \"title\": \"Mode\",       \"default\": 0,       \"minimum\": -2147483648,       \"maximum\": 2147483647,       \"type\": \"integer\"     },     \"request_guid_queue\": {       \"title\": \"Request Guid Queue\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"type\": \"string\"       }     },     \"seconds_remaining\": {       \"title\": \"Seconds Remaining\",       \"default\": 0,       \"type\": \"number\"     }   },   \"required\": [     \"time\",     \"guid\",     \"mode\",     \"request_guid_queue\",     \"seconds_remaining\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     }   } } ```   ### /dispensers/{guid}/health   ``` {   \"title\": \"DispenserHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /ingestors/{guid}/state   ``` {   \"title\": \"IngestorState\",   \"type\": \"object\",   \"properties\": {     \"time\": {       \"title\": \"Time\",       \"default\": {         \"sec\": 0,         \"nanosec\": 0       },       \"allOf\": [         {           \"$ref\": \"#/definitions/Time\"         }       ]     },     \"guid\": {       \"title\": \"Guid\",       \"default\": \"\",       \"type\": \"string\"     },     \"mode\": {       \"title\": \"Mode\",       \"default\": 0,       \"minimum\": -2147483648,       \"maximum\": 2147483647,       \"type\": \"integer\"     },     \"request_guid_queue\": {       \"title\": \"Request Guid Queue\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"type\": \"string\"       }     },     \"seconds_remaining\": {       \"title\": \"Seconds Remaining\",       \"default\": 0,       \"type\": \"number\"     }   },   \"required\": [     \"time\",     \"guid\",     \"mode\",     \"request_guid_queue\",     \"seconds_remaining\"   ],   \"definitions\": {     \"Time\": {       \"title\": \"Time\",       \"type\": \"object\",       \"properties\": {         \"sec\": {           \"title\": \"Sec\",           \"default\": 0,           \"minimum\": -2147483648,           \"maximum\": 2147483647,           \"type\": \"integer\"         },         \"nanosec\": {           \"title\": \"Nanosec\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 4294967295,           \"type\": \"integer\"         }       },       \"required\": [         \"sec\",         \"nanosec\"       ]     }   } } ```   ### /ingestors/{guid}/health   ``` {   \"title\": \"IngestorHealth\",   \"type\": \"object\",   \"properties\": {     \"health_status\": {       \"title\": \"Health Status\",       \"maxLength\": 255,       \"nullable\": true,       \"type\": \"string\"     },     \"health_message\": {       \"title\": \"Health Message\",       \"nullable\": true,       \"type\": \"string\"     },     \"id_\": {       \"title\": \"Id \",       \"maxLength\": 255,       \"type\": \"string\"     }   },   \"required\": [     \"health_status\",     \"id_\"   ],   \"additionalProperties\": false } ```   ### /fleets/{name}/state   ``` {   \"title\": \"FleetState\",   \"type\": \"object\",   \"properties\": {     \"name\": {       \"title\": \"Name\",       \"type\": \"string\"     },     \"robots\": {       \"title\": \"Robots\",       \"description\": \"A dictionary of the states of the robots that belong to this fleet\",       \"type\": \"object\",       \"additionalProperties\": {         \"$ref\": \"#/definitions/RobotState\"       }     }   },   \"definitions\": {     \"Status2\": {       \"title\": \"Status2\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"offline\",         \"shutdown\",         \"idle\",         \"charging\",         \"working\",         \"error\"       ]     },     \"Location2D\": {       \"title\": \"Location2D\",       \"type\": \"object\",       \"properties\": {         \"map\": {           \"title\": \"Map\",           \"type\": \"string\"         },         \"x\": {           \"title\": \"X\",           \"type\": \"number\"         },         \"y\": {           \"title\": \"Y\",           \"type\": \"number\"         },         \"yaw\": {           \"title\": \"Yaw\",           \"type\": \"number\"         }       },       \"required\": [         \"map\",         \"x\",         \"y\",         \"yaw\"       ]     },     \"Issue\": {       \"title\": \"Issue\",       \"type\": \"object\",       \"properties\": {         \"category\": {           \"title\": \"Category\",           \"description\": \"Category of the robot\'s issue\",           \"type\": \"string\"         },         \"detail\": {           \"title\": \"Detail\",           \"description\": \"Detailed information about the issue\",           \"anyOf\": [             {               \"type\": \"object\"             },             {               \"type\": \"array\",               \"items\": {}             },             {               \"type\": \"string\"             }           ]         }       }     },     \"RobotState\": {       \"title\": \"RobotState\",       \"type\": \"object\",       \"properties\": {         \"name\": {           \"title\": \"Name\",           \"type\": \"string\"         },         \"status\": {           \"description\": \"A simple token representing the status of the robot\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Status2\"             }           ]         },         \"task_id\": {           \"title\": \"Task Id\",           \"description\": \"The ID of the task this robot is currently working on. Empty string if the robot is not working on a task.\",           \"type\": \"string\"         },         \"unix_millis_time\": {           \"title\": \"Unix Millis Time\",           \"type\": \"integer\"         },         \"location\": {           \"$ref\": \"#/definitions/Location2D\"         },         \"battery\": {           \"title\": \"Battery\",           \"description\": \"State of charge of the battery. Values range from 0.0 (depleted) to 1.0 (fully charged)\",           \"minimum\": 0.0,           \"maximum\": 1.0,           \"type\": \"number\"         },         \"issues\": {           \"title\": \"Issues\",           \"description\": \"A list of issues with the robot that operators need to address\",           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Issue\"           }         }       }     }   } } ```   ### /fleets/{name}/log   ``` {   \"title\": \"FleetState\",   \"type\": \"object\",   \"properties\": {     \"name\": {       \"title\": \"Name\",       \"type\": \"string\"     },     \"log\": {       \"title\": \"Log\",       \"description\": \"Log for the overall fleet\",       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/LogEntry\"       }     },     \"robots\": {       \"title\": \"Robots\",       \"description\": \"Dictionary of logs for the individual robots. The keys (property names) are the robot names.\",       \"type\": \"object\",       \"additionalProperties\": {         \"type\": \"array\",         \"items\": {           \"$ref\": \"#/definitions/LogEntry\"         }       }     }   },   \"definitions\": {     \"Tier\": {       \"title\": \"Tier\",       \"description\": \"An enumeration.\",       \"enum\": [         \"uninitialized\",         \"info\",         \"warning\",         \"error\"       ]     },     \"LogEntry\": {       \"title\": \"LogEntry\",       \"type\": \"object\",       \"properties\": {         \"seq\": {           \"title\": \"Seq\",           \"description\": \"Sequence number for this entry. Each entry has a unique sequence number which monotonically increase, until integer overflow causes a wrap around.\",           \"exclusiveMaximum\": 4294967296,           \"minimum\": 0,           \"type\": \"integer\"         },         \"tier\": {           \"description\": \"The importance level of the log entry\",           \"allOf\": [             {               \"$ref\": \"#/definitions/Tier\"             }           ]         },         \"unix_millis_time\": {           \"title\": \"Unix Millis Time\",           \"type\": \"integer\"         },         \"text\": {           \"title\": \"Text\",           \"description\": \"The text of the log entry\",           \"type\": \"string\"         }       },       \"required\": [         \"seq\",         \"tier\",         \"unix_millis_time\",         \"text\"       ]     }   } } ```   ### /scheduler/robot_zone_info   ``` {   \"title\": \"CAGRobotInfo\",   \"type\": \"object\",   \"properties\": {     \"info\": {       \"title\": \"Info\",       \"default\": [],       \"type\": \"array\",       \"items\": {         \"$ref\": \"#/definitions/Fleet\"       }     }   },   \"required\": [     \"info\"   ],   \"definitions\": {     \"CleanAction\": {       \"title\": \"CleanAction\",       \"type\": \"object\",       \"properties\": {         \"clean_action\": {           \"title\": \"Clean Action\",           \"default\": \"\",           \"type\": \"string\"         },         \"duration\": {           \"title\": \"Duration\",           \"default\": 0,           \"minimum\": 0,           \"maximum\": 18446744073709551615,           \"type\": \"integer\"         }       },       \"required\": [         \"clean_action\",         \"duration\"       ]     },     \"Zone\": {       \"title\": \"Zone\",       \"type\": \"object\",       \"properties\": {         \"zone_name\": {           \"title\": \"Zone Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"clean_actions\": {           \"title\": \"Clean Actions\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/CleanAction\"           }         }       },       \"required\": [         \"zone_name\",         \"clean_actions\"       ]     },     \"Fleet\": {       \"title\": \"Fleet\",       \"type\": \"object\",       \"properties\": {         \"fleet_name\": {           \"title\": \"Fleet Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"ui_fleet_name\": {           \"title\": \"Ui Fleet Name\",           \"default\": \"\",           \"type\": \"string\"         },         \"ui_robot_names\": {           \"title\": \"Ui Robot Names\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"robots\": {           \"title\": \"Robots\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"type\": \"string\"           }         },         \"zones\": {           \"title\": \"Zones\",           \"default\": [],           \"type\": \"array\",           \"items\": {             \"$ref\": \"#/definitions/Zone\"           }         }       },       \"required\": [         \"fleet_name\",         \"ui_fleet_name\",         \"ui_robot_names\",         \"robots\",         \"zones\"       ]     }   } } ```
     * @summary Socket.io endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.lambdaSocketIoGet = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration)
            .lambdaSocketIoGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
/**
 * DispensersApi - axios parameter creator
 * @export
 */
var DispensersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Available in socket.io
         * @summary Get Dispenser Health
         * @param {string} guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispenserHealthDispensersGuidHealthGet: function (guid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'guid' is not null or undefined
                    (0, common_1.assertParamExists)('getDispenserHealthDispensersGuidHealthGet', 'guid', guid);
                    localVarPath = "/dispensers/{guid}/health".replace("{" + 'guid' + "}", encodeURIComponent(String(guid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Dispenser State
         * @param {string} guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispenserStateDispensersGuidStateGet: function (guid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'guid' is not null or undefined
                    (0, common_1.assertParamExists)('getDispenserStateDispensersGuidStateGet', 'guid', guid);
                    localVarPath = "/dispensers/{guid}/state".replace("{" + 'guid' + "}", encodeURIComponent(String(guid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Dispensers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensersDispensersGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/dispensers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DispensersApiAxiosParamCreator = DispensersApiAxiosParamCreator;
/**
 * DispensersApi - functional programming interface
 * @export
 */
var DispensersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DispensersApiAxiosParamCreator)(configuration);
    return {
        /**
         * Available in socket.io
         * @summary Get Dispenser Health
         * @param {string} guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispenserHealthDispensersGuidHealthGet: function (guid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispenserHealthDispensersGuidHealthGet(guid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Dispenser State
         * @param {string} guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispenserStateDispensersGuidStateGet: function (guid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispenserStateDispensersGuidStateGet(guid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Dispensers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensersDispensersGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispensersDispensersGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DispensersApiFp = DispensersApiFp;
/**
 * DispensersApi - factory interface
 * @export
 */
var DispensersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DispensersApiFp)(configuration);
    return {
        /**
         * Available in socket.io
         * @summary Get Dispenser Health
         * @param {string} guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispenserHealthDispensersGuidHealthGet: function (guid, options) {
            return localVarFp
                .getDispenserHealthDispensersGuidHealthGet(guid, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Available in socket.io
         * @summary Get Dispenser State
         * @param {string} guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispenserStateDispensersGuidStateGet: function (guid, options) {
            return localVarFp
                .getDispenserStateDispensersGuidStateGet(guid, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Dispensers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispensersDispensersGet: function (options) {
            return localVarFp
                .getDispensersDispensersGet(options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DispensersApiFactory = DispensersApiFactory;
/**
 * DispensersApi - object-oriented interface
 * @export
 * @class DispensersApi
 * @extends {BaseAPI}
 */
var DispensersApi = /** @class */ (function (_super) {
    __extends(DispensersApi, _super);
    function DispensersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Available in socket.io
     * @summary Get Dispenser Health
     * @param {string} guid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispensersApi
     */
    DispensersApi.prototype.getDispenserHealthDispensersGuidHealthGet = function (guid, options) {
        var _this = this;
        return (0, exports.DispensersApiFp)(this.configuration)
            .getDispenserHealthDispensersGuidHealthGet(guid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Available in socket.io
     * @summary Get Dispenser State
     * @param {string} guid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispensersApi
     */
    DispensersApi.prototype.getDispenserStateDispensersGuidStateGet = function (guid, options) {
        var _this = this;
        return (0, exports.DispensersApiFp)(this.configuration)
            .getDispenserStateDispensersGuidStateGet(guid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Dispensers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispensersApi
     */
    DispensersApi.prototype.getDispensersDispensersGet = function (options) {
        var _this = this;
        return (0, exports.DispensersApiFp)(this.configuration)
            .getDispensersDispensersGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DispensersApi;
}(base_1.BaseAPI));
exports.DispensersApi = DispensersApi;
/**
 * DoorsApi - axios parameter creator
 * @export
 */
var DoorsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Available in socket.io
         * @summary Get Door Health
         * @param {string} doorName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDoorHealthDoorsDoorNameHealthGet: function (doorName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'doorName' is not null or undefined
                    (0, common_1.assertParamExists)('getDoorHealthDoorsDoorNameHealthGet', 'doorName', doorName);
                    localVarPath = "/doors/{door_name}/health".replace("{" + 'door_name' + "}", encodeURIComponent(String(doorName)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Door State
         * @param {string} doorName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDoorStateDoorsDoorNameStateGet: function (doorName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'doorName' is not null or undefined
                    (0, common_1.assertParamExists)('getDoorStateDoorsDoorNameStateGet', 'doorName', doorName);
                    localVarPath = "/doors/{door_name}/state".replace("{" + 'door_name' + "}", encodeURIComponent(String(doorName)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Doors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDoorsDoorsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/doors";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post Door Request
         * @param {string} doorName
         * @param {DoorRequest} doorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDoorRequestDoorsDoorNameRequestPost: function (doorName, doorRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'doorName' is not null or undefined
                    (0, common_1.assertParamExists)('postDoorRequestDoorsDoorNameRequestPost', 'doorName', doorName);
                    // verify required parameter 'doorRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postDoorRequestDoorsDoorNameRequestPost', 'doorRequest', doorRequest);
                    localVarPath = "/doors/{door_name}/request".replace("{" + 'door_name' + "}", encodeURIComponent(String(doorName)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(doorRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DoorsApiAxiosParamCreator = DoorsApiAxiosParamCreator;
/**
 * DoorsApi - functional programming interface
 * @export
 */
var DoorsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DoorsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Available in socket.io
         * @summary Get Door Health
         * @param {string} doorName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDoorHealthDoorsDoorNameHealthGet: function (doorName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDoorHealthDoorsDoorNameHealthGet(doorName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Door State
         * @param {string} doorName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDoorStateDoorsDoorNameStateGet: function (doorName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDoorStateDoorsDoorNameStateGet(doorName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Doors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDoorsDoorsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDoorsDoorsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Door Request
         * @param {string} doorName
         * @param {DoorRequest} doorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDoorRequestDoorsDoorNameRequestPost: function (doorName, doorRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postDoorRequestDoorsDoorNameRequestPost(doorName, doorRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DoorsApiFp = DoorsApiFp;
/**
 * DoorsApi - factory interface
 * @export
 */
var DoorsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DoorsApiFp)(configuration);
    return {
        /**
         * Available in socket.io
         * @summary Get Door Health
         * @param {string} doorName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDoorHealthDoorsDoorNameHealthGet: function (doorName, options) {
            return localVarFp
                .getDoorHealthDoorsDoorNameHealthGet(doorName, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Available in socket.io
         * @summary Get Door State
         * @param {string} doorName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDoorStateDoorsDoorNameStateGet: function (doorName, options) {
            return localVarFp
                .getDoorStateDoorsDoorNameStateGet(doorName, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Doors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDoorsDoorsGet: function (options) {
            return localVarFp.getDoorsDoorsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Door Request
         * @param {string} doorName
         * @param {DoorRequest} doorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDoorRequestDoorsDoorNameRequestPost: function (doorName, doorRequest, options) {
            return localVarFp
                .postDoorRequestDoorsDoorNameRequestPost(doorName, doorRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DoorsApiFactory = DoorsApiFactory;
/**
 * DoorsApi - object-oriented interface
 * @export
 * @class DoorsApi
 * @extends {BaseAPI}
 */
var DoorsApi = /** @class */ (function (_super) {
    __extends(DoorsApi, _super);
    function DoorsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Available in socket.io
     * @summary Get Door Health
     * @param {string} doorName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoorsApi
     */
    DoorsApi.prototype.getDoorHealthDoorsDoorNameHealthGet = function (doorName, options) {
        var _this = this;
        return (0, exports.DoorsApiFp)(this.configuration)
            .getDoorHealthDoorsDoorNameHealthGet(doorName, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Available in socket.io
     * @summary Get Door State
     * @param {string} doorName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoorsApi
     */
    DoorsApi.prototype.getDoorStateDoorsDoorNameStateGet = function (doorName, options) {
        var _this = this;
        return (0, exports.DoorsApiFp)(this.configuration)
            .getDoorStateDoorsDoorNameStateGet(doorName, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Doors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoorsApi
     */
    DoorsApi.prototype.getDoorsDoorsGet = function (options) {
        var _this = this;
        return (0, exports.DoorsApiFp)(this.configuration)
            .getDoorsDoorsGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Door Request
     * @param {string} doorName
     * @param {DoorRequest} doorRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoorsApi
     */
    DoorsApi.prototype.postDoorRequestDoorsDoorNameRequestPost = function (doorName, doorRequest, options) {
        var _this = this;
        return (0, exports.DoorsApiFp)(this.configuration)
            .postDoorRequestDoorsDoorNameRequestPost(doorName, doorRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DoorsApi;
}(base_1.BaseAPI));
exports.DoorsApi = DoorsApi;
/**
 * FleetsApi - axios parameter creator
 * @export
 */
var FleetsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Available in socket.io
         * @summary Get Fleet Log
         * @param {string} name
         * @param {string} [between]          The period of time to fetch, in unix millis.          This can be either a comma separated string or a string prefixed with \&#39;-\&#39; to fetch the last X millis.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.             \&quot;-60000\&quot; - Fetches logs in the last minute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetLogFleetsNameLogGet: function (name, between, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'name' is not null or undefined
                    (0, common_1.assertParamExists)('getFleetLogFleetsNameLogGet', 'name', name);
                    localVarPath = "/fleets/{name}/log".replace("{" + 'name' + "}", encodeURIComponent(String(name)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (between !== undefined) {
                        localVarQueryParameter['between'] = between;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Fleet State
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetStateFleetsNameStateGet: function (name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'name' is not null or undefined
                    (0, common_1.assertParamExists)('getFleetStateFleetsNameStateGet', 'name', name);
                    localVarPath = "/fleets/{name}/state".replace("{" + 'name' + "}", encodeURIComponent(String(name)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Fleets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetsFleetsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleets";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FleetsApiAxiosParamCreator = FleetsApiAxiosParamCreator;
/**
 * FleetsApi - functional programming interface
 * @export
 */
var FleetsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FleetsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Available in socket.io
         * @summary Get Fleet Log
         * @param {string} name
         * @param {string} [between]          The period of time to fetch, in unix millis.          This can be either a comma separated string or a string prefixed with \&#39;-\&#39; to fetch the last X millis.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.             \&quot;-60000\&quot; - Fetches logs in the last minute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetLogFleetsNameLogGet: function (name, between, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetLogFleetsNameLogGet(name, between, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Fleet State
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetStateFleetsNameStateGet: function (name, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetStateFleetsNameStateGet(name, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Fleets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetsFleetsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFleetsFleetsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FleetsApiFp = FleetsApiFp;
/**
 * FleetsApi - factory interface
 * @export
 */
var FleetsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FleetsApiFp)(configuration);
    return {
        /**
         * Available in socket.io
         * @summary Get Fleet Log
         * @param {string} name
         * @param {string} [between]          The period of time to fetch, in unix millis.          This can be either a comma separated string or a string prefixed with \&#39;-\&#39; to fetch the last X millis.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.             \&quot;-60000\&quot; - Fetches logs in the last minute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetLogFleetsNameLogGet: function (name, between, options) {
            return localVarFp
                .getFleetLogFleetsNameLogGet(name, between, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Available in socket.io
         * @summary Get Fleet State
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetStateFleetsNameStateGet: function (name, options) {
            return localVarFp
                .getFleetStateFleetsNameStateGet(name, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Fleets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetsFleetsGet: function (options) {
            return localVarFp.getFleetsFleetsGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FleetsApiFactory = FleetsApiFactory;
/**
 * FleetsApi - object-oriented interface
 * @export
 * @class FleetsApi
 * @extends {BaseAPI}
 */
var FleetsApi = /** @class */ (function (_super) {
    __extends(FleetsApi, _super);
    function FleetsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Available in socket.io
     * @summary Get Fleet Log
     * @param {string} name
     * @param {string} [between]          The period of time to fetch, in unix millis.          This can be either a comma separated string or a string prefixed with \&#39;-\&#39; to fetch the last X millis.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.             \&quot;-60000\&quot; - Fetches logs in the last minute.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetsApi
     */
    FleetsApi.prototype.getFleetLogFleetsNameLogGet = function (name, between, options) {
        var _this = this;
        return (0, exports.FleetsApiFp)(this.configuration)
            .getFleetLogFleetsNameLogGet(name, between, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Available in socket.io
     * @summary Get Fleet State
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetsApi
     */
    FleetsApi.prototype.getFleetStateFleetsNameStateGet = function (name, options) {
        var _this = this;
        return (0, exports.FleetsApiFp)(this.configuration)
            .getFleetStateFleetsNameStateGet(name, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Fleets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetsApi
     */
    FleetsApi.prototype.getFleetsFleetsGet = function (options) {
        var _this = this;
        return (0, exports.FleetsApiFp)(this.configuration)
            .getFleetsFleetsGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FleetsApi;
}(base_1.BaseAPI));
exports.FleetsApi = FleetsApi;
/**
 * IngestorsApi - axios parameter creator
 * @export
 */
var IngestorsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Available in socket.io
         * @summary Get Ingestor Health
         * @param {string} guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIngestorHealthIngestorsGuidHealthGet: function (guid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'guid' is not null or undefined
                    (0, common_1.assertParamExists)('getIngestorHealthIngestorsGuidHealthGet', 'guid', guid);
                    localVarPath = "/ingestors/{guid}/health".replace("{" + 'guid' + "}", encodeURIComponent(String(guid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Ingestor State
         * @param {string} guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIngestorStateIngestorsGuidStateGet: function (guid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'guid' is not null or undefined
                    (0, common_1.assertParamExists)('getIngestorStateIngestorsGuidStateGet', 'guid', guid);
                    localVarPath = "/ingestors/{guid}/state".replace("{" + 'guid' + "}", encodeURIComponent(String(guid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Ingestors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIngestorsIngestorsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ingestors";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.IngestorsApiAxiosParamCreator = IngestorsApiAxiosParamCreator;
/**
 * IngestorsApi - functional programming interface
 * @export
 */
var IngestorsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.IngestorsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Available in socket.io
         * @summary Get Ingestor Health
         * @param {string} guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIngestorHealthIngestorsGuidHealthGet: function (guid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getIngestorHealthIngestorsGuidHealthGet(guid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Ingestor State
         * @param {string} guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIngestorStateIngestorsGuidStateGet: function (guid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getIngestorStateIngestorsGuidStateGet(guid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Ingestors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIngestorsIngestorsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getIngestorsIngestorsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.IngestorsApiFp = IngestorsApiFp;
/**
 * IngestorsApi - factory interface
 * @export
 */
var IngestorsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.IngestorsApiFp)(configuration);
    return {
        /**
         * Available in socket.io
         * @summary Get Ingestor Health
         * @param {string} guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIngestorHealthIngestorsGuidHealthGet: function (guid, options) {
            return localVarFp
                .getIngestorHealthIngestorsGuidHealthGet(guid, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Available in socket.io
         * @summary Get Ingestor State
         * @param {string} guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIngestorStateIngestorsGuidStateGet: function (guid, options) {
            return localVarFp
                .getIngestorStateIngestorsGuidStateGet(guid, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Ingestors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIngestorsIngestorsGet: function (options) {
            return localVarFp
                .getIngestorsIngestorsGet(options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.IngestorsApiFactory = IngestorsApiFactory;
/**
 * IngestorsApi - object-oriented interface
 * @export
 * @class IngestorsApi
 * @extends {BaseAPI}
 */
var IngestorsApi = /** @class */ (function (_super) {
    __extends(IngestorsApi, _super);
    function IngestorsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Available in socket.io
     * @summary Get Ingestor Health
     * @param {string} guid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestorsApi
     */
    IngestorsApi.prototype.getIngestorHealthIngestorsGuidHealthGet = function (guid, options) {
        var _this = this;
        return (0, exports.IngestorsApiFp)(this.configuration)
            .getIngestorHealthIngestorsGuidHealthGet(guid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Available in socket.io
     * @summary Get Ingestor State
     * @param {string} guid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestorsApi
     */
    IngestorsApi.prototype.getIngestorStateIngestorsGuidStateGet = function (guid, options) {
        var _this = this;
        return (0, exports.IngestorsApiFp)(this.configuration)
            .getIngestorStateIngestorsGuidStateGet(guid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Ingestors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestorsApi
     */
    IngestorsApi.prototype.getIngestorsIngestorsGet = function (options) {
        var _this = this;
        return (0, exports.IngestorsApiFp)(this.configuration)
            .getIngestorsIngestorsGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return IngestorsApi;
}(base_1.BaseAPI));
exports.IngestorsApi = IngestorsApi;
/**
 * LiftsApi - axios parameter creator
 * @export
 */
var LiftsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Available in socket.io
         * @summary Get Lift Health
         * @param {string} liftName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiftHealthLiftsLiftNameHealthGet: function (liftName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'liftName' is not null or undefined
                    (0, common_1.assertParamExists)('getLiftHealthLiftsLiftNameHealthGet', 'liftName', liftName);
                    localVarPath = "/lifts/{lift_name}/health".replace("{" + 'lift_name' + "}", encodeURIComponent(String(liftName)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Lift State
         * @param {string} liftName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiftStateLiftsLiftNameStateGet: function (liftName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'liftName' is not null or undefined
                    (0, common_1.assertParamExists)('getLiftStateLiftsLiftNameStateGet', 'liftName', liftName);
                    localVarPath = "/lifts/{lift_name}/state".replace("{" + 'lift_name' + "}", encodeURIComponent(String(liftName)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Lifts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiftsLiftsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/lifts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary  Post Lift Request
         * @param {string} liftName
         * @param {LiftRequest} liftRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLiftRequestLiftsLiftNameRequestPost: function (liftName, liftRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'liftName' is not null or undefined
                    (0, common_1.assertParamExists)('postLiftRequestLiftsLiftNameRequestPost', 'liftName', liftName);
                    // verify required parameter 'liftRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postLiftRequestLiftsLiftNameRequestPost', 'liftRequest', liftRequest);
                    localVarPath = "/lifts/{lift_name}/request".replace("{" + 'lift_name' + "}", encodeURIComponent(String(liftName)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(liftRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.LiftsApiAxiosParamCreator = LiftsApiAxiosParamCreator;
/**
 * LiftsApi - functional programming interface
 * @export
 */
var LiftsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LiftsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Available in socket.io
         * @summary Get Lift Health
         * @param {string} liftName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiftHealthLiftsLiftNameHealthGet: function (liftName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLiftHealthLiftsLiftNameHealthGet(liftName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Lift State
         * @param {string} liftName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiftStateLiftsLiftNameStateGet: function (liftName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLiftStateLiftsLiftNameStateGet(liftName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Lifts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiftsLiftsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLiftsLiftsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary  Post Lift Request
         * @param {string} liftName
         * @param {LiftRequest} liftRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLiftRequestLiftsLiftNameRequestPost: function (liftName, liftRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postLiftRequestLiftsLiftNameRequestPost(liftName, liftRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LiftsApiFp = LiftsApiFp;
/**
 * LiftsApi - factory interface
 * @export
 */
var LiftsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LiftsApiFp)(configuration);
    return {
        /**
         * Available in socket.io
         * @summary Get Lift Health
         * @param {string} liftName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiftHealthLiftsLiftNameHealthGet: function (liftName, options) {
            return localVarFp
                .getLiftHealthLiftsLiftNameHealthGet(liftName, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Available in socket.io
         * @summary Get Lift State
         * @param {string} liftName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiftStateLiftsLiftNameStateGet: function (liftName, options) {
            return localVarFp
                .getLiftStateLiftsLiftNameStateGet(liftName, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Lifts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiftsLiftsGet: function (options) {
            return localVarFp.getLiftsLiftsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary  Post Lift Request
         * @param {string} liftName
         * @param {LiftRequest} liftRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLiftRequestLiftsLiftNameRequestPost: function (liftName, liftRequest, options) {
            return localVarFp
                .postLiftRequestLiftsLiftNameRequestPost(liftName, liftRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LiftsApiFactory = LiftsApiFactory;
/**
 * LiftsApi - object-oriented interface
 * @export
 * @class LiftsApi
 * @extends {BaseAPI}
 */
var LiftsApi = /** @class */ (function (_super) {
    __extends(LiftsApi, _super);
    function LiftsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Available in socket.io
     * @summary Get Lift Health
     * @param {string} liftName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiftsApi
     */
    LiftsApi.prototype.getLiftHealthLiftsLiftNameHealthGet = function (liftName, options) {
        var _this = this;
        return (0, exports.LiftsApiFp)(this.configuration)
            .getLiftHealthLiftsLiftNameHealthGet(liftName, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Available in socket.io
     * @summary Get Lift State
     * @param {string} liftName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiftsApi
     */
    LiftsApi.prototype.getLiftStateLiftsLiftNameStateGet = function (liftName, options) {
        var _this = this;
        return (0, exports.LiftsApiFp)(this.configuration)
            .getLiftStateLiftsLiftNameStateGet(liftName, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Lifts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiftsApi
     */
    LiftsApi.prototype.getLiftsLiftsGet = function (options) {
        var _this = this;
        return (0, exports.LiftsApiFp)(this.configuration)
            .getLiftsLiftsGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary  Post Lift Request
     * @param {string} liftName
     * @param {LiftRequest} liftRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiftsApi
     */
    LiftsApi.prototype.postLiftRequestLiftsLiftNameRequestPost = function (liftName, liftRequest, options) {
        var _this = this;
        return (0, exports.LiftsApiFp)(this.configuration)
            .postLiftRequestLiftsLiftNameRequestPost(liftName, liftRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LiftsApi;
}(base_1.BaseAPI));
exports.LiftsApi = LiftsApi;
/**
 * NotificationApi - axios parameter creator
 * @export
 */
var NotificationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * API to add new notifications based on message provided
         * @summary Add Notification
         * @param {string} message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNotificationNotificationTelegramPost: function (message, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'message' is not null or undefined
                    (0, common_1.assertParamExists)('addNotificationNotificationTelegramPost', 'message', message);
                    localVarPath = "/notification/telegram";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (message !== undefined) {
                        localVarQueryParameter['message'] = message;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * API to create new OTP
         * @summary Add Otp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOtpNotificationOtpPost: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/notification/otp";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * API to add participant based on participant_id and full_name provided
         * @summary Add Participant
         * @param {string} participantId
         * @param {string} fullName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParticipantNotificationParticipantPost: function (participantId, fullName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'participantId' is not null or undefined
                    (0, common_1.assertParamExists)('addParticipantNotificationParticipantPost', 'participantId', participantId);
                    // verify required parameter 'fullName' is not null or undefined
                    (0, common_1.assertParamExists)('addParticipantNotificationParticipantPost', 'fullName', fullName);
                    localVarPath = "/notification/participant";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (participantId !== undefined) {
                        localVarQueryParameter['participant_id'] = participantId;
                    }
                    if (fullName !== undefined) {
                        localVarQueryParameter['full_name'] = fullName;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * API to validate provided OTP and further invalidate it
         * @summary Find And Validate Otp
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAndValidateOtpNotificationValidateOtpPost: function (code, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'code' is not null or undefined
                    (0, common_1.assertParamExists)('findAndValidateOtpNotificationValidateOtpPost', 'code', code);
                    localVarPath = "/notification/validate_otp";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (code !== undefined) {
                        localVarQueryParameter['code'] = code;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * API to get all notifications
         * @summary Get Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsNotificationTelegramGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/notification/telegram";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * API to get all otp
         * @summary Get Otp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtpNotificationOtpGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/notification/otp";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * API to get all participants
         * @summary Get Participants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantsNotificationParticipantGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/notification/participant";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * API to remove notification based on id provided
         * @summary Remove Notification
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeNotificationNotificationTelegramDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('removeNotificationNotificationTelegramDelete', 'id', id);
                    localVarPath = "/notification/telegram";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * API to remove participants based on provided participant id
         * @summary Remove Participant
         * @param {string} participantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeParticipantNotificationParticipantDelete: function (participantId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'participantId' is not null or undefined
                    (0, common_1.assertParamExists)('removeParticipantNotificationParticipantDelete', 'participantId', participantId);
                    localVarPath = "/notification/participant";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (participantId !== undefined) {
                        localVarQueryParameter['participant_id'] = participantId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.NotificationApiAxiosParamCreator = NotificationApiAxiosParamCreator;
/**
 * NotificationApi - functional programming interface
 * @export
 */
var NotificationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.NotificationApiAxiosParamCreator)(configuration);
    return {
        /**
         * API to add new notifications based on message provided
         * @summary Add Notification
         * @param {string} message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNotificationNotificationTelegramPost: function (message, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addNotificationNotificationTelegramPost(message, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * API to create new OTP
         * @summary Add Otp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOtpNotificationOtpPost: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addOtpNotificationOtpPost(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * API to add participant based on participant_id and full_name provided
         * @summary Add Participant
         * @param {string} participantId
         * @param {string} fullName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParticipantNotificationParticipantPost: function (participantId, fullName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addParticipantNotificationParticipantPost(participantId, fullName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * API to validate provided OTP and further invalidate it
         * @summary Find And Validate Otp
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAndValidateOtpNotificationValidateOtpPost: function (code, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAndValidateOtpNotificationValidateOtpPost(code, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * API to get all notifications
         * @summary Get Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsNotificationTelegramGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getNotificationsNotificationTelegramGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * API to get all otp
         * @summary Get Otp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtpNotificationOtpGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOtpNotificationOtpGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * API to get all participants
         * @summary Get Participants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantsNotificationParticipantGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getParticipantsNotificationParticipantGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * API to remove notification based on id provided
         * @summary Remove Notification
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeNotificationNotificationTelegramDelete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeNotificationNotificationTelegramDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * API to remove participants based on provided participant id
         * @summary Remove Participant
         * @param {string} participantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeParticipantNotificationParticipantDelete: function (participantId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeParticipantNotificationParticipantDelete(participantId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.NotificationApiFp = NotificationApiFp;
/**
 * NotificationApi - factory interface
 * @export
 */
var NotificationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.NotificationApiFp)(configuration);
    return {
        /**
         * API to add new notifications based on message provided
         * @summary Add Notification
         * @param {string} message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNotificationNotificationTelegramPost: function (message, options) {
            return localVarFp
                .addNotificationNotificationTelegramPost(message, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * API to create new OTP
         * @summary Add Otp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOtpNotificationOtpPost: function (options) {
            return localVarFp
                .addOtpNotificationOtpPost(options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * API to add participant based on participant_id and full_name provided
         * @summary Add Participant
         * @param {string} participantId
         * @param {string} fullName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParticipantNotificationParticipantPost: function (participantId, fullName, options) {
            return localVarFp
                .addParticipantNotificationParticipantPost(participantId, fullName, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * API to validate provided OTP and further invalidate it
         * @summary Find And Validate Otp
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAndValidateOtpNotificationValidateOtpPost: function (code, options) {
            return localVarFp
                .findAndValidateOtpNotificationValidateOtpPost(code, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * API to get all notifications
         * @summary Get Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsNotificationTelegramGet: function (options) {
            return localVarFp
                .getNotificationsNotificationTelegramGet(options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * API to get all otp
         * @summary Get Otp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtpNotificationOtpGet: function (options) {
            return localVarFp
                .getOtpNotificationOtpGet(options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * API to get all participants
         * @summary Get Participants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantsNotificationParticipantGet: function (options) {
            return localVarFp
                .getParticipantsNotificationParticipantGet(options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * API to remove notification based on id provided
         * @summary Remove Notification
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeNotificationNotificationTelegramDelete: function (id, options) {
            return localVarFp
                .removeNotificationNotificationTelegramDelete(id, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * API to remove participants based on provided participant id
         * @summary Remove Participant
         * @param {string} participantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeParticipantNotificationParticipantDelete: function (participantId, options) {
            return localVarFp
                .removeParticipantNotificationParticipantDelete(participantId, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.NotificationApiFactory = NotificationApiFactory;
/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
var NotificationApi = /** @class */ (function (_super) {
    __extends(NotificationApi, _super);
    function NotificationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * API to add new notifications based on message provided
     * @summary Add Notification
     * @param {string} message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    NotificationApi.prototype.addNotificationNotificationTelegramPost = function (message, options) {
        var _this = this;
        return (0, exports.NotificationApiFp)(this.configuration)
            .addNotificationNotificationTelegramPost(message, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * API to create new OTP
     * @summary Add Otp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    NotificationApi.prototype.addOtpNotificationOtpPost = function (options) {
        var _this = this;
        return (0, exports.NotificationApiFp)(this.configuration)
            .addOtpNotificationOtpPost(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * API to add participant based on participant_id and full_name provided
     * @summary Add Participant
     * @param {string} participantId
     * @param {string} fullName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    NotificationApi.prototype.addParticipantNotificationParticipantPost = function (participantId, fullName, options) {
        var _this = this;
        return (0, exports.NotificationApiFp)(this.configuration)
            .addParticipantNotificationParticipantPost(participantId, fullName, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * API to validate provided OTP and further invalidate it
     * @summary Find And Validate Otp
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    NotificationApi.prototype.findAndValidateOtpNotificationValidateOtpPost = function (code, options) {
        var _this = this;
        return (0, exports.NotificationApiFp)(this.configuration)
            .findAndValidateOtpNotificationValidateOtpPost(code, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * API to get all notifications
     * @summary Get Notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    NotificationApi.prototype.getNotificationsNotificationTelegramGet = function (options) {
        var _this = this;
        return (0, exports.NotificationApiFp)(this.configuration)
            .getNotificationsNotificationTelegramGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * API to get all otp
     * @summary Get Otp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    NotificationApi.prototype.getOtpNotificationOtpGet = function (options) {
        var _this = this;
        return (0, exports.NotificationApiFp)(this.configuration)
            .getOtpNotificationOtpGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * API to get all participants
     * @summary Get Participants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    NotificationApi.prototype.getParticipantsNotificationParticipantGet = function (options) {
        var _this = this;
        return (0, exports.NotificationApiFp)(this.configuration)
            .getParticipantsNotificationParticipantGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * API to remove notification based on id provided
     * @summary Remove Notification
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    NotificationApi.prototype.removeNotificationNotificationTelegramDelete = function (id, options) {
        var _this = this;
        return (0, exports.NotificationApiFp)(this.configuration)
            .removeNotificationNotificationTelegramDelete(id, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * API to remove participants based on provided participant id
     * @summary Remove Participant
     * @param {string} participantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    NotificationApi.prototype.removeParticipantNotificationParticipantDelete = function (participantId, options) {
        var _this = this;
        return (0, exports.NotificationApiFp)(this.configuration)
            .removeParticipantNotificationParticipantDelete(participantId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return NotificationApi;
}(base_1.BaseAPI));
exports.NotificationApi = NotificationApi;
/**
 * SchedulerApi - axios parameter creator
 * @export
 */
var SchedulerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Add Schedule
         * @param {ScheduleForTaskScheduler} scheduleForTaskScheduler
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScheduleSchedulerScheduleAddPost: function (scheduleForTaskScheduler, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'scheduleForTaskScheduler' is not null or undefined
                    (0, common_1.assertParamExists)('addScheduleSchedulerScheduleAddPost', 'scheduleForTaskScheduler', scheduleForTaskScheduler);
                    localVarPath = "/scheduler/schedule/add";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(scheduleForTaskScheduler, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Cancel Task
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTaskSchedulerCancelPost: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('cancelTaskSchedulerCancelPost', 'id', id);
                    localVarPath = "/scheduler/cancel";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete Schedule
         * @param {DeleteScheduleRequest} deleteScheduleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduleSchedulerScheduleDeleteDelete: function (deleteScheduleRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deleteScheduleRequest' is not null or undefined
                    (0, common_1.assertParamExists)('deleteScheduleSchedulerScheduleDeleteDelete', 'deleteScheduleRequest', deleteScheduleRequest);
                    localVarPath = "/scheduler/schedule/delete";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteScheduleRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Finish Maintenance
         * @param {FinishMaintenance} finishMaintenance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishMaintenanceSchedulerMaintenanceFinishPost: function (finishMaintenance, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'finishMaintenance' is not null or undefined
                    (0, common_1.assertParamExists)('finishMaintenanceSchedulerMaintenanceFinishPost', 'finishMaintenance', finishMaintenance);
                    localVarPath = "/scheduler/maintenance/finish";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(finishMaintenance, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Cag Robot Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCagRobotInfoSchedulerRobotZoneInfoGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/scheduler/robot_zone_info";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Maintenance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceSchedulerMaintenanceGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/scheduler/maintenance";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Schedule
         * @param {number} [startTime]
         * @param {number} [endTime]
         * @param {boolean} [full]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleSchedulerScheduleGet: function (startTime, endTime, full, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/scheduler/schedule";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (startTime !== undefined) {
                        localVarQueryParameter['start_time'] = startTime;
                    }
                    if (endTime !== undefined) {
                        localVarQueryParameter['end_time'] = endTime;
                    }
                    if (full !== undefined) {
                        localVarQueryParameter['full'] = full;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Toggle Pause
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        togglePauseSchedulerTogglePausePost: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('togglePauseSchedulerTogglePausePost', 'id', id);
                    localVarPath = "/scheduler/toggle_pause";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update Event Time
         * @param {UpdateEventTimeRequest} updateEventTimeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventTimeSchedulerScheduleUpdateEventTimePut: function (updateEventTimeRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'updateEventTimeRequest' is not null or undefined
                    (0, common_1.assertParamExists)('updateEventTimeSchedulerScheduleUpdateEventTimePut', 'updateEventTimeRequest', updateEventTimeRequest);
                    localVarPath = "/scheduler/schedule/update_event_time";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateEventTimeRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update Schedule
         * @param {ScheduleForTaskScheduler} scheduleForTaskScheduler
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduleSchedulerScheduleUpdatePut: function (scheduleForTaskScheduler, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'scheduleForTaskScheduler' is not null or undefined
                    (0, common_1.assertParamExists)('updateScheduleSchedulerScheduleUpdatePut', 'scheduleForTaskScheduler', scheduleForTaskScheduler);
                    localVarPath = "/scheduler/schedule/update";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(scheduleForTaskScheduler, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update Series
         * @param {UpdateSeriesRequest} updateSeriesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeriesSchedulerSeriesUpdateSeriesPut: function (updateSeriesRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'updateSeriesRequest' is not null or undefined
                    (0, common_1.assertParamExists)('updateSeriesSchedulerSeriesUpdateSeriesPut', 'updateSeriesRequest', updateSeriesRequest);
                    localVarPath = "/scheduler/series/update_series";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSeriesRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SchedulerApiAxiosParamCreator = SchedulerApiAxiosParamCreator;
/**
 * SchedulerApi - functional programming interface
 * @export
 */
var SchedulerApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SchedulerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Add Schedule
         * @param {ScheduleForTaskScheduler} scheduleForTaskScheduler
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScheduleSchedulerScheduleAddPost: function (scheduleForTaskScheduler, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addScheduleSchedulerScheduleAddPost(scheduleForTaskScheduler, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Cancel Task
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTaskSchedulerCancelPost: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cancelTaskSchedulerCancelPost(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Schedule
         * @param {DeleteScheduleRequest} deleteScheduleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduleSchedulerScheduleDeleteDelete: function (deleteScheduleRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteScheduleSchedulerScheduleDeleteDelete(deleteScheduleRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Finish Maintenance
         * @param {FinishMaintenance} finishMaintenance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishMaintenanceSchedulerMaintenanceFinishPost: function (finishMaintenance, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.finishMaintenanceSchedulerMaintenanceFinishPost(finishMaintenance, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Cag Robot Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCagRobotInfoSchedulerRobotZoneInfoGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCagRobotInfoSchedulerRobotZoneInfoGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Maintenance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceSchedulerMaintenanceGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMaintenanceSchedulerMaintenanceGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Schedule
         * @param {number} [startTime]
         * @param {number} [endTime]
         * @param {boolean} [full]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleSchedulerScheduleGet: function (startTime, endTime, full, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getScheduleSchedulerScheduleGet(startTime, endTime, full, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Toggle Pause
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        togglePauseSchedulerTogglePausePost: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.togglePauseSchedulerTogglePausePost(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Event Time
         * @param {UpdateEventTimeRequest} updateEventTimeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventTimeSchedulerScheduleUpdateEventTimePut: function (updateEventTimeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateEventTimeSchedulerScheduleUpdateEventTimePut(updateEventTimeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Schedule
         * @param {ScheduleForTaskScheduler} scheduleForTaskScheduler
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduleSchedulerScheduleUpdatePut: function (scheduleForTaskScheduler, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateScheduleSchedulerScheduleUpdatePut(scheduleForTaskScheduler, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Series
         * @param {UpdateSeriesRequest} updateSeriesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeriesSchedulerSeriesUpdateSeriesPut: function (updateSeriesRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSeriesSchedulerSeriesUpdateSeriesPut(updateSeriesRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SchedulerApiFp = SchedulerApiFp;
/**
 * SchedulerApi - factory interface
 * @export
 */
var SchedulerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SchedulerApiFp)(configuration);
    return {
        /**
         *
         * @summary Add Schedule
         * @param {ScheduleForTaskScheduler} scheduleForTaskScheduler
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScheduleSchedulerScheduleAddPost: function (scheduleForTaskScheduler, options) {
            return localVarFp
                .addScheduleSchedulerScheduleAddPost(scheduleForTaskScheduler, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Cancel Task
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTaskSchedulerCancelPost: function (id, options) {
            return localVarFp
                .cancelTaskSchedulerCancelPost(id, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Schedule
         * @param {DeleteScheduleRequest} deleteScheduleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduleSchedulerScheduleDeleteDelete: function (deleteScheduleRequest, options) {
            return localVarFp
                .deleteScheduleSchedulerScheduleDeleteDelete(deleteScheduleRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Finish Maintenance
         * @param {FinishMaintenance} finishMaintenance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishMaintenanceSchedulerMaintenanceFinishPost: function (finishMaintenance, options) {
            return localVarFp
                .finishMaintenanceSchedulerMaintenanceFinishPost(finishMaintenance, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Cag Robot Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCagRobotInfoSchedulerRobotZoneInfoGet: function (options) {
            return localVarFp
                .getCagRobotInfoSchedulerRobotZoneInfoGet(options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Maintenance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceSchedulerMaintenanceGet: function (options) {
            return localVarFp
                .getMaintenanceSchedulerMaintenanceGet(options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Schedule
         * @param {number} [startTime]
         * @param {number} [endTime]
         * @param {boolean} [full]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleSchedulerScheduleGet: function (startTime, endTime, full, options) {
            return localVarFp
                .getScheduleSchedulerScheduleGet(startTime, endTime, full, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Toggle Pause
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        togglePauseSchedulerTogglePausePost: function (id, options) {
            return localVarFp
                .togglePauseSchedulerTogglePausePost(id, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Event Time
         * @param {UpdateEventTimeRequest} updateEventTimeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventTimeSchedulerScheduleUpdateEventTimePut: function (updateEventTimeRequest, options) {
            return localVarFp
                .updateEventTimeSchedulerScheduleUpdateEventTimePut(updateEventTimeRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Schedule
         * @param {ScheduleForTaskScheduler} scheduleForTaskScheduler
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduleSchedulerScheduleUpdatePut: function (scheduleForTaskScheduler, options) {
            return localVarFp
                .updateScheduleSchedulerScheduleUpdatePut(scheduleForTaskScheduler, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Series
         * @param {UpdateSeriesRequest} updateSeriesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeriesSchedulerSeriesUpdateSeriesPut: function (updateSeriesRequest, options) {
            return localVarFp
                .updateSeriesSchedulerSeriesUpdateSeriesPut(updateSeriesRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SchedulerApiFactory = SchedulerApiFactory;
/**
 * SchedulerApi - object-oriented interface
 * @export
 * @class SchedulerApi
 * @extends {BaseAPI}
 */
var SchedulerApi = /** @class */ (function (_super) {
    __extends(SchedulerApi, _super);
    function SchedulerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Add Schedule
     * @param {ScheduleForTaskScheduler} scheduleForTaskScheduler
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    SchedulerApi.prototype.addScheduleSchedulerScheduleAddPost = function (scheduleForTaskScheduler, options) {
        var _this = this;
        return (0, exports.SchedulerApiFp)(this.configuration)
            .addScheduleSchedulerScheduleAddPost(scheduleForTaskScheduler, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Cancel Task
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    SchedulerApi.prototype.cancelTaskSchedulerCancelPost = function (id, options) {
        var _this = this;
        return (0, exports.SchedulerApiFp)(this.configuration)
            .cancelTaskSchedulerCancelPost(id, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Schedule
     * @param {DeleteScheduleRequest} deleteScheduleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    SchedulerApi.prototype.deleteScheduleSchedulerScheduleDeleteDelete = function (deleteScheduleRequest, options) {
        var _this = this;
        return (0, exports.SchedulerApiFp)(this.configuration)
            .deleteScheduleSchedulerScheduleDeleteDelete(deleteScheduleRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Finish Maintenance
     * @param {FinishMaintenance} finishMaintenance
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    SchedulerApi.prototype.finishMaintenanceSchedulerMaintenanceFinishPost = function (finishMaintenance, options) {
        var _this = this;
        return (0, exports.SchedulerApiFp)(this.configuration)
            .finishMaintenanceSchedulerMaintenanceFinishPost(finishMaintenance, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Cag Robot Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    SchedulerApi.prototype.getCagRobotInfoSchedulerRobotZoneInfoGet = function (options) {
        var _this = this;
        return (0, exports.SchedulerApiFp)(this.configuration)
            .getCagRobotInfoSchedulerRobotZoneInfoGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Maintenance
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    SchedulerApi.prototype.getMaintenanceSchedulerMaintenanceGet = function (options) {
        var _this = this;
        return (0, exports.SchedulerApiFp)(this.configuration)
            .getMaintenanceSchedulerMaintenanceGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Schedule
     * @param {number} [startTime]
     * @param {number} [endTime]
     * @param {boolean} [full]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    SchedulerApi.prototype.getScheduleSchedulerScheduleGet = function (startTime, endTime, full, options) {
        var _this = this;
        return (0, exports.SchedulerApiFp)(this.configuration)
            .getScheduleSchedulerScheduleGet(startTime, endTime, full, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Toggle Pause
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    SchedulerApi.prototype.togglePauseSchedulerTogglePausePost = function (id, options) {
        var _this = this;
        return (0, exports.SchedulerApiFp)(this.configuration)
            .togglePauseSchedulerTogglePausePost(id, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Event Time
     * @param {UpdateEventTimeRequest} updateEventTimeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    SchedulerApi.prototype.updateEventTimeSchedulerScheduleUpdateEventTimePut = function (updateEventTimeRequest, options) {
        var _this = this;
        return (0, exports.SchedulerApiFp)(this.configuration)
            .updateEventTimeSchedulerScheduleUpdateEventTimePut(updateEventTimeRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Schedule
     * @param {ScheduleForTaskScheduler} scheduleForTaskScheduler
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    SchedulerApi.prototype.updateScheduleSchedulerScheduleUpdatePut = function (scheduleForTaskScheduler, options) {
        var _this = this;
        return (0, exports.SchedulerApiFp)(this.configuration)
            .updateScheduleSchedulerScheduleUpdatePut(scheduleForTaskScheduler, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Series
     * @param {UpdateSeriesRequest} updateSeriesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    SchedulerApi.prototype.updateSeriesSchedulerSeriesUpdateSeriesPut = function (updateSeriesRequest, options) {
        var _this = this;
        return (0, exports.SchedulerApiFp)(this.configuration)
            .updateSeriesSchedulerSeriesUpdateSeriesPut(updateSeriesRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SchedulerApi;
}(base_1.BaseAPI));
exports.SchedulerApi = SchedulerApi;
/**
 * TasksApi - axios parameter creator
 * @export
 */
var TasksApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Del Scheduled Tasks
         * @param {number} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delScheduledTasksScheduledTasksTaskIdDelete: function (taskId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'taskId' is not null or undefined
                    (0, common_1.assertParamExists)('delScheduledTasksScheduledTasksTaskIdDelete', 'taskId', taskId);
                    localVarPath = "/scheduled_tasks/{task_id}".replace("{" + 'task_id' + "}", encodeURIComponent(String(taskId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete Favorite Task
         * @param {string} favoriteTaskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteTaskFavoriteTasksFavoriteTaskIdDelete: function (favoriteTaskId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'favoriteTaskId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteFavoriteTaskFavoriteTasksFavoriteTaskIdDelete', 'favoriteTaskId', favoriteTaskId);
                    localVarPath = "/favorite_tasks/{favorite_task_id}".replace("{" + 'favorite_task_id' + "}", encodeURIComponent(String(favoriteTaskId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Favorites Tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritesTasksFavoriteTasksGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/favorite_tasks";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Scheduled Task
         * @param {number} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledTaskScheduledTasksTaskIdGet: function (taskId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'taskId' is not null or undefined
                    (0, common_1.assertParamExists)('getScheduledTaskScheduledTasksTaskIdGet', 'taskId', taskId);
                    localVarPath = "/scheduled_tasks/{task_id}".replace("{" + 'task_id' + "}", encodeURIComponent(String(taskId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Scheduled Tasks
         * @param {string} startBefore Only return scheduled tasks that start before given timestamp
         * @param {string} untilAfter Only return scheduled tasks that stop after given timestamp
         * @param {number} [limit] defaults to 100
         * @param {number} [offset] defaults to 0
         * @param {string} [orderBy] common separated list of fields to order by, prefix with \&#39;-\&#39; to sort descendingly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledTasksScheduledTasksGet: function (startBefore, untilAfter, limit, offset, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'startBefore' is not null or undefined
                    (0, common_1.assertParamExists)('getScheduledTasksScheduledTasksGet', 'startBefore', startBefore);
                    // verify required parameter 'untilAfter' is not null or undefined
                    (0, common_1.assertParamExists)('getScheduledTasksScheduledTasksGet', 'untilAfter', untilAfter);
                    localVarPath = "/scheduled_tasks";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (startBefore !== undefined) {
                        localVarQueryParameter['start_before'] =
                            startBefore instanceof Date ? startBefore.toISOString() : startBefore;
                    }
                    if (untilAfter !== undefined) {
                        localVarQueryParameter['until_after'] =
                            untilAfter instanceof Date ? untilAfter.toISOString() : untilAfter;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['order_by'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Task Log
         * @param {string} taskId task_id
         * @param {string} [between]          The period of time to fetch, in unix millis.          This can be either a comma separated string or a string prefixed with \&#39;-\&#39; to fetch the last X millis.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.             \&quot;-60000\&quot; - Fetches logs in the last minute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskLogTasksTaskIdLogGet: function (taskId, between, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'taskId' is not null or undefined
                    (0, common_1.assertParamExists)('getTaskLogTasksTaskIdLogGet', 'taskId', taskId);
                    localVarPath = "/tasks/{task_id}/log".replace("{" + 'task_id' + "}", encodeURIComponent(String(taskId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (between !== undefined) {
                        localVarQueryParameter['between'] = between;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Task State
         * @param {string} taskId task_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskStateTasksTaskIdStateGet: function (taskId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'taskId' is not null or undefined
                    (0, common_1.assertParamExists)('getTaskStateTasksTaskIdStateGet', 'taskId', taskId);
                    localVarPath = "/tasks/{task_id}/state".replace("{" + 'task_id' + "}", encodeURIComponent(String(taskId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post Activity Discovery
         * @param {ActivityDiscoveryRequest} activityDiscoveryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postActivityDiscoveryTasksActivityDiscoveryPost: function (activityDiscoveryRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'activityDiscoveryRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postActivityDiscoveryTasksActivityDiscoveryPost', 'activityDiscoveryRequest', activityDiscoveryRequest);
                    localVarPath = "/tasks/activity_discovery";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(activityDiscoveryRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post Cancel Task
         * @param {CancelTaskRequest} cancelTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCancelTaskTasksCancelTaskPost: function (cancelTaskRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'cancelTaskRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postCancelTaskTasksCancelTaskPost', 'cancelTaskRequest', cancelTaskRequest);
                    localVarPath = "/tasks/cancel_task";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cancelTaskRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post Dispatch Task
         * @param {DispatchTaskRequest} dispatchTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDispatchTaskTasksDispatchTaskPost: function (dispatchTaskRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dispatchTaskRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postDispatchTaskTasksDispatchTaskPost', 'dispatchTaskRequest', dispatchTaskRequest);
                    localVarPath = "/tasks/dispatch_task";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dispatchTaskRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post Favorite Task
         * @param {TaskFavoritePydantic} taskFavoritePydantic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFavoriteTaskFavoriteTasksPost: function (taskFavoritePydantic, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'taskFavoritePydantic' is not null or undefined
                    (0, common_1.assertParamExists)('postFavoriteTaskFavoriteTasksPost', 'taskFavoritePydantic', taskFavoritePydantic);
                    localVarPath = "/favorite_tasks";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(taskFavoritePydantic, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post Interrupt Task
         * @param {TaskInterruptionRequest} taskInterruptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInterruptTaskTasksInterruptTaskPost: function (taskInterruptionRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'taskInterruptionRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postInterruptTaskTasksInterruptTaskPost', 'taskInterruptionRequest', taskInterruptionRequest);
                    localVarPath = "/tasks/interrupt_task";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(taskInterruptionRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post Kill Task
         * @param {TaskKillRequest} taskKillRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postKillTaskTasksKillTaskPost: function (taskKillRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'taskKillRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postKillTaskTasksKillTaskPost', 'taskKillRequest', taskKillRequest);
                    localVarPath = "/tasks/kill_task";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(taskKillRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post Resume Task
         * @param {TaskResumeRequest} taskResumeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResumeTaskTasksResumeTaskPost: function (taskResumeRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'taskResumeRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postResumeTaskTasksResumeTaskPost', 'taskResumeRequest', taskResumeRequest);
                    localVarPath = "/tasks/resume_task";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(taskResumeRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post Rewind Task
         * @param {TaskRewindRequest} taskRewindRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRewindTaskTasksRewindTaskPost: function (taskRewindRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'taskRewindRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postRewindTaskTasksRewindTaskPost', 'taskRewindRequest', taskRewindRequest);
                    localVarPath = "/tasks/rewind_task";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(taskRewindRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post Robot Task
         * @param {RobotTaskRequest} robotTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRobotTaskTasksRobotTaskPost: function (robotTaskRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'robotTaskRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postRobotTaskTasksRobotTaskPost', 'robotTaskRequest', robotTaskRequest);
                    localVarPath = "/tasks/robot_task";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(robotTaskRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create a scheduled task. Below are some examples of how the schedules are represented. For more examples, check the docs of the underlying library used [here](https://github.com/dbader/schedule/blob/6eb0b5346b1ce35ece5050e65789fa6e44368175/docs/examples.rst).  | every | to | period | at | description | | - | - | - | - | - | | 10 | - | minutes | - | Every 10 minutes | | - | - | hour | - | Every hour | | - | - | day | 10:30 | Every day at 10:30am | | - | - | monday | - | Every monday | | - | - | wednesday | 13:15 | Every wednesday at 01:15pm | | - | - | minute | :17 | Every 17th sec of a mintue | | 5 | 10 | seconds | - | Every 5-10 seconds (randomly) |
         * @summary Post Scheduled Task
         * @param {PostScheduledTaskRequest} postScheduledTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postScheduledTaskScheduledTasksPost: function (postScheduledTaskRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'postScheduledTaskRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postScheduledTaskScheduledTasksPost', 'postScheduledTaskRequest', postScheduledTaskRequest);
                    localVarPath = "/scheduled_tasks";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postScheduledTaskRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post Skip Phase
         * @param {TaskPhaseSkipRequest} taskPhaseSkipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSkipPhaseTasksSkipPhasePost: function (taskPhaseSkipRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'taskPhaseSkipRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postSkipPhaseTasksSkipPhasePost', 'taskPhaseSkipRequest', taskPhaseSkipRequest);
                    localVarPath = "/tasks/skip_phase";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(taskPhaseSkipRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post Task Discovery
         * @param {TaskDiscoveryRequest} taskDiscoveryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTaskDiscoveryTasksTaskDiscoveryPost: function (taskDiscoveryRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'taskDiscoveryRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postTaskDiscoveryTasksTaskDiscoveryPost', 'taskDiscoveryRequest', taskDiscoveryRequest);
                    localVarPath = "/tasks/task_discovery";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(taskDiscoveryRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Post Undo Skip Phase
         * @param {UndoPhaseSkipRequest} undoPhaseSkipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUndoSkipPhaseTasksUndoSkipPhasePost: function (undoPhaseSkipRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'undoPhaseSkipRequest' is not null or undefined
                    (0, common_1.assertParamExists)('postUndoSkipPhaseTasksUndoSkipPhasePost', 'undoPhaseSkipRequest', undoPhaseSkipRequest);
                    localVarPath = "/tasks/undo_skip_phase";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(undoPhaseSkipRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Query Task States
         * @param {string} [taskId] comma separated list of task ids
         * @param {string} [category] comma separated list of task categories
         * @param {string} [assignedTo] comma separated list of assigned robot names
         * @param {string} [status] comma separated list of statuses
         * @param {string} [startTimeBetween]          The period of starting time to fetch, in unix millis.          This must be a comma separated string, \&#39;X,Y\&#39; to fetch between X millis and Y millis inclusive.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.
         * @param {string} [finishTimeBetween]          The period of finishing time to fetch, in unix millis.          This must be a comma separated string, \&#39;X,Y\&#39; to fetch between X millis and Y millis inclusive.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.             \&quot;-60000\&quot; - Fetches logs in the last minute.
         * @param {number} [limit] defaults to 100
         * @param {number} [offset] defaults to 0
         * @param {string} [orderBy] common separated list of fields to order by, prefix with \&#39;-\&#39; to sort descendingly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryTaskStatesTasksGet: function (taskId, category, assignedTo, status, startTimeBetween, finishTimeBetween, limit, offset, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tasks";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (taskId !== undefined) {
                        localVarQueryParameter['task_id'] = taskId;
                    }
                    if (category !== undefined) {
                        localVarQueryParameter['category'] = category;
                    }
                    if (assignedTo !== undefined) {
                        localVarQueryParameter['assigned_to'] = assignedTo;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (startTimeBetween !== undefined) {
                        localVarQueryParameter['start_time_between'] = startTimeBetween;
                    }
                    if (finishTimeBetween !== undefined) {
                        localVarQueryParameter['finish_time_between'] = finishTimeBetween;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['order_by'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TasksApiAxiosParamCreator = TasksApiAxiosParamCreator;
/**
 * TasksApi - functional programming interface
 * @export
 */
var TasksApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TasksApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Del Scheduled Tasks
         * @param {number} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delScheduledTasksScheduledTasksTaskIdDelete: function (taskId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.delScheduledTasksScheduledTasksTaskIdDelete(taskId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Favorite Task
         * @param {string} favoriteTaskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteTaskFavoriteTasksFavoriteTaskIdDelete: function (favoriteTaskId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFavoriteTaskFavoriteTasksFavoriteTaskIdDelete(favoriteTaskId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Favorites Tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritesTasksFavoriteTasksGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFavoritesTasksFavoriteTasksGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Scheduled Task
         * @param {number} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledTaskScheduledTasksTaskIdGet: function (taskId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getScheduledTaskScheduledTasksTaskIdGet(taskId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Scheduled Tasks
         * @param {string} startBefore Only return scheduled tasks that start before given timestamp
         * @param {string} untilAfter Only return scheduled tasks that stop after given timestamp
         * @param {number} [limit] defaults to 100
         * @param {number} [offset] defaults to 0
         * @param {string} [orderBy] common separated list of fields to order by, prefix with \&#39;-\&#39; to sort descendingly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledTasksScheduledTasksGet: function (startBefore, untilAfter, limit, offset, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getScheduledTasksScheduledTasksGet(startBefore, untilAfter, limit, offset, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Task Log
         * @param {string} taskId task_id
         * @param {string} [between]          The period of time to fetch, in unix millis.          This can be either a comma separated string or a string prefixed with \&#39;-\&#39; to fetch the last X millis.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.             \&quot;-60000\&quot; - Fetches logs in the last minute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskLogTasksTaskIdLogGet: function (taskId, between, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTaskLogTasksTaskIdLogGet(taskId, between, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Available in socket.io
         * @summary Get Task State
         * @param {string} taskId task_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskStateTasksTaskIdStateGet: function (taskId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTaskStateTasksTaskIdStateGet(taskId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Activity Discovery
         * @param {ActivityDiscoveryRequest} activityDiscoveryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postActivityDiscoveryTasksActivityDiscoveryPost: function (activityDiscoveryRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postActivityDiscoveryTasksActivityDiscoveryPost(activityDiscoveryRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Cancel Task
         * @param {CancelTaskRequest} cancelTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCancelTaskTasksCancelTaskPost: function (cancelTaskRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postCancelTaskTasksCancelTaskPost(cancelTaskRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Dispatch Task
         * @param {DispatchTaskRequest} dispatchTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDispatchTaskTasksDispatchTaskPost: function (dispatchTaskRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postDispatchTaskTasksDispatchTaskPost(dispatchTaskRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Favorite Task
         * @param {TaskFavoritePydantic} taskFavoritePydantic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFavoriteTaskFavoriteTasksPost: function (taskFavoritePydantic, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postFavoriteTaskFavoriteTasksPost(taskFavoritePydantic, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Interrupt Task
         * @param {TaskInterruptionRequest} taskInterruptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInterruptTaskTasksInterruptTaskPost: function (taskInterruptionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postInterruptTaskTasksInterruptTaskPost(taskInterruptionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Kill Task
         * @param {TaskKillRequest} taskKillRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postKillTaskTasksKillTaskPost: function (taskKillRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postKillTaskTasksKillTaskPost(taskKillRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Resume Task
         * @param {TaskResumeRequest} taskResumeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResumeTaskTasksResumeTaskPost: function (taskResumeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postResumeTaskTasksResumeTaskPost(taskResumeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Rewind Task
         * @param {TaskRewindRequest} taskRewindRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRewindTaskTasksRewindTaskPost: function (taskRewindRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postRewindTaskTasksRewindTaskPost(taskRewindRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Robot Task
         * @param {RobotTaskRequest} robotTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRobotTaskTasksRobotTaskPost: function (robotTaskRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postRobotTaskTasksRobotTaskPost(robotTaskRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a scheduled task. Below are some examples of how the schedules are represented. For more examples, check the docs of the underlying library used [here](https://github.com/dbader/schedule/blob/6eb0b5346b1ce35ece5050e65789fa6e44368175/docs/examples.rst).  | every | to | period | at | description | | - | - | - | - | - | | 10 | - | minutes | - | Every 10 minutes | | - | - | hour | - | Every hour | | - | - | day | 10:30 | Every day at 10:30am | | - | - | monday | - | Every monday | | - | - | wednesday | 13:15 | Every wednesday at 01:15pm | | - | - | minute | :17 | Every 17th sec of a mintue | | 5 | 10 | seconds | - | Every 5-10 seconds (randomly) |
         * @summary Post Scheduled Task
         * @param {PostScheduledTaskRequest} postScheduledTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postScheduledTaskScheduledTasksPost: function (postScheduledTaskRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postScheduledTaskScheduledTasksPost(postScheduledTaskRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Skip Phase
         * @param {TaskPhaseSkipRequest} taskPhaseSkipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSkipPhaseTasksSkipPhasePost: function (taskPhaseSkipRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postSkipPhaseTasksSkipPhasePost(taskPhaseSkipRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Task Discovery
         * @param {TaskDiscoveryRequest} taskDiscoveryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTaskDiscoveryTasksTaskDiscoveryPost: function (taskDiscoveryRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postTaskDiscoveryTasksTaskDiscoveryPost(taskDiscoveryRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Undo Skip Phase
         * @param {UndoPhaseSkipRequest} undoPhaseSkipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUndoSkipPhaseTasksUndoSkipPhasePost: function (undoPhaseSkipRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postUndoSkipPhaseTasksUndoSkipPhasePost(undoPhaseSkipRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Query Task States
         * @param {string} [taskId] comma separated list of task ids
         * @param {string} [category] comma separated list of task categories
         * @param {string} [assignedTo] comma separated list of assigned robot names
         * @param {string} [status] comma separated list of statuses
         * @param {string} [startTimeBetween]          The period of starting time to fetch, in unix millis.          This must be a comma separated string, \&#39;X,Y\&#39; to fetch between X millis and Y millis inclusive.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.
         * @param {string} [finishTimeBetween]          The period of finishing time to fetch, in unix millis.          This must be a comma separated string, \&#39;X,Y\&#39; to fetch between X millis and Y millis inclusive.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.             \&quot;-60000\&quot; - Fetches logs in the last minute.
         * @param {number} [limit] defaults to 100
         * @param {number} [offset] defaults to 0
         * @param {string} [orderBy] common separated list of fields to order by, prefix with \&#39;-\&#39; to sort descendingly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryTaskStatesTasksGet: function (taskId, category, assignedTo, status, startTimeBetween, finishTimeBetween, limit, offset, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.queryTaskStatesTasksGet(taskId, category, assignedTo, status, startTimeBetween, finishTimeBetween, limit, offset, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TasksApiFp = TasksApiFp;
/**
 * TasksApi - factory interface
 * @export
 */
var TasksApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TasksApiFp)(configuration);
    return {
        /**
         *
         * @summary Del Scheduled Tasks
         * @param {number} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delScheduledTasksScheduledTasksTaskIdDelete: function (taskId, options) {
            return localVarFp
                .delScheduledTasksScheduledTasksTaskIdDelete(taskId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Favorite Task
         * @param {string} favoriteTaskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteTaskFavoriteTasksFavoriteTaskIdDelete: function (favoriteTaskId, options) {
            return localVarFp
                .deleteFavoriteTaskFavoriteTasksFavoriteTaskIdDelete(favoriteTaskId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Favorites Tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritesTasksFavoriteTasksGet: function (options) {
            return localVarFp
                .getFavoritesTasksFavoriteTasksGet(options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Scheduled Task
         * @param {number} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledTaskScheduledTasksTaskIdGet: function (taskId, options) {
            return localVarFp
                .getScheduledTaskScheduledTasksTaskIdGet(taskId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Scheduled Tasks
         * @param {string} startBefore Only return scheduled tasks that start before given timestamp
         * @param {string} untilAfter Only return scheduled tasks that stop after given timestamp
         * @param {number} [limit] defaults to 100
         * @param {number} [offset] defaults to 0
         * @param {string} [orderBy] common separated list of fields to order by, prefix with \&#39;-\&#39; to sort descendingly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledTasksScheduledTasksGet: function (startBefore, untilAfter, limit, offset, orderBy, options) {
            return localVarFp
                .getScheduledTasksScheduledTasksGet(startBefore, untilAfter, limit, offset, orderBy, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Available in socket.io
         * @summary Get Task Log
         * @param {string} taskId task_id
         * @param {string} [between]          The period of time to fetch, in unix millis.          This can be either a comma separated string or a string prefixed with \&#39;-\&#39; to fetch the last X millis.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.             \&quot;-60000\&quot; - Fetches logs in the last minute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskLogTasksTaskIdLogGet: function (taskId, between, options) {
            return localVarFp
                .getTaskLogTasksTaskIdLogGet(taskId, between, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Available in socket.io
         * @summary Get Task State
         * @param {string} taskId task_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskStateTasksTaskIdStateGet: function (taskId, options) {
            return localVarFp
                .getTaskStateTasksTaskIdStateGet(taskId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Activity Discovery
         * @param {ActivityDiscoveryRequest} activityDiscoveryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postActivityDiscoveryTasksActivityDiscoveryPost: function (activityDiscoveryRequest, options) {
            return localVarFp
                .postActivityDiscoveryTasksActivityDiscoveryPost(activityDiscoveryRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Cancel Task
         * @param {CancelTaskRequest} cancelTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCancelTaskTasksCancelTaskPost: function (cancelTaskRequest, options) {
            return localVarFp
                .postCancelTaskTasksCancelTaskPost(cancelTaskRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Dispatch Task
         * @param {DispatchTaskRequest} dispatchTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDispatchTaskTasksDispatchTaskPost: function (dispatchTaskRequest, options) {
            return localVarFp
                .postDispatchTaskTasksDispatchTaskPost(dispatchTaskRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Favorite Task
         * @param {TaskFavoritePydantic} taskFavoritePydantic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFavoriteTaskFavoriteTasksPost: function (taskFavoritePydantic, options) {
            return localVarFp
                .postFavoriteTaskFavoriteTasksPost(taskFavoritePydantic, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Interrupt Task
         * @param {TaskInterruptionRequest} taskInterruptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInterruptTaskTasksInterruptTaskPost: function (taskInterruptionRequest, options) {
            return localVarFp
                .postInterruptTaskTasksInterruptTaskPost(taskInterruptionRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Kill Task
         * @param {TaskKillRequest} taskKillRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postKillTaskTasksKillTaskPost: function (taskKillRequest, options) {
            return localVarFp
                .postKillTaskTasksKillTaskPost(taskKillRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Resume Task
         * @param {TaskResumeRequest} taskResumeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResumeTaskTasksResumeTaskPost: function (taskResumeRequest, options) {
            return localVarFp
                .postResumeTaskTasksResumeTaskPost(taskResumeRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Rewind Task
         * @param {TaskRewindRequest} taskRewindRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRewindTaskTasksRewindTaskPost: function (taskRewindRequest, options) {
            return localVarFp
                .postRewindTaskTasksRewindTaskPost(taskRewindRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Robot Task
         * @param {RobotTaskRequest} robotTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRobotTaskTasksRobotTaskPost: function (robotTaskRequest, options) {
            return localVarFp
                .postRobotTaskTasksRobotTaskPost(robotTaskRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a scheduled task. Below are some examples of how the schedules are represented. For more examples, check the docs of the underlying library used [here](https://github.com/dbader/schedule/blob/6eb0b5346b1ce35ece5050e65789fa6e44368175/docs/examples.rst).  | every | to | period | at | description | | - | - | - | - | - | | 10 | - | minutes | - | Every 10 minutes | | - | - | hour | - | Every hour | | - | - | day | 10:30 | Every day at 10:30am | | - | - | monday | - | Every monday | | - | - | wednesday | 13:15 | Every wednesday at 01:15pm | | - | - | minute | :17 | Every 17th sec of a mintue | | 5 | 10 | seconds | - | Every 5-10 seconds (randomly) |
         * @summary Post Scheduled Task
         * @param {PostScheduledTaskRequest} postScheduledTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postScheduledTaskScheduledTasksPost: function (postScheduledTaskRequest, options) {
            return localVarFp
                .postScheduledTaskScheduledTasksPost(postScheduledTaskRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Skip Phase
         * @param {TaskPhaseSkipRequest} taskPhaseSkipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSkipPhaseTasksSkipPhasePost: function (taskPhaseSkipRequest, options) {
            return localVarFp
                .postSkipPhaseTasksSkipPhasePost(taskPhaseSkipRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Task Discovery
         * @param {TaskDiscoveryRequest} taskDiscoveryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTaskDiscoveryTasksTaskDiscoveryPost: function (taskDiscoveryRequest, options) {
            return localVarFp
                .postTaskDiscoveryTasksTaskDiscoveryPost(taskDiscoveryRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Undo Skip Phase
         * @param {UndoPhaseSkipRequest} undoPhaseSkipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUndoSkipPhaseTasksUndoSkipPhasePost: function (undoPhaseSkipRequest, options) {
            return localVarFp
                .postUndoSkipPhaseTasksUndoSkipPhasePost(undoPhaseSkipRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Query Task States
         * @param {string} [taskId] comma separated list of task ids
         * @param {string} [category] comma separated list of task categories
         * @param {string} [assignedTo] comma separated list of assigned robot names
         * @param {string} [status] comma separated list of statuses
         * @param {string} [startTimeBetween]          The period of starting time to fetch, in unix millis.          This must be a comma separated string, \&#39;X,Y\&#39; to fetch between X millis and Y millis inclusive.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.
         * @param {string} [finishTimeBetween]          The period of finishing time to fetch, in unix millis.          This must be a comma separated string, \&#39;X,Y\&#39; to fetch between X millis and Y millis inclusive.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.             \&quot;-60000\&quot; - Fetches logs in the last minute.
         * @param {number} [limit] defaults to 100
         * @param {number} [offset] defaults to 0
         * @param {string} [orderBy] common separated list of fields to order by, prefix with \&#39;-\&#39; to sort descendingly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryTaskStatesTasksGet: function (taskId, category, assignedTo, status, startTimeBetween, finishTimeBetween, limit, offset, orderBy, options) {
            return localVarFp
                .queryTaskStatesTasksGet(taskId, category, assignedTo, status, startTimeBetween, finishTimeBetween, limit, offset, orderBy, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TasksApiFactory = TasksApiFactory;
/**
 * TasksApi - object-oriented interface
 * @export
 * @class TasksApi
 * @extends {BaseAPI}
 */
var TasksApi = /** @class */ (function (_super) {
    __extends(TasksApi, _super);
    function TasksApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Del Scheduled Tasks
     * @param {number} taskId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.delScheduledTasksScheduledTasksTaskIdDelete = function (taskId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .delScheduledTasksScheduledTasksTaskIdDelete(taskId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Favorite Task
     * @param {string} favoriteTaskId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.deleteFavoriteTaskFavoriteTasksFavoriteTaskIdDelete = function (favoriteTaskId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .deleteFavoriteTaskFavoriteTasksFavoriteTaskIdDelete(favoriteTaskId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Favorites Tasks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.getFavoritesTasksFavoriteTasksGet = function (options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .getFavoritesTasksFavoriteTasksGet(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Scheduled Task
     * @param {number} taskId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.getScheduledTaskScheduledTasksTaskIdGet = function (taskId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .getScheduledTaskScheduledTasksTaskIdGet(taskId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Scheduled Tasks
     * @param {string} startBefore Only return scheduled tasks that start before given timestamp
     * @param {string} untilAfter Only return scheduled tasks that stop after given timestamp
     * @param {number} [limit] defaults to 100
     * @param {number} [offset] defaults to 0
     * @param {string} [orderBy] common separated list of fields to order by, prefix with \&#39;-\&#39; to sort descendingly.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.getScheduledTasksScheduledTasksGet = function (startBefore, untilAfter, limit, offset, orderBy, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .getScheduledTasksScheduledTasksGet(startBefore, untilAfter, limit, offset, orderBy, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Available in socket.io
     * @summary Get Task Log
     * @param {string} taskId task_id
     * @param {string} [between]          The period of time to fetch, in unix millis.          This can be either a comma separated string or a string prefixed with \&#39;-\&#39; to fetch the last X millis.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.             \&quot;-60000\&quot; - Fetches logs in the last minute.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.getTaskLogTasksTaskIdLogGet = function (taskId, between, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .getTaskLogTasksTaskIdLogGet(taskId, between, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Available in socket.io
     * @summary Get Task State
     * @param {string} taskId task_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.getTaskStateTasksTaskIdStateGet = function (taskId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .getTaskStateTasksTaskIdStateGet(taskId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Activity Discovery
     * @param {ActivityDiscoveryRequest} activityDiscoveryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.postActivityDiscoveryTasksActivityDiscoveryPost = function (activityDiscoveryRequest, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .postActivityDiscoveryTasksActivityDiscoveryPost(activityDiscoveryRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Cancel Task
     * @param {CancelTaskRequest} cancelTaskRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.postCancelTaskTasksCancelTaskPost = function (cancelTaskRequest, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .postCancelTaskTasksCancelTaskPost(cancelTaskRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Dispatch Task
     * @param {DispatchTaskRequest} dispatchTaskRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.postDispatchTaskTasksDispatchTaskPost = function (dispatchTaskRequest, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .postDispatchTaskTasksDispatchTaskPost(dispatchTaskRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Favorite Task
     * @param {TaskFavoritePydantic} taskFavoritePydantic
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.postFavoriteTaskFavoriteTasksPost = function (taskFavoritePydantic, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .postFavoriteTaskFavoriteTasksPost(taskFavoritePydantic, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Interrupt Task
     * @param {TaskInterruptionRequest} taskInterruptionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.postInterruptTaskTasksInterruptTaskPost = function (taskInterruptionRequest, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .postInterruptTaskTasksInterruptTaskPost(taskInterruptionRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Kill Task
     * @param {TaskKillRequest} taskKillRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.postKillTaskTasksKillTaskPost = function (taskKillRequest, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .postKillTaskTasksKillTaskPost(taskKillRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Resume Task
     * @param {TaskResumeRequest} taskResumeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.postResumeTaskTasksResumeTaskPost = function (taskResumeRequest, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .postResumeTaskTasksResumeTaskPost(taskResumeRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Rewind Task
     * @param {TaskRewindRequest} taskRewindRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.postRewindTaskTasksRewindTaskPost = function (taskRewindRequest, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .postRewindTaskTasksRewindTaskPost(taskRewindRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Robot Task
     * @param {RobotTaskRequest} robotTaskRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.postRobotTaskTasksRobotTaskPost = function (robotTaskRequest, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .postRobotTaskTasksRobotTaskPost(robotTaskRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a scheduled task. Below are some examples of how the schedules are represented. For more examples, check the docs of the underlying library used [here](https://github.com/dbader/schedule/blob/6eb0b5346b1ce35ece5050e65789fa6e44368175/docs/examples.rst).  | every | to | period | at | description | | - | - | - | - | - | | 10 | - | minutes | - | Every 10 minutes | | - | - | hour | - | Every hour | | - | - | day | 10:30 | Every day at 10:30am | | - | - | monday | - | Every monday | | - | - | wednesday | 13:15 | Every wednesday at 01:15pm | | - | - | minute | :17 | Every 17th sec of a mintue | | 5 | 10 | seconds | - | Every 5-10 seconds (randomly) |
     * @summary Post Scheduled Task
     * @param {PostScheduledTaskRequest} postScheduledTaskRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.postScheduledTaskScheduledTasksPost = function (postScheduledTaskRequest, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .postScheduledTaskScheduledTasksPost(postScheduledTaskRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Skip Phase
     * @param {TaskPhaseSkipRequest} taskPhaseSkipRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.postSkipPhaseTasksSkipPhasePost = function (taskPhaseSkipRequest, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .postSkipPhaseTasksSkipPhasePost(taskPhaseSkipRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Task Discovery
     * @param {TaskDiscoveryRequest} taskDiscoveryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.postTaskDiscoveryTasksTaskDiscoveryPost = function (taskDiscoveryRequest, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .postTaskDiscoveryTasksTaskDiscoveryPost(taskDiscoveryRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Undo Skip Phase
     * @param {UndoPhaseSkipRequest} undoPhaseSkipRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.postUndoSkipPhaseTasksUndoSkipPhasePost = function (undoPhaseSkipRequest, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .postUndoSkipPhaseTasksUndoSkipPhasePost(undoPhaseSkipRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Query Task States
     * @param {string} [taskId] comma separated list of task ids
     * @param {string} [category] comma separated list of task categories
     * @param {string} [assignedTo] comma separated list of assigned robot names
     * @param {string} [status] comma separated list of statuses
     * @param {string} [startTimeBetween]          The period of starting time to fetch, in unix millis.          This must be a comma separated string, \&#39;X,Y\&#39; to fetch between X millis and Y millis inclusive.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.
     * @param {string} [finishTimeBetween]          The period of finishing time to fetch, in unix millis.          This must be a comma separated string, \&#39;X,Y\&#39; to fetch between X millis and Y millis inclusive.          Example:             \&quot;1000,2000\&quot; - Fetches logs between unix millis 1000 and 2000.             \&quot;-60000\&quot; - Fetches logs in the last minute.
     * @param {number} [limit] defaults to 100
     * @param {number} [offset] defaults to 0
     * @param {string} [orderBy] common separated list of fields to order by, prefix with \&#39;-\&#39; to sort descendingly.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.queryTaskStatesTasksGet = function (taskId, category, assignedTo, status, startTimeBetween, finishTimeBetween, limit, offset, orderBy, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration)
            .queryTaskStatesTasksGet(taskId, category, assignedTo, status, startTimeBetween, finishTimeBetween, limit, offset, orderBy, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TasksApi;
}(base_1.BaseAPI));
exports.TasksApi = TasksApi;
